import i18next from 'i18next';
import { initReactI18next, useTranslation, Trans, I18nextProvider } from 'react-i18next';
import * as React from 'react';
import React__default, { useState, useEffect, createContext, useContext, forwardRef, Children, useCallback, useRef, useMemo } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { css as css$1, ThemeProvider } from '@emotion/react';
import { AnimatePresence, m, LazyMotion, domAnimation } from 'framer-motion';
import styled from '@emotion/styled';
import ReactDOM from 'react-dom';

function _mergeNamespaces(n, m) {
  m.forEach(function (e) {
    e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
      if (k !== 'default' && !(k in n)) {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  });
  return Object.freeze(n);
}

const regionCookieName = 'preferred-region';
/**
 * @see https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 for country code
 * @see https://mcoproduct.atlassian.net/browse/WRP1-445 for country/region requirement
 * NOTE region and country are in a one-to-many relationship
 */
const ukCountryList = ['GB', 'GBR'];
const eeaCountryList = [
    //'GB',
    //'GBR',
    'CH',
    'NO',
    'LI',
    'IS',
    'SE',
    'ES',
    'SI',
    'SK',
    'RO',
    'PT',
    'PL',
    'NL',
    'MT',
    'LU',
    'LT',
    'LV',
    // 'IT',
    'IE',
    'HU',
    'GR',
    'DE',
    //  "FR",
    'FI',
    'EE',
    'DK',
    'CZ',
    'CY',
    'HR',
    'BG',
    'BE',
    'AT',
];
var RegionsEnum;
(function (RegionsEnum) {
    RegionsEnum["US"] = "US";
    RegionsEnum["EEA"] = "EEA";
    RegionsEnum["SG"] = "SG";
    RegionsEnum["BR"] = "BR";
    RegionsEnum["AU"] = "AU";
    RegionsEnum["GLOBAL"] = "GLOBAL";
    RegionsEnum["TR"] = "TR";
    RegionsEnum["FR"] = "FR";
    RegionsEnum["CA"] = "CA";
    RegionsEnum["IT"] = "IT";
    RegionsEnum["KR"] = "KR";
    RegionsEnum["UK"] = "UK";
})(RegionsEnum || (RegionsEnum = {}));
const navAvailRegions = [
    RegionsEnum.US,
    RegionsEnum.EEA,
    RegionsEnum.SG,
    RegionsEnum.BR,
    RegionsEnum.AU,
    RegionsEnum.TR,
    RegionsEnum.FR,
    RegionsEnum.CA,
    RegionsEnum.IT,
    //  RegionsEnum.KR,
    RegionsEnum.UK,
    RegionsEnum.GLOBAL,
];

var Site;
(function (Site) {
    Site[Site["MKT"] = 0] = "MKT";
    Site[Site["CHUB"] = 1] = "CHUB";
    Site[Site["GLOSSARY"] = 2] = "GLOSSARY";
})(Site || (Site = {}));

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
var arr = [];
var each = arr.forEach;
var slice$1 = arr.slice;
function defaults$7(obj) {
  each.call(slice$1.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof$2(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

var global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var getFetch$1 = {exports: {}};

var browserPonyfill = {exports: {}};

var hasRequiredBrowserPonyfill;

function requireBrowserPonyfill () {
	if (hasRequiredBrowserPonyfill) return browserPonyfill.exports;
	hasRequiredBrowserPonyfill = 1;
	(function (module, exports) {
		var global = typeof self !== 'undefined' ? self : commonjsGlobal;
		var __self__ = (function () {
		function F() {
		this.fetch = false;
		this.DOMException = global.DOMException;
		}
		F.prototype = global;
		return new F();
		})();
		(function(self) {

		((function (exports) {

		  var support = {
		    searchParams: 'URLSearchParams' in self,
		    iterable: 'Symbol' in self && 'iterator' in Symbol,
		    blob:
		      'FileReader' in self &&
		      'Blob' in self &&
		      (function() {
		        try {
		          new Blob();
		          return true
		        } catch (e) {
		          return false
		        }
		      })(),
		    formData: 'FormData' in self,
		    arrayBuffer: 'ArrayBuffer' in self
		  };

		  function isDataView(obj) {
		    return obj && DataView.prototype.isPrototypeOf(obj)
		  }

		  if (support.arrayBuffer) {
		    var viewClasses = [
		      '[object Int8Array]',
		      '[object Uint8Array]',
		      '[object Uint8ClampedArray]',
		      '[object Int16Array]',
		      '[object Uint16Array]',
		      '[object Int32Array]',
		      '[object Uint32Array]',
		      '[object Float32Array]',
		      '[object Float64Array]'
		    ];

		    var isArrayBufferView =
		      ArrayBuffer.isView ||
		      function(obj) {
		        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
		      };
		  }

		  function normalizeName(name) {
		    if (typeof name !== 'string') {
		      name = String(name);
		    }
		    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
		      throw new TypeError('Invalid character in header field name')
		    }
		    return name.toLowerCase()
		  }

		  function normalizeValue(value) {
		    if (typeof value !== 'string') {
		      value = String(value);
		    }
		    return value
		  }

		  // Build a destructive iterator for the value list
		  function iteratorFor(items) {
		    var iterator = {
		      next: function() {
		        var value = items.shift();
		        return {done: value === undefined, value: value}
		      }
		    };

		    if (support.iterable) {
		      iterator[Symbol.iterator] = function() {
		        return iterator
		      };
		    }

		    return iterator
		  }

		  function Headers(headers) {
		    this.map = {};

		    if (headers instanceof Headers) {
		      headers.forEach(function(value, name) {
		        this.append(name, value);
		      }, this);
		    } else if (Array.isArray(headers)) {
		      headers.forEach(function(header) {
		        this.append(header[0], header[1]);
		      }, this);
		    } else if (headers) {
		      Object.getOwnPropertyNames(headers).forEach(function(name) {
		        this.append(name, headers[name]);
		      }, this);
		    }
		  }

		  Headers.prototype.append = function(name, value) {
		    name = normalizeName(name);
		    value = normalizeValue(value);
		    var oldValue = this.map[name];
		    this.map[name] = oldValue ? oldValue + ', ' + value : value;
		  };

		  Headers.prototype['delete'] = function(name) {
		    delete this.map[normalizeName(name)];
		  };

		  Headers.prototype.get = function(name) {
		    name = normalizeName(name);
		    return this.has(name) ? this.map[name] : null
		  };

		  Headers.prototype.has = function(name) {
		    return this.map.hasOwnProperty(normalizeName(name))
		  };

		  Headers.prototype.set = function(name, value) {
		    this.map[normalizeName(name)] = normalizeValue(value);
		  };

		  Headers.prototype.forEach = function(callback, thisArg) {
		    for (var name in this.map) {
		      if (this.map.hasOwnProperty(name)) {
		        callback.call(thisArg, this.map[name], name, this);
		      }
		    }
		  };

		  Headers.prototype.keys = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push(name);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.values = function() {
		    var items = [];
		    this.forEach(function(value) {
		      items.push(value);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.entries = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push([name, value]);
		    });
		    return iteratorFor(items)
		  };

		  if (support.iterable) {
		    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
		  }

		  function consumed(body) {
		    if (body.bodyUsed) {
		      return Promise.reject(new TypeError('Already read'))
		    }
		    body.bodyUsed = true;
		  }

		  function fileReaderReady(reader) {
		    return new Promise(function(resolve, reject) {
		      reader.onload = function() {
		        resolve(reader.result);
		      };
		      reader.onerror = function() {
		        reject(reader.error);
		      };
		    })
		  }

		  function readBlobAsArrayBuffer(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsArrayBuffer(blob);
		    return promise
		  }

		  function readBlobAsText(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsText(blob);
		    return promise
		  }

		  function readArrayBufferAsText(buf) {
		    var view = new Uint8Array(buf);
		    var chars = new Array(view.length);

		    for (var i = 0; i < view.length; i++) {
		      chars[i] = String.fromCharCode(view[i]);
		    }
		    return chars.join('')
		  }

		  function bufferClone(buf) {
		    if (buf.slice) {
		      return buf.slice(0)
		    } else {
		      var view = new Uint8Array(buf.byteLength);
		      view.set(new Uint8Array(buf));
		      return view.buffer
		    }
		  }

		  function Body() {
		    this.bodyUsed = false;

		    this._initBody = function(body) {
		      this._bodyInit = body;
		      if (!body) {
		        this._bodyText = '';
		      } else if (typeof body === 'string') {
		        this._bodyText = body;
		      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
		        this._bodyBlob = body;
		      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
		        this._bodyFormData = body;
		      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		        this._bodyText = body.toString();
		      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
		        this._bodyArrayBuffer = bufferClone(body.buffer);
		        // IE 10-11 can't handle a DataView body.
		        this._bodyInit = new Blob([this._bodyArrayBuffer]);
		      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
		        this._bodyArrayBuffer = bufferClone(body);
		      } else {
		        this._bodyText = body = Object.prototype.toString.call(body);
		      }

		      if (!this.headers.get('content-type')) {
		        if (typeof body === 'string') {
		          this.headers.set('content-type', 'text/plain;charset=UTF-8');
		        } else if (this._bodyBlob && this._bodyBlob.type) {
		          this.headers.set('content-type', this._bodyBlob.type);
		        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
		        }
		      }
		    };

		    if (support.blob) {
		      this.blob = function() {
		        var rejected = consumed(this);
		        if (rejected) {
		          return rejected
		        }

		        if (this._bodyBlob) {
		          return Promise.resolve(this._bodyBlob)
		        } else if (this._bodyArrayBuffer) {
		          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
		        } else if (this._bodyFormData) {
		          throw new Error('could not read FormData body as blob')
		        } else {
		          return Promise.resolve(new Blob([this._bodyText]))
		        }
		      };

		      this.arrayBuffer = function() {
		        if (this._bodyArrayBuffer) {
		          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
		        } else {
		          return this.blob().then(readBlobAsArrayBuffer)
		        }
		      };
		    }

		    this.text = function() {
		      var rejected = consumed(this);
		      if (rejected) {
		        return rejected
		      }

		      if (this._bodyBlob) {
		        return readBlobAsText(this._bodyBlob)
		      } else if (this._bodyArrayBuffer) {
		        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
		      } else if (this._bodyFormData) {
		        throw new Error('could not read FormData body as text')
		      } else {
		        return Promise.resolve(this._bodyText)
		      }
		    };

		    if (support.formData) {
		      this.formData = function() {
		        return this.text().then(decode)
		      };
		    }

		    this.json = function() {
		      return this.text().then(JSON.parse)
		    };

		    return this
		  }

		  // HTTP methods whose capitalization should be normalized
		  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

		  function normalizeMethod(method) {
		    var upcased = method.toUpperCase();
		    return methods.indexOf(upcased) > -1 ? upcased : method
		  }

		  function Request(input, options) {
		    options = options || {};
		    var body = options.body;

		    if (input instanceof Request) {
		      if (input.bodyUsed) {
		        throw new TypeError('Already read')
		      }
		      this.url = input.url;
		      this.credentials = input.credentials;
		      if (!options.headers) {
		        this.headers = new Headers(input.headers);
		      }
		      this.method = input.method;
		      this.mode = input.mode;
		      this.signal = input.signal;
		      if (!body && input._bodyInit != null) {
		        body = input._bodyInit;
		        input.bodyUsed = true;
		      }
		    } else {
		      this.url = String(input);
		    }

		    this.credentials = options.credentials || this.credentials || 'same-origin';
		    if (options.headers || !this.headers) {
		      this.headers = new Headers(options.headers);
		    }
		    this.method = normalizeMethod(options.method || this.method || 'GET');
		    this.mode = options.mode || this.mode || null;
		    this.signal = options.signal || this.signal;
		    this.referrer = null;

		    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
		      throw new TypeError('Body not allowed for GET or HEAD requests')
		    }
		    this._initBody(body);
		  }

		  Request.prototype.clone = function() {
		    return new Request(this, {body: this._bodyInit})
		  };

		  function decode(body) {
		    var form = new FormData();
		    body
		      .trim()
		      .split('&')
		      .forEach(function(bytes) {
		        if (bytes) {
		          var split = bytes.split('=');
		          var name = split.shift().replace(/\+/g, ' ');
		          var value = split.join('=').replace(/\+/g, ' ');
		          form.append(decodeURIComponent(name), decodeURIComponent(value));
		        }
		      });
		    return form
		  }

		  function parseHeaders(rawHeaders) {
		    var headers = new Headers();
		    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
		    // https://tools.ietf.org/html/rfc7230#section-3.2
		    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
		    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
		      var parts = line.split(':');
		      var key = parts.shift().trim();
		      if (key) {
		        var value = parts.join(':').trim();
		        headers.append(key, value);
		      }
		    });
		    return headers
		  }

		  Body.call(Request.prototype);

		  function Response(bodyInit, options) {
		    if (!options) {
		      options = {};
		    }

		    this.type = 'default';
		    this.status = options.status === undefined ? 200 : options.status;
		    this.ok = this.status >= 200 && this.status < 300;
		    this.statusText = 'statusText' in options ? options.statusText : 'OK';
		    this.headers = new Headers(options.headers);
		    this.url = options.url || '';
		    this._initBody(bodyInit);
		  }

		  Body.call(Response.prototype);

		  Response.prototype.clone = function() {
		    return new Response(this._bodyInit, {
		      status: this.status,
		      statusText: this.statusText,
		      headers: new Headers(this.headers),
		      url: this.url
		    })
		  };

		  Response.error = function() {
		    var response = new Response(null, {status: 0, statusText: ''});
		    response.type = 'error';
		    return response
		  };

		  var redirectStatuses = [301, 302, 303, 307, 308];

		  Response.redirect = function(url, status) {
		    if (redirectStatuses.indexOf(status) === -1) {
		      throw new RangeError('Invalid status code')
		    }

		    return new Response(null, {status: status, headers: {location: url}})
		  };

		  exports.DOMException = self.DOMException;
		  try {
		    new exports.DOMException();
		  } catch (err) {
		    exports.DOMException = function(message, name) {
		      this.message = message;
		      this.name = name;
		      var error = Error(message);
		      this.stack = error.stack;
		    };
		    exports.DOMException.prototype = Object.create(Error.prototype);
		    exports.DOMException.prototype.constructor = exports.DOMException;
		  }

		  function fetch(input, init) {
		    return new Promise(function(resolve, reject) {
		      var request = new Request(input, init);

		      if (request.signal && request.signal.aborted) {
		        return reject(new exports.DOMException('Aborted', 'AbortError'))
		      }

		      var xhr = new XMLHttpRequest();

		      function abortXhr() {
		        xhr.abort();
		      }

		      xhr.onload = function() {
		        var options = {
		          status: xhr.status,
		          statusText: xhr.statusText,
		          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
		        };
		        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
		        var body = 'response' in xhr ? xhr.response : xhr.responseText;
		        resolve(new Response(body, options));
		      };

		      xhr.onerror = function() {
		        reject(new TypeError('Network request failed'));
		      };

		      xhr.ontimeout = function() {
		        reject(new TypeError('Network request failed'));
		      };

		      xhr.onabort = function() {
		        reject(new exports.DOMException('Aborted', 'AbortError'));
		      };

		      xhr.open(request.method, request.url, true);

		      if (request.credentials === 'include') {
		        xhr.withCredentials = true;
		      } else if (request.credentials === 'omit') {
		        xhr.withCredentials = false;
		      }

		      if ('responseType' in xhr && support.blob) {
		        xhr.responseType = 'blob';
		      }

		      request.headers.forEach(function(value, name) {
		        xhr.setRequestHeader(name, value);
		      });

		      if (request.signal) {
		        request.signal.addEventListener('abort', abortXhr);

		        xhr.onreadystatechange = function() {
		          // DONE (success or failure)
		          if (xhr.readyState === 4) {
		            request.signal.removeEventListener('abort', abortXhr);
		          }
		        };
		      }

		      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
		    })
		  }

		  fetch.polyfill = true;

		  if (!self.fetch) {
		    self.fetch = fetch;
		    self.Headers = Headers;
		    self.Request = Request;
		    self.Response = Response;
		  }

		  exports.Headers = Headers;
		  exports.Request = Request;
		  exports.Response = Response;
		  exports.fetch = fetch;

		  Object.defineProperty(exports, '__esModule', { value: true });

		  return exports;

		}))({});
		})(__self__);
		__self__.fetch.ponyfill = true;
		// Remove "polyfill" property added by whatwg-fetch
		delete __self__.fetch.polyfill;
		// Choose between native implementation (global) or custom implementation (__self__)
		// var ctx = global.fetch ? global : __self__;
		var ctx = __self__; // this line disable service worker support temporarily
		exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
		exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
		exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
		exports.Headers = ctx.Headers;
		exports.Request = ctx.Request;
		exports.Response = ctx.Response;
		module.exports = exports;
} (browserPonyfill, browserPonyfill.exports));
	return browserPonyfill.exports;
}

(function (module, exports) {
	var fetchApi;
	if (typeof fetch === 'function') {
	  if (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.fetch) {
	    fetchApi = commonjsGlobal.fetch;
	  } else if (typeof window !== 'undefined' && window.fetch) {
	    fetchApi = window.fetch;
	  } else {
	    fetchApi = fetch;
	  }
	}

	if (typeof commonjsRequire !== 'undefined' && (typeof window === 'undefined' || typeof window.document === 'undefined')) {
	  var f = fetchApi || requireBrowserPonyfill();
	  if (f.default) f = f.default;
	  exports.default = f;
	  module.exports = exports.default;
	}
} (getFetch$1, getFetch$1.exports));

var getFetch = getFetch$1.exports;

var fetchNode = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': getFetch
}, [getFetch$1.exports]);

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
var fetchApi;
if (typeof fetch === 'function') {
  if (typeof global$1 !== 'undefined' && global$1.fetch) {
    fetchApi = global$1.fetch;
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
var XmlHttpRequestApi;
if (hasXMLHttpRequest()) {
  if (typeof global$1 !== 'undefined' && global$1.XMLHttpRequest) {
    XmlHttpRequestApi = global$1.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof global$1 !== 'undefined' && global$1.ActiveXObject) {
    ActiveXObjectApi = global$1.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = getFetch || fetchNode;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof$1(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = defaults$7({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = defaults$7({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  try {
    fetchIt(url, fetchOptions, callback);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof$1(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if (hasXMLHttpRequest() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: request,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults$7(options, this.options || {}, getDefaults());
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = makePromise(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';

var navbar = {
	nft: "NFT",
	"new": "NEW",
	product: "Products",
	company: "Company",
	support: "Support",
	price: "Prices",
	learn: "Learn",
	back: "Back",
	downloadButton: "Download App",
	download: "Download",
	banner: "Don’t invest unless you’re prepared to lose all of the money you invest. This is a high-risk investment and you are unlikely to be protected if something goes wrong. <a>Take 2 mins to learn more.</a>",
	banner_be_title: "Warning",
	banner_be_subtitle: "Virtual currencies, real risks. <br/>The only guarantee in crypto is risk.",
	banner_be_content_sm: "Read more to understand the risks involved in investing in virtual currencies.",
	banner_be_content_1: "<ul><li>The value of your virtual currencies can rise or fall sharply, and your initial investment may be lost completely.</li><li>Virtual currencies are not covered by the guarantee funds that cover bank deposits.</li><li>There is no legal mechanism on the virtual currencies market to prevent market manipulation or insider dealing.</li><li>Virtual currencies depend entirely on a specific computer technology and infrastructure, which in certain cases may be very recent and not yet adequately tested.</li></ul>",
	banner_be_content_2: "<ul><li>If one loses the identification code or password giving access to the virtual wallet in which the virtual currency is stored, the currency held therein will be irretrievably lost.</li><li>Virtual currencies are currently accepted as a means of payment to a limited extent, and in most countries there is no legal obligation to accept them.</li><li>For more information about the risks associated with an investment in virtual currencies, we advise you to read the Wikifin page <a>What is a cryptocurrency?</a></li></ul>",
	risk_warn_paragrpah_1: "<ul><li>The value of your virtual currencies can rise or fall sharply, and your initial investment may be lost completely.</li></ul>",
	risk_warn_paragrpah_2: "<ul><li>Virtual currencies are not covered by the guarantee funds that cover bank deposits.</li></ul>",
	risk_warn_paragrpah_3: "<ul><li>There is no legal mechanism on the virtual currencies market to prevent market manipulation or insider dealing.</li></ul>",
	risk_warn_paragrpah_4: "<ul><li>Virtual currencies depend entirely on a specific computer technology and infrastructure, which in certain cases may be very recent and not yet adequately tested.</li></ul>",
	risk_warn_paragrpah_5: "<ul><li>If one loses the identification code or password giving access to the virtual wallet in which the virtual currency is stored, the currency held therein will be irretrievably lost.</li></ul>",
	risk_warn_paragrpah_6: "<ul><li>Virtual currencies are currently accepted as a means of payment to a limited extent, and in most countries there is no legal obligation to accept them.</li></ul>",
	risk_warn_paragrpah_7: "<ul><li>For more information about the risks associated with an investment in virtual currencies, we advise you to read the Wikifin page <a>What is a cryptocurrency?</a></li></ul>",
	risk_warn_cta: "Read more to understand the risks involved in investing in virtual currencies."
};
var navbarV2 = {
	explore: "Explore",
	quick_links: "Quick links",
	buy_crypto: {
		title: "Buy Crypto",
		explore: {
			cdc_app: "Crypto.com App",
			exchange: "Exchange",
			defi_wallet: "DeFi Wallet",
			earn: "Earn",
			prices: "Prices"
		},
		quick_links: {
			buy_bitcoin: "How to buy Bitcoin",
			price_of_crypto: "What influence the price of crypto",
			use_defi: "How to use DeFi",
			bullish_trading: "Top 10 Bullish Crypto Trading Indicators",
			get_started: "Get Started"
		}
	},
	spend_crypto: {
		title: "Spend Crypto",
		explore: {
			visa_cards: "Metal Visa Cards",
			cdc_pay: "Crypto.com Pay",
			pay_for_merchants: "Pay for Merchants"
		},
		quick_links: {
			pay_crypto: "How to pay with crypto",
			top_brands: "How to shop at top brands with crypto",
			rewards_pay: "How to get rewards with Pay",
			become_merchant: "Become a crypto merchant",
			visa_card: "Get your Visa Card"
		}
	},
	earn: {
		title: "Earn"
	},
	NFT: {
		title: "NFT"
	},
	learn: {
		title: "Learn",
		explore: {
			university: "University",
			glossary: "Glossary",
			research: "Research & Analysis",
			nft_deep: "Bitcoin"
		},
		quick_links: {
			guide_cdc_app: "Quick guide of the Crypto.com App",
			crypto_wallet: "What is a crypto wallet",
			bitcoin_halving: "What Is Bitcoin halving and how does it affect BTC price",
			ai_tokens: "Top 10 AI tokens",
			mining: "What is crypto mining",
			security_tips: "Essential security tips"
		}
	},
	news: {
		title: "News",
		explore: {
			trending: "What’s Trending",
			market_updates: "Market Updates",
			product_news: "Product News",
			company_news: "Company News",
			events: "Events"
		},
		quick_links: {
			about: "About",
			partners: "Partners",
			security: "Security",
			affiliate: "Affiliate",
			capital: "Capital",
			support: "Support"
		}
	}
};
var products = {
	sectionTitle_getStarted: "Get Started",
	sectionTitle_advancedTrading: "Advanced Trading",
	categoryTitle_app: "APP",
	categoryTitle_buyAndSell: "BUY AND SELL",
	categoryTitle_spend: "SPEND",
	categoryTitle_grow: "GROW",
	categoryTitle_exchange: "EXCHANGE",
	categoryTitle_defi: "DEFI",
	categoryTitle_ecosystem: "ECOSYSTEM",
	app: "App",
	appDescription: "Trusted by 100M customers world-wide",
	appDescription_update: "Buy Bitcoin, Ethereum, and 350+ cryptocurrencies",
	appDescription_update_kr: "Buy Bitcoin, Ethereum, and 160+ cryptocurrencies",
	appDescription_uk: "Cryptocurrency in Every Wallet™",
	nft: "Crypto.com NFT",
	nftDescription: "Own the culture you love",
	rewards: "Rewards+",
	rewardsDescription: "Make every trade more rewarding",
	crypto: "Crypto.com App",
	buyAndSell: "Buy and Sell",
	buyAndSellDescription: "Buy crypto at true cost",
	metalCards: "Metal Visa Cards",
	metalCardsDescription: "Up to 5% back on all spending",
	pay: "Crypto.com Pay",
	payDescription: "Pay and get paid in crypto",
	payDescription_update: "Spend your crypto anywhere",
	credit: "Crypto Credit",
	creditDescription: "Get an instant loan with no deadlines",
	earn: "Crypto Earn",
	earnDescription: "Get the most out of your assets",
	exchange: "Exchange",
	exchangeIndex: "Exchange Home",
	exchangeIndexDescription: "Trade with low fees and deep liquidity",
	oneTimeCard: "One Time Card",
	staking: "Staking",
	marginTrading: "Margin Trading",
	marginTradingDescription: "Get 3x leverage",
	derivatives: "Derivatives Trading",
	derivativesDescription: "20x leverage, ultra low latency",
	defi: "DeFi",
	wallet: "Wallet",
	walletDescription: "Full control of your private keys",
	defiEarn: "Earn",
	defiEarnDescription: "Earn interest from DeFi protocols",
	eco: "Ecosystem",
	swap: "Swap",
	swapDescription: "Farm popular DeFi tokens",
	chain: "Crypto.org Chain",
	chainDescription: "Next-generation public blockchain",
	payMerchant: "Pay for Business",
	payMerchantDescription: "Accept crypto simply and securely",
	blockchain: "Blockchain",
	blog: "Blog",
	cards: "Cards",
	chainExplorer: "Chain Explorer",
	commerce: "Commerce",
	dashboard: "Dashboard",
	explorer: "Explorer",
	explorerDescription: "Track and validate CRO transactions",
	others: "Others",
	prices: "Prices",
	cdcPrices: "Crypto Prices",
	siteWidgets: "Site Widgets",
	pricesDescription: "Real-time crypto price index",
	resources: "Resources",
	supercharger: "Supercharger",
	superchargerDescription: "One-click liquidity mining ",
	syndicate: "The Syndicate",
	syndicateDescription: "Discounted token distributions",
	tax: "Tax",
	token: "CRO Token",
	tokenDescription: "Powering the Crypto.com Ecosystem",
	tradingArena: "Trading Arena",
	tradingArenaDescription: "Trading activity competitions",
	defiWallet: "DeFi Wallet",
	defiWalletDescription: "One app, multiple DeFi services",
	browserExt: "Browser Extension",
	browserExtDescription: "Access DeFi protocols on desktop",
	desktopWallet: "Desktop Wallet",
	desktopWalletDescription: "Easily manage your DeFi tools",
	proofOfReserves: "Proof of Reserves",
	derivativesTrading: "Derivatives Trading",
	pricesBitcoin: "Bitcoin Price",
	pricesEth: "Ethereum Price",
	visaCard: "Visa Card",
	NFTtoken: "NFT",
	onChainStaking: "On-chain Staking",
	onChainStakingDescription: "Generate passive income",
	prime: "Prime",
	prime_description: "Build your generational wealth",
	app_derivatives: "Derivatives",
	app_derivatives_description: "Potentially profit whichever way the market goes",
	updown_options: "UpDown Options",
	strike_options: "Strike Options",
	bitcoin_halving_countDown: "Bitcoin Halving Countdown",
	btc_usd_converter: "BTC/USD Converter",
	btc_eur_converter: "BTC/EUR Converter",
	btc_sgd_converter: "BTC/SGD Converter",
	btc_brl_converter: "BTC/BRL Converter",
	btc_aud_converter: "BTC/AUD Converter",
	btc_cad_converter: "BTC/CAD Converter",
	btc_gbp_converter: "BTC/GBP Converter",
	btc_krw_converter: "BTC/KRW Converter"
};
var company$c = {
	sectionTitle_aboutUs: "About us",
	about: "About",
	aboutUs: "About Us",
	aboutDescription: "Discover our vision, mission and team",
	careers: "Careers",
	careersDescription: "Build Web3 with us",
	news: "News",
	companyNews: "Company News",
	newsDescription: "Company and product updates",
	listing: "Listing",
	support: "Support",
	supportDescription: "Get help 24/7",
	security: "Security",
	securityDescription: "Learn about our industry-leading protection",
	partners: "Partners",
	partnersDescription: "Explore our world-class portfolio of partners",
	noticeBoard: "Notice Board",
	noticeBoardDescription: "Company and product updates",
	vision: "Vision",
	advisors: "Advisors",
	capital: "Capital",
	team: "Team",
	values: "Values",
	university: "University",
	research: "Research",
	contact: "Contact",
	climate: "Climate",
	eea_complaints: "Complaints Policy",
	affiliate: "Affiliate",
	learn: "Learn",
	complaints: "Complaints Policy",
	riskStatement: "Risk Statement",
	financialStatement_2022: "Financial Statements 2022",
	financialStatement_2023: "Financial Statements 2023",
	liquid_risk_manage: "Liquidity Risk Management",
	weekly_report: "Semiannual Ombudsman Report",
	regulatory_reports: "Regulatory Reports"
};
var footer = {
	globalRemark: "The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.\n\nPlease note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.",
	usRemark: "The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.\n\nPlease note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.\n\nCrypto.com services are provided by Foris DAX, Inc. and its affiliates (NMLS ID 1966158).",
	eeaRemark: "Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services: 1. execution of orders on behalf of other persons; 2. dealing on own account; and 3. custodian or nominee services to experienced and non-experienced investors.\n\nAny other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services. \n\nPast performance is not a reliable indicator of future performance. \n\nEmail: contact@crypto.com | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
	complaint_brochure: "Complaint Brochure",
	copyright: "Copyright © 2024 Crypto.com. All rights reserved.",
	privacy_notice: "Privacy Notice",
	card_privacy_notice: "Card Privacy Notice",
	legal: "Legal",
	status: "Status",
	"t&c": "Terms & Conditions",
	"usT&C": "U.S. Terms and Conditions",
	cookie_preferences: "Cookie Preferences",
	"Do Not Sell My Personal Information": "Do Not Sell My Personal Information",
	sgRemarks: [
		"The purpose of this website is solely to display information regarding the products and services available on the <crypto>Crypto.com</crypto> App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the <crypto>Crypto.com</crypto> App.",
		"Please note that the availability of the products and services on the <crypto>Crypto.com</crypto> App is subject to jurisdictional limitations.",
		"Foris DAX Asia Pte. Ltd. (trading under the brand name “<crypto>Crypto.com</crypto>”) may only be able to offer certain products, features and/or services on the <crypto>Crypto.com</crypto> App due to potential or actual regulatory restrictions.",
		"The Monetary Authority of Singapore (MAS) requires us to provide this risk warning to you as a customer of a digital payment token (DPT) service provider. Before you pay Foris DAX Asia Pte. Ltd. any money or DPT, you should be aware of the following.",
		"a. Foris DAX Asia Pte. Ltd.  is exempted by MAS from holding a licence to provide DPT services. Please note that you may not be able to recover all the money or DPTs you paid to Foris DAX Asia Pte. Ltd. if Foris DAX Asia Pte. Ltd. business fails.",
		"b. You should not transact in the DPT if you are not familiar with this DPT. Transacting in DPTs may not be suitable for you if you are not familiar with the technology that DPT services are provided.",
		"c. You should be aware that the value of DPTs may fluctuate greatly. You should buy DPTs only if you are prepared to accept the risk of losing all of the money you put into such tokens."
	],
	ukRemarks: [
		"The purpose of this website is solely to display information regarding the products and services available on the <crypto>Crypto.com</crypto> App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the <crypto>Crypto.com</crypto> App. Your use of the <crypto>Crypto.com</crypto> app is subject to the <tnc>terms and conditions</tnc>.",
		"Please note that the availability of the products and services on the <crypto>Crypto.com</crypto> App is subject to jurisdictional limitations. <crypto>Crypto.com</crypto> may not offer certain products, features and/or services on the <crypto>Crypto.com</crypto> App in certain jurisdictions due to potential or actual regulatory restrictions.",
		"The <crypto>Crypto.com</crypto> App Services (as defined in the terms and conditions) are provided by Foris DAX MT Limited incorporated in Malta with company registration number C88392, (“Foris DAX MT”) licensed as a Class 3 Virtual Financial Assets service provider under the Virtual Financial Assets Act by the Malta Financial Services Authority (“MFSA”). Any product or service other than the <crypto>Crypto.com</crypto> App Services offered via the <crypto>Crypto.com</crypto> App is provided by affiliates of Foris DAX MT and is governed by separate sets of T&Cs.",
		"For enquiries (including any complaints) email: <email>contact@crypto.com</email> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta. Foris DAX MT complaints handling procedures are set out in the <tnc>terms and conditions</tnc>.",
		"Cryptocurrencies are a high risk investment that can fluctuate widely in price and may even become worthless. They are not appropriate for all investors and you should consider whether they are suitable for you in light of your financial situation. You should only buy cryptocurrency if you are prepared to accept the risk of losing all your initial investment. You should familiarise yourself with our <tnc>cryptocurrency risk disclosure statement</tnc>."
	],
	br_contact_info: "Talk to us by:",
	br_contact_schedule: "Everyday, from 08:00AM to 5:00PM (Sao Paulo-SP time)",
	br_ombudsman: "Ombudsman:",
	br_ombudsman_schedule: "Business days, from 08:00AM to 5:00PM (Sao Paulo-SP time)",
	qrcode: {
		title: "Get started with crypto",
		downloadBtn: "Download App",
		scan: "Scan to Download",
		or: "Or"
	},
	section: {
		products: "Products",
		features: "Features",
		learn: "Learn",
		prices: "Prices",
		news: "News",
		company: "Company"
	}
};
var geolocation = {
	description: "Please select your location",
	lang_desktop: "Language",
	lang_mobile: "Preferred language",
	location: "Location",
	select_location: "Please select your preferred location",
	suggestion: "Suggested for you",
	allLang: "All languages",
	allLocation: "All locations",
	us: "United States",
	global: "Global",
	eea: "European Economic Area",
	br: "Brazil",
	sg: "Singapore",
	au: "Australia",
	tr: "Türkiye",
	ca: "Canada",
	fr: "France",
	uk: "United Kingdom",
	it: "Italy",
	kr: "Korea"
};
var learn$c = {
	categoryTitle_updates: "Updates",
	categoryTitle_resources: "Resources",
	trending: "What's Trending",
	trendingDescription: "Read our top stories",
	marketUpdates: "Market Updates",
	marketUpdatesDescription: "Track the market's latest developments",
	productNews: "Product News",
	productNewsDescription: "Our latest updates and launches",
	events: "Events",
	eventsDescription: "Connect online and in person",
	university: "University",
	universityDescription: "Build your crypto knowledge",
	reportsAndAnalysis: "Research & Analysis",
	reportsAndAnalysisDescription: "Get our industry-leading insights",
	glossary: "Glossary",
	glossaryDescription: "Crypto terms explained",
	research: "Research",
	nftStories: "Bitcoin",
	nftStoriesDescription: "Everything you need to know about Bitcoin",
	bitcoin: "What is Bitcoin",
	bitcoin2: "Bitcoin",
	eth: "What is Ehereum?",
	eth2: "What is Ethereum?",
	blockchain: "What is Blockchain?",
	buyBitcoin: "How to buy Bitcoin?",
	buyEth: "How to buy Ethereum?",
	buyCrypto: "How to buy Crypto?",
	crypto: "What is Crypto?",
	defi: "What is DeFi?"
};
var navigation_en = {
	navbar: navbar,
	navbarV2: navbarV2,
	products: products,
	company: company$c,
	footer: footer,
	geolocation: geolocation,
	learn: learn$c
};

const fallback = 'en';
const langMinResources = {
    en: { navigation: navigation_en },
};
const languages = [
    'da',
    'en',
    'en-US',
    'es',
    'fr',
    'hu',
    'id',
    'it',
    'pl',
    'pt',
    'pt-BR',
    'ro',
    'ru',
    'tr',
    'vi',
    'zh-TW',
    'ko',
];
const i18n = i18next.createInstance();
i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
    resources: langMinResources,
    lng: 'en',
    fallbackLng: 'en',
    backend: {
        loadPath: () => {
            return ((process.env.MKT_NAV_STATIC_BASE_URL ?? '') +
                '/locales/mkt-nav-footer/{{lng}}/{{ns}}.json');
        },
    },
    defaultNS: 'navigation',
    ns: ['navigation'],
    interpolation: { escapeValue: false },
    returnObjects: true,
    partialBundledLanguages: true,
    react: { useSuspense: false },
});
/**
 * NOTE: Specific site need to show corresponding languages.
 *       Add the config blow and export it.
 *       import the corresponding config from useStaticSiteConfig.
 */
// WR-665 Brazil site shows pt-BR, other sites show pt
const brSiteLanguages = [
    'da',
    'en',
    'es',
    'fr',
    'hu',
    'id',
    'it',
    'pl',
    'pt-BR',
    'ro',
    'ru',
    'tr',
    'vi',
    'zh-TW',
];
const trSiteLanguages = ['en', 'tr'];
const eeaSiteLanguages = ['en'];
// WR-665 Brazil site shows pt-BR, other sites show pt
const regularSiteLanguages = [
    'da',
    'en',
    'es',
    'fr',
    'hu',
    'id',
    'it',
    'pl',
    'pt',
    'ro',
    'ru',
    'tr',
    'vi',
    'zh-TW',
    // 'ko',
];
const usSiteLanguages = [
    'da',
    'en-US',
    'es',
    'fr',
    'hu',
    'id',
    'it',
    'pl',
    'pt',
    'ro',
    'ru',
    'tr',
    'vi',
    'zh-TW',
    //  'ko',
];
const frSiteLanguages = ['en', 'fr'];
const caSiteLanguages = ['en', 'fr-CA'];
const itSiteLanguages = ['en', 'it'];
const krSiteLanguages = ['en', 'ko'];
const i18nLanguageToDisplayString = (language) => {
    switch (language) {
        case 'da':
            return 'Dansk';
        // case "de":
        //   return "Deutsch"
        case 'en':
            return 'English';
        case 'en-US':
            return 'English';
        case 'es':
            return 'Español';
        case 'fr':
            return 'Français';
        case 'fr-CA':
            return 'Français';
        case 'hu':
            return 'Magyar';
        case 'id':
            return 'Bahasa Indonesia';
        case 'it':
            return 'Italiano';
        case 'pl':
            return 'Polski';
        case 'pt':
            return 'Português';
        case 'pt-BR':
            return 'Português';
        case 'ro':
            return 'Română';
        case 'ru':
            return 'Pусский';
        case 'tr':
            return 'Türkçe';
        case 'vi':
            return 'Tiếng Việt';
        case 'zh-TW':
            return '繁體中文';
        case 'ko':
            return '한국어';
        default:
            return '';
    }
};

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign$1 (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign$1({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign$1({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign$1({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign$1({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

/**
 * @description to get user IP
 */
const traceUser = async () => {
    try {
        return await fetch('https://crypto.com/cdn-cgi/trace').then((response) => response.text());
    }
    catch (err) {
        console.log(err);
        return 'loc: GLOBAL';
    }
};
const getTraceObject = (text) => {
    const lines = text.trim().split('\n');
    const accumulator = {};
    return lines.reduce((acc, cur) => {
        const pair = cur.split('=');
        acc[pair[0]] = pair[1];
        return acc;
    }, accumulator);
};
const getRegion = (regionValue = 'GLOBAL') => {
    // TODO: enable IT and CA
    // if ([US, SG, BR, AU, TR, FR, IT, CA].includes(regionValue)) {
    //   return regionValue as Regions
    // }
    if ([
        RegionsEnum.US.toString(),
        RegionsEnum.SG.toString(),
        RegionsEnum.BR.toString(),
        RegionsEnum.AU.toString(),
        RegionsEnum.TR.toString(),
        RegionsEnum.FR.toString(),
        RegionsEnum.IT.toString(),
        RegionsEnum.CA.toString(),
        RegionsEnum.UK.toString(),
    ].includes(regionValue)) {
        return RegionsEnum[regionValue];
    }
    //set JP vpn as FR to test
    // if (regionValue === "JP") {
    //   return FR
    // }
    //set IN vpn as BR to test
    // if (regionValue === "IN") {
    //   return BR
    // }
    //set TW vpn as TR to test
    // if (regionValue === "TW") {
    //   return TR
    // }
    if (eeaCountryList.includes(regionValue)) {
        return RegionsEnum.EEA;
    }
    if (ukCountryList.includes(regionValue)) {
        return RegionsEnum.UK;
    }
    return RegionsEnum.GLOBAL;
};

const useUserRegion = () => {
    const [userRegion, setUserRegion] = useState(RegionsEnum.GLOBAL);
    useEffect(() => {
        let isMounted = true;
        const getUsersRegion = async () => {
            try {
                const data = await traceUser();
                const { loc: location } = getTraceObject(data);
                const region = getRegion(location);
                isMounted && setUserRegion(region);
            }
            catch (error) {
                //TODO can just do nothing for now
                console.error(error);
            }
        };
        getUsersRegion();
        return () => {
            isMounted = false;
        };
    }, []);
    return userRegion;
};
//For contenthub
const useUserRegionCH = () => {
    const [userRegion, setUserRegion] = useState(RegionsEnum.GLOBAL);
    useEffect(() => {
        const regionCookie = api.get(regionCookieName);
        const getUsersRegion = async () => {
            try {
                const data = await traceUser();
                const { loc: location } = getTraceObject(data);
                const region = getRegion(location);
                if (region === RegionsEnum.SG) {
                    setUserRegion(region);
                }
                else if (regionCookie) {
                    setUserRegion(regionCookie);
                }
                else {
                    setUserRegion(region);
                }
            }
            catch (error) {
                //TODO can just do nothing for now
                console.error(error);
            }
        };
        getUsersRegion();
    }, []);
    return userRegion;
};
const getUsersRegion = async () => {
    try {
        const data = await traceUser();
        const { loc: location } = getTraceObject(data);
        const region = getRegion(location);
        return region;
    }
    catch (error) {
        //TODO can just do nothing for now
        console.error(error);
    }
};

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

var test = {
	foo: {}
};

var $Object = Object;

var hasProto$1 = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var bind$1 = functionBind;

var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();
var hasProto = hasProto$1();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$1(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$1(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$1 = {exports: {}};

(function (module) {

	var bind = functionBind;
	var GetIntrinsic = getIntrinsic;

	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');

	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}

	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};

	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};

	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}
} (callBind$1));

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBind$1.exports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp$1(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$2(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$3(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$2(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$2(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge$1 = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$2(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$2(target) && !isArray$2(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$2(target) && isArray$2(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$2 = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge$1
};

var getSideChannel = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$1 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$6 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$1.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        obj = utils$1.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$6.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$6.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$6.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (isArray$1(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$6.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$1(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = generateArrayPrefix === 'comma' && isArray$1(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$1(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$6;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$6.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$6.filter;
    if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$6.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$6.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$6.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$6.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$6.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$6.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$6.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$6.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$6.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$6.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$1(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils = utils$2;

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults$5 = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults$5.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults$5.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults$5.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults$5;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults$5.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$5.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$5.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults$5.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$5.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$5.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$5.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$5.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults$5.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults$5.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$5.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$5.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$5.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$5.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var stringify = stringify_1;
var parse = parse$1;
var formats = formats$3;

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

const OneLinkContext = createContext({ queryString: '' });
const OneLinkProvider = ({ children, ...props }) => {
    const [queryString, setQueryString] = useState('');
    useEffect(() => {
        setQueryString(generatequeryString());
    }, []);
    function generatequeryString() {
        const queryStringObject = lib.parse(window.location.search.replace('?', ''));
        const queryMapping = {
            utm_source: 'pid',
            utm_campaign: 'c',
            gclid: 'af_sub2',
            utm_channel: 'af_channel',
            utm_ad: 'af_ad',
        };
        const newQuery = {};
        for (const [key, value] of Object.entries(queryStringObject)) {
            if (!queryMapping[key])
                continue;
            newQuery[queryMapping[key]] = value;
        }
        if (newQuery == null || Object.keys(newQuery).length === 0) {
            return '';
        }
        newQuery['af_js_web'] = true;
        return '?' + lib.stringify(newQuery);
    }
    return (jsx(OneLinkContext.Provider, { ...props, value: { queryString }, children: children }));
};
const useOneLink = () => {
    return useContext(OneLinkContext);
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get$1(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$1(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$6({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get$1(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$6({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get$1(theme, val))(theme);
        result = _extends$6({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get$1(aliases, key, key);
      var scaleName = get$1(scales, prop);
      var scale = get$1(theme, scaleName, get$1(theme, prop, {}));
      var transform = get$1(transforms, prop, get$1);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$4 = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults$4.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber$1(n) || n > 1 ? n : n * 100 + '%');
};

var config$7 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$7);

var config$6 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
var color = system(config$6);

var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$5);

var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$4);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$3);

var config$2 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$2.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$2.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$2.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$2.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$2.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$2.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$2.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$2.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$2.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$2.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$2.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$2.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$2.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$2.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$2.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$2.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$2);

var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
var background = system(config$1);

var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$1.space
  }
};
var position = system(config);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space$1 = compose(margin, padding);

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

layout.width;
    layout.height;
    layout.minWidth;
    layout.minHeight;
    layout.maxWidth;
    layout.maxHeight;
    layout.size;
    layout.verticalAlign;
    layout.display;
    layout.overflow;
    layout.overflowX;
    layout.overflowY;
color.opacity;
typography.fontSize;
    typography.fontFamily;
    typography.fontWeight;
    typography.lineHeight;
    typography.textAlign;
    typography.fontStyle;
    typography.letterSpacing;
flexbox.alignItems;
    flexbox.alignContent;
    flexbox.justifyItems;
    flexbox.justifyContent;
    flexbox.flexWrap;
    flexbox.flexDirection;
    flexbox.flex;
    flexbox.flexGrow;
    flexbox.flexShrink;
    flexbox.flexBasis;
    flexbox.justifySelf;
    flexbox.alignSelf;
    flexbox.order;
grid.gridGap;
    grid.gridColumnGap;
    grid.gridRowGap;
    grid.gridColumn;
    grid.gridRow;
    grid.gridAutoFlow;
    grid.gridAutoColumns;
    grid.gridAutoRows;
    grid.gridTemplateColumns;
    grid.gridTemplateRows;
    grid.gridTemplateAreas;
    grid.gridArea;
border.borderWidth;
    border.borderStyle;
    border.borderColor;
    border.borderTop;
    border.borderRight;
    border.borderBottom;
    border.borderLeft;
    border.borderRadius;
background.backgroundImage;
    background.backgroundSize;
    background.backgroundPosition;
    background.backgroundRepeat;
position.zIndex;
    position.top;
    position.right;
    position.bottom;
    position.left;

var all = compose(space$1, typography, color, layout, flexbox, border, background, position, grid, shadow, buttonStyle, textStyle, colorStyle);
var props = all.propNames;
var createShouldForwardProp = function createShouldForwardProp(props) {
  var regex = new RegExp("^(" + props.join('|') + ")$");
  return memoize$1(function (prop) {
    return index(prop) && !regex.test(prop);
  });
};
var shouldForwardProp = createShouldForwardProp(props);

const Box = styled('div', { shouldForwardProp }) `
  box-sizing: border-box;
  margin: 0;
  ${typography}
  ${flexbox}
  ${space$1}
  ${color}
  ${layout}
  ${position}
  ${border}
  ${({ customCss }) => css(customCss)}
`;

const Container = styled(Box) `
  ${css({
    maxWidth: 'containerWidth',
    mx: 'auto',
    my: 0,
    px: [3, 7, 3],
})}
`;

const Flex = styled(Box) `
  display: flex;
`;

const variants = {
    h1: {
        fontFamily: 'general',
        fontSize: [48, 48, 74],
        lineHeight: ['115%', '125%', '115%'],
        letterSpacing: ['-0.015em', '-0.65px', '-0.015em'],
        fontWeight: ['600', '600', '600'],
    },
    h2: {
        fontFamily: 'general',
        fontSize: [42, 34, 64],
        lineHeight: ['115%', '125%', '115%'],
        letterSpacing: ['-0.015em', '-0.25px', '-0.015em'],
        fontWeight: ['600', '600', '600'],
    },
    h3: {
        fontFamily: 'general',
        fontSize: [32, 25, 48],
        lineHeight: ['125%', '132%', '125%'],
        letterSpacing: ['-0.015em', '0px', '-0.015em'],
        fontWeight: ['600', '600', '600'],
    },
    h4: {
        fontFamily: 'general',
        fontSize: [14, 15, 18],
        lineHeight: ['125%', '145%', '115%'],
        letterSpacing: ['0.03em', '0.4px', '0.03em'],
        fontWeight: ['bold', '600', '600'],
    },
    h5: {
        fontFamily: 'general',
        fontSize: [22, 21, 32],
        lineHeight: ['125%', '130%', '125%'],
        letterSpacing: ['0em', '0.1px', '0em'],
        fontWeight: ['600', '600', '600'],
    },
    h6: {
        fontFamily: 'general',
        fontSize: [18, 18, 18],
        lineHeight: ['120%', '130%', '125%'],
        letterSpacing: ['0em', '0px', '0em'],
        fontWeight: ['500', '500', '500'],
    },
    h7: {
        fontFamily: 'general',
        fontSize: [15, 15, 15],
        lineHeight: ['125%', '145%', '125%'],
        letterSpacing: ['0.03em', '0.5px', '0.03em'],
        fontWeight: ['bold', 'bold', 'bold'],
    },
    p: {
        fontFamily: 'general',
    },
    subtitle: {
        fontFamily: 'general',
        fontSize: [17, 16, 24],
        lineHeight: ['130%', '130%', '145%'],
        letterSpacing: ['0em', '0.1px', '0em'],
        fontWeight: ['600', '600', '600'],
    },
    subtitle2: {
        fontFamily: 'general',
        fontSize: [16, 17, 18],
        lineHeight: ['135%', '135%', '145%'],
        letterSpacing: ['-0.1px', '0.01em', '0em'],
        fontWeight: ['500', '600', '600'],
    },
    subtitle4: {
        fontFamily: 'general',
        fontSize: [14, 14, 14],
        lineHeight: ['125%', '145%', '170%'],
        letterSpacing: ['0.03em', '0.4px', '0.01em'],
        fontWeight: ['500', '500', '500'],
    },
    subtitle6: {
        fontFamily: 'general',
        fontSize: [14, 14, 14],
        lineHeight: ['125%', '145%', '170%'],
        letterSpacing: ['0.03em', '0.4px', '0.01em'],
        fontWeight: ['700', '700', '700'],
    },
    menuTitle: {
        fontFamily: 'general',
        fontSize: ['18px'],
        lineHeight: ['22px', '22px', '22px'],
        fontWeight: ['600', '600', '600'],
    },
    menuSubTitle: {
        fontFamily: 'general',
        fontSize: ['18px'],
        lineHeight: ['22px', '22px', '22px'],
    },
    langTitle: {
        fontFamily: 'general',
        fontSize: ['22px'],
        lineHeight: ['22px', '22px', '22px'],
        fontWeight: ['600', '600', '600'],
    },
    subtitle5: {
        fontFamily: 'general',
        fontSize: ['14px'],
        lineHeight: ['20px'],
        fontWeight: ['500'],
        letterSpacing: ['0.28px'],
    },
    textCta: {
        fontFamily: 'general',
        fontSize: [16, 14, 18],
        lineHeight: ['145%', '145%', '100%'],
        letterSpacing: ['0em', '0.4px', '0.02em'],
        fontWeight: ['600', '500', 'bold'],
    },
    textCta2: {
        fontFamily: 'general',
        fontSize: [12, 12, 14],
        lineHeight: ['132%', '145%', '145%'],
        letterSpacing: ['0.015em', '0.2px', '0.01em'],
        fontWeight: ['500', '600', '500'],
    },
    submitBtn: {
        fontFamily: 'general',
        fontSize: '16px',
        color: '#fff',
        letterSpacing: ['0.015em', '0.15px', '0.015em'],
        fontWeight: '600',
    },
    downloadBtn: {
        fontFamily: 'general',
        fontSize: '16px',
        letterSpacing: ['0.015em', '0.15px', '0.015em'],
        fontWeight: '600',
    },
    caption: {
        fontFamily: 'general',
        fontSize: [14, 14, 14],
        lineHeight: ['132%', '132%', '150%'],
        letterSpacing: ['0.015em', '0px', '0em'],
        fontWeight: ['500', '500', '500'],
    },
    menuDescription: {
        fontFamily: 'general',
        fontSize: [14, 14, 14],
        lineHeight: ['150%', '150%', '150%'],
        fontWeight: ['500', '500', '500'],
    },
    badge: {
        fontFamily: 'general',
        fontSize: [12],
        lineHeight: ['17px'],
        letterSpacing: ['2%'],
        fontWeight: ['700', '700', '700'],
    },
};
const Typography = styled(Box) `
  white-space: ${({ whiteSpace }) => whiteSpace || 'pre-wrap'};
  ${variant({ variants })}
`;
const textVariants = {
    h4: {
        //styleName: Desktop/H4;
        fontFamily: 'general',
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '0px',
    },
    h4_m: {
        //styleName: Nivuke/H4;
        fontFamily: 'general',
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0px',
    },
    h3: {
        //styleName: Desktop/H3;
        fontFamily: 'general',
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0px',
    },
    h3_m: {
        //styleName: Mobile/H3;
        fontFamily: 'general',
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0px',
    },
    t4: {
        //styleName: Desktop/T4;
        fontFamily: 'general',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '19px',
        letterSpacing: '0px',
    },
    t3: {
        //styleName: Desktop/T3;
        fontFamily: 'general',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '155%',
        letterSpacing: '0px',
    },
    t1_m: {
        //styleName: Mobile/T1;
        fontFamily: 'general',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '23px',
    },
    l2: {
        fontFamily: 'general',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '110%',
    },
    l3: {
        fontFamily: 'general',
        fontSize: '14px',
        lineHeight: '110%',
        fontWeight: 600,
    },
    l2_m: {
        fontFamily: 'general',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '110%',
    },
    default: {
        fontFamily: 'general',
    },
};
const Text = styled(Box)(({ variant: variant$1 = 'default', ...props }) => ({
    whiteSpace: props.whiteSpace || 'pre-wrap',
    ...variant({ variants: textVariants })({ variant: variant$1, ...props }),
}));
const getTagFromVariant = (variant) => {
    switch (variant) {
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
            return variant;
        case 'h6':
        case 'h7':
        case 'subtitle':
            return 'h5';
        case 'bodyCopy':
            return 'div';
        default:
            return 'p';
    }
};
const ForwardedTypography = forwardRef(({ as, variant, ...props }, ref) => (jsx(Typography, { as: as || getTagFromVariant(variant), variant: variant, ref: ref, ...props })));
ForwardedTypography.displayName = 'Typography';

const screenSizes = {
    mobile: '375px',
    mobileBelow: '374px',
    tablet: '768px',
    tabletBelow: '767px',
    laptop: '1128px',
};
const mobileFirstDevice = {
    mobile: `(min-width: ${screenSizes.mobile})`,
    tablet: `(min-width: ${screenSizes.tablet})`,
    laptop: `(min-width: ${screenSizes.laptop})`,
    laptopL: `(min-width: ${screenSizes.laptop})`, // deprecated
};

var _path$4;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  viewBox: "0 0 13 8",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.016.585 6.431 5.17 1.846.585.431 2l6 6 6-6L11.016.585Z"
})));

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
const SvgChevronDownNav = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  d: "m5.755 8.333 5 5 5-5",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
const SvgPopoverArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  viewBox: "0 0 29 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.678 7.585a4 4 0 0 1-4.358 0L.643 0h27.713L16.677 7.585Z",
  fill: "#fff"
})));

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
const SvgPopoverArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  viewBox: "0 0 9 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  d: "M7.585 11.678a4 4 0 0 1 0 4.357L0 27.713V0l7.585 11.678Z",
  fill: "#fff"
})));

var _path;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const SvgPopoverArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  viewBox: "0 0 28 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.678 1.415a4 4 0 0 1 4.357 0L27.713 9H0l11.678-7.585Z",
  fill: "#fff"
})));

var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgClose28X28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 20.364,
  y: 6.222,
  width: 2,
  height: 20,
  rx: 1,
  transform: "rotate(45 20.364 6.222)",
  fill: "#A0A9BE"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 21.778,
  y: 20.364,
  width: 2,
  height: 20,
  rx: 1,
  transform: "rotate(135 21.778 20.364)",
  fill: "#A0A9BE"
})));

//social icons
//products icons
const createReactIcon = (Component) => {
    const Icon = forwardRef(({ height, width, customCss, ...props }, ref) => (jsx(Box, { display: "inline-flex", fontSize: "1em", ref: ref, height: height, width: width, ...props, customCss: {
            svg: {
                width: width,
                height: height,
            },
            ...customCss,
        }, children: jsx(Component, {}) })));
    Icon.displayName = 'Icon';
    return Icon;
};
const createImgIcon = (src, alt, imgWidth, imgHeight) => {
    const Icon = forwardRef(({ height, width, customCss, ...props }, ref) => {
        return (jsx(Box, { display: "inline-flex", ref: ref, width: width, height: height, ...props, customCss: {
                ...customCss,
            }, children: jsx("img", { alt: alt, width: imgWidth, height: imgHeight ?? imgWidth, src: (process.env.MKT_NAV_STATIC_BASE_URL ?? '') + src, style: { width: '100%', height: '100%' }, loading: "lazy" }) }));
    });
    Icon.displayName = 'Icon';
    return Icon;
};
const ChevronDown = createReactIcon(SvgChevronDown);
const PopoverArrowUp = createReactIcon(SvgPopoverArrowUp);
const PopoverArrowRight = createReactIcon(SvgPopoverArrowRight);
const PopoverArrowDown = createReactIcon(SvgPopoverArrowDown);
const NavDown = createReactIcon(SvgChevronDownNav);
createReactIcon(SvgClose28X28);
const AppStore = createImgIcon('/__assets/mkt-nav-footer/images/app_store.svg', 'App Store', 24);
const CdcLogo = createImgIcon('/__assets/mkt-nav-footer/images/cdc_logo.svg', 'CDC logo', 199, 40);
createImgIcon('/__assets/mkt-nav-footer/images/cdc_logo_xmas.svg', 'CDC logo', 199, 40);
const DownloadApp$1 = createImgIcon('/__assets/mkt-nav-footer/images/download-app.svg', "Download CDC's App", 14, 20);
createImgIcon('/__assets/mkt-nav-footer/images/footer/ea-icon.svg', 'EA logo', 58, 22);
const PlayStore = createImgIcon('/__assets/mkt-nav-footer/images/play_store.svg', 'Play Store', 24);
const GLOBALFlag = createImgIcon('/__assets/mkt-nav-footer/images/region-popup/global-round.svg', 'Global Flag', 24);
const ChevronLeftNarrow = createImgIcon('/__assets/mkt-nav-footer/images/icons/chevron-left-narrow.svg', 'Chevron Left Narrow', 8, 14);
const QrIcon = createImgIcon('/__assets/mkt-nav-footer/images/icons/qricon.svg', 'QR Icon', 17, 16);
const Close = createImgIcon('/__assets/mkt-nav-footer/images/icons/close.svg', 'Close', 20);
const Apple = createImgIcon('/__assets/mkt-nav-footer/images/icons/apple.svg', 'Apple', 16, 17);
const GooglePlay = createImgIcon('/__assets/mkt-nav-footer/images/icons/google-play.svg', 'Google Play', 16);
const GeolocationThin = createImgIcon('/__assets/mkt-nav-footer/images/icons/geolocation-thin.svg', 'Geolocation Thin', 20);
const Menu = createImgIcon('/__assets/mkt-nav-footer/images/icons/menu.svg', 'Menu', 22, 16);
const Search = createImgIcon('/__assets/mkt-nav-footer/images/icons/search.svg', 'Search', 24);
const SearchClose = createImgIcon('/__assets/mkt-nav-footer/images/icons/search-close.svg', 'Search Close', 21, 20);
const Select = createImgIcon('/__assets/mkt-nav-footer/images/icons/select.svg', 'Select', 21, 16);
const Telegram2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/telegram.svg', 'Telegram', 40);
const Twitter2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/twitter.svg', 'Twitter', 40);
const Threads = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/threads.svg', 'Threads', 40);
const Reddit2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/reddit.svg', 'Reddit', 40);
const Instagram2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/instagram.svg', 'Instagram', 40);
const Facebook2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/facebook.svg', 'Facebook', 40);
const LinkedIn2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/linkedin.svg', 'LinkedIn', 40);
const Discord2 = createImgIcon('/__assets/mkt-nav-footer/images/icons/socials/discord.svg', 'Discord', 40);
const ProductApp = createImgIcon('/__assets/mkt-nav-footer/images/icons/products/app.svg', 'App', 48, 24);
const ProductDefi = createImgIcon('/__assets/mkt-nav-footer/images/icons/products/defi.svg', 'Defi', 137, 24);
const ProductExchange = createImgIcon('/__assets/mkt-nav-footer/images/icons/products/exchange.svg', 'Exchange', 115, 24);
const ProductNFT = createImgIcon('/__assets/mkt-nav-footer/images/icons/products/nft.svg', 'NFT', 46, 24);
const ProductVisa = createImgIcon('/__assets/mkt-nav-footer/images/icons/products/visa.svg', 'Visa', 118, 24);

const links$1 = {
    'products.buyAndSell': {
        tTitle: 'products.buyAndSell',
        href: '/app',
        base: Site.MKT,
    },
    'products.earn': { tTitle: 'products.earn', href: '/earn', base: Site.MKT },
    'products.rewards': {
        tTitle: 'products.rewards',
        href: '/rewardsplus',
        base: Site.MKT,
    },
    'products.updownOptions': {
        tTitle: 'products.updown_options',
        href: '/app/derivatives#updown-options',
        base: Site.MKT,
    },
    'products.strikeOptions': {
        tTitle: 'products.strike_options',
        href: '/app/derivatives#strike-options',
        base: Site.MKT,
    },
    'products.pay': { tTitle: 'products.pay', href: '/pay', base: Site.MKT },
    'products.payMerchant': {
        tTitle: 'products.payMerchant',
        href: '/pay-merchant',
        base: Site.MKT,
    },
    'products.marginTrading': {
        tTitle: 'products.marginTrading',
        href: 'https://crypto.com/exchange/trade/BTC_USD',
    },
    'products.derivativesTrading': {
        tTitle: 'products.derivativesTrading',
        href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
    },
    'products.supercharger': {
        tTitle: 'products.supercharger',
        href: 'https://crypto.com/exchange/supercharger',
    },
    'products.oneTimeCard': {
        tTitle: 'products.oneTimeCard',
        href: 'https://help.crypto.com/en/articles/6890212-one-time-card',
    },
    'products.onChainStaking': {
        tTitle: 'products.onChainStaking',
        href: '/staking',
        base: Site.MKT,
    },
    'products.tradingArena': {
        tTitle: 'products.tradingArena',
        href: 'https://crypto.com/exchange/trading-arena',
    },
    'learn.university': {
        tTitle: 'learn.university',
        href: `/university`,
        base: Site.CHUB,
    },
    'learn.research': {
        tTitle: 'learn.reportsAndAnalysis',
        href: `/research`,
        base: Site.CHUB,
    },
    'learn.bitcoin': {
        tTitle: 'learn.bitcoin2',
        href: 'https://crypto.com/bitcoin',
    },
    'learn.eth': {
        tTitle: 'learn.eth2',
        href: 'https://crypto.com/university/ethereum-vs-ethereum-classic',
        base: Site.CHUB,
    },
    'learn.blockchain': {
        tTitle: 'learn.blockchain',
        href: 'https://crypto.com/university/what-is-blockchain-consensus',
        base: Site.CHUB,
    },
    'learn.buyBitcoin': {
        tTitle: 'learn.buyBitcoin',
        href: 'https://crypto.com/university/how-to-buy-bitcoin',
        base: Site.CHUB,
    },
    'learn.buyEth': {
        tTitle: 'learn.buyEth',
        href: 'https://crypto.com/university/how-to-buy-ethereum',
        base: Site.CHUB,
    },
    'learn.buyCrypto': {
        tTitle: 'learn.buyCrypto',
        href: 'https://crypto.com/university/how-to-buy-bitcoin-cryptocurrencies',
        base: Site.CHUB,
    },
    'learn.crypto': {
        tTitle: 'learn.crypto',
        href: 'https://crypto.com/university/what-is-cryptocurrency',
        base: Site.CHUB,
    },
    'learn.defi': {
        tTitle: 'learn.defi',
        href: 'https://crypto.com/university/decentralised-finance-defi-intro',
        base: Site.CHUB,
    },
    'products.prices': {
        tTitle: 'products.cdcPrices',
        href: 'https://crypto.com/price',
    },
    'products.pricesBitcoin': {
        tTitle: 'products.pricesBitcoin',
        href: 'https://crypto.com/price/bitcoin',
    },
    'products.pricesEth': {
        tTitle: 'products.pricesEth',
        href: 'https://crypto.com/price/ethereum',
    },
    'products.siteWidgets': {
        tTitle: 'products.siteWidgets',
        href: 'https://crypto.com/price/widget',
    },
    'products.btc_usd_converter': {
        tTitle: 'products.btc_usd_converter',
        href: 'https://crypto.com/converter/btc/usd',
    },
    'products.btc_eur_converter': {
        tTitle: 'products.btc_eur_converter',
        href: 'https://crypto.com/converter/btc/eur',
    },
    'products.btc_sgd_converter': {
        tTitle: 'products.btc_sgd_converter',
        href: 'https://crypto.com/converter/btc/sgd',
    },
    'products.btc_brl_converter': {
        tTitle: 'products.btc_brl_converter',
        href: 'https://crypto.com/converter/btc/brl',
    },
    'products.btc_aud_converter': {
        tTitle: 'products.btc_aud_converter',
        href: 'https://crypto.com/converter/btc/aud',
    },
    'products.btc_cad_converter': {
        tTitle: 'products.btc_cad_converter',
        href: 'https://crypto.com/converter/btc/cad',
    },
    'products.btc_gbp_converter': {
        tTitle: 'products.btc_gbp_converter',
        href: 'https://crypto.com/converter/btc/gbp',
    },
    'products.btc_krw_converter': {
        tTitle: 'products.btc_krw_converter',
        href: 'https://crypto.com/converter/btc/krw',
    },
    'learn.trending': {
        tTitle: 'learn.trending',
        href: `/trending`,
        base: Site.CHUB,
    },
    'learn.marketUpdates': {
        tTitle: 'learn.marketUpdates',
        href: `/market-updates`,
        base: Site.CHUB,
    },
    'learn.productNews': {
        tTitle: 'learn.productNews',
        href: `/product-news`,
        base: Site.CHUB,
    },
    'company.news': {
        tTitle: 'company.companyNews',
        href: `/company-news`,
        base: Site.CHUB,
    },
    'learn.events': { tTitle: 'learn.events', href: `/events`, base: Site.CHUB },
    'company.aboutUs': { tTitle: 'company.aboutUs', href: '/about' },
    'company.partners': { tTitle: 'company.partners', href: '/partners' },
    'company.security': { tTitle: 'company.security', href: '/security' },
    'products.proofOfReserves': {
        tTitle: 'products.proofOfReserves',
        base: Site.MKT,
        href: '/proof-of-reserves',
    },
    'products.tax': {
        tTitle: 'products.tax',
        href: 'https://tax.crypto.com/',
    },
    'company.climate': {
        tTitle: 'company.climate',
        href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
    },
    'company.capital': {
        tTitle: 'company.capital',
        href: '/capital',
        base: Site.MKT,
    },
    'company.affiliate': {
        tTitle: 'company.affiliate',
        href: '/affiliate',
        base: Site.MKT,
    },
    'company.careers': { tTitle: 'company.careers', href: '/careers' },
    'company.eea_complaints': {
        tTitle: 'company.eea_complaints',
        href: '/privacy/complaints_eea.pdf',
    },
    'company.listing': {
        tTitle: 'company.listing',
        href: '/listing',
        base: Site.MKT,
    },
    'company.support': {
        tTitle: 'company.support',
        href: 'https://help.crypto.com/en',
    },
    'products.app': {
        tTitle: 'products.app',
        icon: ProductApp,
        Site: Site.MKT,
        href: '/app',
    },
    'products.visaCard': {
        tTitle: 'products.visaCard',
        icon: ProductVisa,
        Site: Site.MKT,
        href: '/cards',
    },
    'products.exchange': {
        tTitle: 'products.exchange',
        icon: ProductExchange,
        href: 'https://crypto.com/exchange',
    },
    'products.defiWallet': {
        tTitle: 'products.defiWallet',
        icon: ProductDefi,
        Site: Site.MKT,
        href: '/defi-wallet',
    },
    'products.NFTtoken': {
        tTitle: 'products.NFTtoken',
        icon: ProductNFT,
        href: 'https://crypto.com/nft',
    },
    'company.regulatoryReports': {
        tTitle: 'company.regulatory_reports',
        href: 'https://crypto.com/br/regulatory-reports',
    },
    'company.financialStatement2022': {
        tTitle: 'company.financialStatement_2022',
        href: 'https://crypto.com/document/demonstracoesfinanceiras_dez_2022',
    },
    'company.financialStatement2023': {
        tTitle: 'company.financialStatement_2023',
        href: 'https://crypto.com/document/demonstracoesinanceiras_2023',
    },
    'company.liquidRiskManage': {
        tTitle: 'company.liquid_risk_manage',
        href: 'https://crypto.com/document/estrutura_do_gerenciamento_do_risco_de_liquidez',
    },
    'learn.glossary': {
        tTitle: 'learn.glossary',
        href: '/glossary',
        base: Site.GLOSSARY,
    },
    'company.weeklyReport': {
        tTitle: 'company.weekly_report',
        href: 'https://crypto.com/document/relatorio_semestral_de_ouvidoria',
    },
};

const legal_au = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/australia.pdf',
    },
    {
        key: 'card_privacy_notice',
        name: 'Card Privacy Notice',
        href: '/privacy/australia_ForisGFS.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$b = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$9 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.onChainStaking'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
    ],
};
const learn$b = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$a = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_aud_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$b = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$b = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$9 = [
    [features$9],
    [learn$b],
    [prices$a, news$b],
    [company$b],
];
const tablet_global$9 = [
    [features$9, prices$a, news$b],
    [learn$b, company$b],
];
const mobile_global$9 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$b,
    },
    ...desktop_global$9.flatMap((menu) => menu),
];
const footer_au = {
    products: desktop_products$b,
    desktop: desktop_global$9,
    tablet: tablet_global$9,
    mobile: mobile_global$9,
};
const features_noStaking$5 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
    ],
};
const desktop_global_noStaking$5 = [
    [features_noStaking$5],
    [learn$b],
    [prices$a, news$b],
    [company$b],
];
const tablet_global_noStaking$5 = [
    [features_noStaking$5, prices$a, news$b],
    [learn$b, company$b],
];
const mobile_global_noStaking$5 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$b,
    },
    ...desktop_global_noStaking$5.flatMap((menu) => menu),
];
const footer_au_noStaking = {
    products: desktop_products$b,
    desktop: desktop_global_noStaking$5,
    tablet: tablet_global_noStaking$5,
    mobile: mobile_global_noStaking$5,
};

const legal_br = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/brazil.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$a = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$8 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.onChainStaking'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
        links$1['products.supercharger'],
        links$1['products.tradingArena'],
    ],
};
const learn$a = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$9 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_brl_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$a = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$a = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
        links$1['company.regulatoryReports'],
    ],
};
const desktop_global$8 = [
    [features$8],
    [learn$a],
    [prices$9, news$a],
    [company$a],
];
const tablet_global$8 = [
    [features$8, prices$9, news$a],
    [learn$a, company$a],
];
const mobile_global$8 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$a,
    },
    ...desktop_global$8.flatMap((menu) => menu),
];
const footer_br = {
    products: desktop_products$a,
    desktop: desktop_global$8,
    tablet: tablet_global$8,
    mobile: mobile_global$8,
};
const features_noStaking$4 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
        links$1['products.supercharger'],
        links$1['products.tradingArena'],
    ],
};
const desktop_global_noStaking$4 = [
    [features_noStaking$4],
    [learn$a],
    [prices$9, news$a],
    [company$a],
];
const tablet_global_noStaking$4 = [
    [features_noStaking$4, prices$9, news$a],
    [learn$a, company$a],
];
const mobile_global_noStaking$4 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$a,
    },
    ...desktop_global_noStaking$4.flatMap((menu) => menu),
];
const footer_br_noStaking = {
    products: desktop_products$a,
    desktop: desktop_global_noStaking$4,
    tablet: tablet_global_noStaking$4,
    mobile: mobile_global_noStaking$4,
};

const legal_ca = [
    {
        key: 'complaint_brochure',
        name: 'Complaint Brochure',
        href: 'https://crypto.com/document/cad_card_compliants_brochure',
    },
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/canada',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$9 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.NFTtoken'],
];
const features$7 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
    ],
};
const learn$9 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$8 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_cad_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$9 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$9 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$7 = [
    [features$7],
    [learn$9],
    [prices$8, news$9],
    [company$9],
];
const tablet_global$7 = [
    [features$7, prices$8, news$9],
    [learn$9, company$9],
];
const mobile_global$7 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$9,
    },
    ...desktop_global$7.flatMap((menu) => menu),
];
const footer_ca = {
    products: desktop_products$9,
    desktop: desktop_global$7,
    tablet: tablet_global$7,
    mobile: mobile_global$7,
};

const certificates = [
    {
        src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/certificates/AICPA.webp`,
        alt: 'AICPA SOC security logo',
        width: 100,
        height: 100,
    },
    {
        src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/certificates/SGS27701.webp`,
        alt: 'SGS ISO 27701 security logo',
        width: 100,
        height: 100,
    },
    {
        src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/certificates/SGS27001.webp`,
        alt: 'SGS ISO 27001 security logo',
        width: 100,
        height: 100,
    },
    {
        src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/certificates/PCI.webp`,
        alt: 'PCi DSS certified logo',
        width: 166,
        height: 100,
    },
];
const socials = [
    {
        IconComponent: Twitter2,
        href: 'https://twitter.com/cryptocom',
        label: 'Twitter',
    },
    {
        IconComponent: Instagram2,
        href: 'https://www.instagram.com/cryptocomofficial/',
        label: 'Instagram',
    },
    {
        IconComponent: Threads,
        href: 'https://www.threads.net/@cryptocomofficial',
        label: 'Thread',
    },
    {
        IconComponent: Facebook2,
        href: 'https://www.facebook.com/CryptoComOfficial',
        label: 'Facebook',
    },
    {
        IconComponent: Discord2,
        href: 'https://discord.gg/cryptocom',
        label: 'Discord',
    },
    {
        IconComponent: LinkedIn2,
        href: 'https://hk.linkedin.com/company/cryptocom',
        label: 'LinkedIn',
    },
    {
        IconComponent: Reddit2,
        href: 'https://www.reddit.com/r/Crypto_com/',
        label: 'Reddit',
    },
    {
        IconComponent: Telegram2,
        href: 'https://blog.crypto.com/official-crypto-com-telegram-communities/',
        label: 'Telegram',
    },
];

const globalDisclaimers = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.',
];
const usDisclaimers = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.',
    'Crypto.com services are provided by Foris DAX, Inc. and its affiliates (NMLS ID 1966158).',
];
const sgDisclaimers = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App. Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Foris DAX Asia Pte. Ltd. (trading under the brand name “Crypto.com”) may only be able to offer certain products, features and/or services on the Crypto.com App due to potential or actual regulatory restrictions.The Crypto.com Visa Card is issued and distributed by Foris Asia Pte. Ltd. that holds a Major Payment Institution License approved by the Monetary Authority of Singapore (“MAS”), which allows it to provide e-money issuance services, account issuance services, cross border and domestic money transfer services. The Monetary Authority of Singapore (MAS) requires us to provide this risk warning to you as a customer of a digital payment token (DPT) service provider.',
    'Before you:</br>(a) pay  Foris DAX Asia Pte. Ltd. any money or DPT; or</br>(b) pay a third party any money or DPT under an arrangement by Foris DAX Asia Pte. Ltd.,',
    'you should be aware of the following.<ol><li>Foris DAX Asia Pte. Ltd. is licensed by MAS to provide DPT services. Please note that this does not mean you will be able to recover all the money or DPTs you paid to Foris DAX Asia Pte. Ltd. or any other third party referred to above, if Foris DAX Asia Pte. Ltd’s or the third party’s business fails.</br>1A. You should be aware that MAS does not supervise or regulate Foris DAX Asia Pte. Ltd. for the provision of unregulated services . This includes any service of trading digital payment token derivatives such as futures.</li><li>You should not transact in the DPT if you are not familiar with this DPT. This includes how the DPT is created, and how the DPT you intend to transact is transferred or held by Foris DAX Asia Pte. Ltd.</li><li>You should be aware that the value of DPTs may fluctuate greatly. You should buy DPTs only if you are prepared to accept the risk of losing all of the money you put into such tokens.</li><li>You should be aware that Foris DAX Asia Pte. Ltd., as part of its licence to provide DPT services, may offer services related to DPTs which are promoted as having a stable value, commonly known as “stablecoin”.</li></ol>',
];
const eeaDisclaimers = [
    'Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services: 1. execution of orders on behalf of other persons; 2. dealing on own account; and 3. custodian or nominee services to experienced and non-experienced investors.',
    'Any other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
];
const belguimDisclaimers = [
    'Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services: 1. execution of orders on behalf of other persons; 2. dealing on own account; and 3. custodian or nominee services to experienced and non-experienced investors.',
    'Any other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
    "Virtual currencies, real risks. The only guarantee in crypto is risk. For further information on the risks involved, please refer to <a href='https://crypto.com/document/risk_disclosure_be'  target='_blank' style='color: #1199FA'>Risk Disclosure Document</a>.",
];
const spDisclamiers = [
    'Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services: 1. execution of orders on behalf of other persons; 2. dealing on own account; and 3. custodian or nominee services to experienced and non-experienced investors.',
    'Any other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services.',
    'Please note that past performance is not a reliable indicator of future performance.',
    '<b>Aviso a residentes en España</b>',
    'La inversión en criptoactivos no está regulada, puede no ser adecuada para inversores minoristas y perderse la totalidad del importe invertido.',
    "Es importante leer y comprender los riesgos de esta inversión que se explican detalladamente en <a href='https://crypto.com/document/spain_riskdisclosure' target='_blank' style='color: #1199FA'>esta ubicación</a>.",
    'Por favor tenga en cuenta que las rentabilidades pasadas no constituyen un indicador fiable de las rentabilidades futuras.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
];
const ukDisclaimers = [
    'The value of cryptoassets can go down as well as up and returns may be subject to capital gains tax. Cryptoassets are not regulated in the United Kingdom (UK) by the UK Financial Conduct Authority (FCA) and users maintaining cryptoassets are not eligible for Financial Services Compensation Scheme (FSCS) protection or recourse from the Financial Ombudsman Service (FOS).',
    'Foris DAX UK Limited, a company incorporated in the UK with company registration number 12843841 trading under the name “Crypto.com” via the Crypto.com App, is registered with the FCA under the Money Laundering, Terrorist Financing and Transfer of Funds (Information on the Payer) Regulations 2017 to provide cryptoasset services.',
    'Any other products or services offered in the Crypto.com App and advertised on this website are provided by other group companies and are not provided by Foris DAX UK Limited.',
    "Email: <a href='https://chat.crypto.com/' style='color: #1199FA' target='_blank'>contact@crypto.com</a> | Office: Tricor Suite 4th Floor, 50 Mark Lane, London, United Kingdom",
];
const auDisclaimers = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in Australia due to potential or actual regulatory restrictions.',
    "We are a holder of Australian Financial Services License No. 467462 (AFSL) issued by the Australian Securities and Investments Commission. To assist you to decide whether to use our services, our <a href='/document/entity_australia_financial_services_guide.pdf' style='color: #1199FA'>Financial Services Guide (FSG)</a> describes how we are remunerated, compensation arrangements, and how we handle any complaints you may have. Our <a href='/document/entity_australia_product_disclosure_statement.pdf' style='color: #1199FA'>Product Disclosure Statement (PDS)</a> contains important information regarding the Services and is designed to assist eligible potential users in deciding whether to obtain this product.",
    "Our <a href='https://crypto.com/document/au_card_targetmarketdetermination.pdf' target='_blank' style='color: #1199FA'>Target Market Determination (TMD)</a> describes who a product is appropriate for (target market), and any conditions around how the product can be distributed to customers.",
];
const trDisclaimers = [
    'Bu web sitesinin amacı yalnızca Crypto.com Uygulamasında bulunan ürün ve hizmetlerle ilgili bilgileri görüntülemektir. Bu tür ürün ve hizmetlerin hiçbirine erişim sağlamak amaçlanmamıştır. Bu tür ürün ve hizmetlere Crypto.com Uygulamasından erişebilirsiniz.',
    'Crypto.com Uygulamasındaki ürün ve hizmetlerin kullanılabilirliğinin yargısal sınırlamalara tabi olduğunu lütfen unutmayınız.',
    "Foris DAX TR Teknoloji A.Ş. (“Crypto.com” markası altında faaliyet göstermektedir) potansiyel veya fiili düzenleyici kısıtlamalar nedeniyle yalnızca Crypto.com Uygulamasında belirli ürün, özellik ve/veya hizmetleri sunabilir. Foris DAX TR Teknoloji A.Ş. tarafından sunulan Crypto.com Uygulamasındaki ürün, özellik ve/veya hizmetler Uygulamadaki 'Al ve Sat' işlevidir.",
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations.',
    'Foris DAX TR Teknoloji A.Ş. (trading under the brand name “Crypto.com”) may only be able to offer certain products, features and/or services on the Crypto.com App due to potential or actual regulatory restrictions. The products, features and/or services on the Crypto.com App that is offered by Foris DAX TR Teknoloji A.Ş. is the ‘Buy and Sell’ function under the App.',
];
const frDisclaimers = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com  App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.',
    'Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed in Malta as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services in Malta: 1. execution of orders on behalf of other persons; 2. dealing on own account; and 3. custodian or nominee services 4. transfer of VFAs, to experienced and non-experienced investors.',
    'Foris DAX MT Limited is also registered in France by the French Financial Market Authority as a digital asset services provider and consequently authorised to provide the following digital asset services in France: 1. Custody of digital assets; 2. Service of buying or selling digital assets for legal tender; and 3. Service of trading digital assets for other digital assets.Any other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta",
];
const frDisclaimersInFr = [
    "L’objectif de ce site Internet est uniquement de fournir des informations concernant les produits et services disponibles sur l'application Crypto.com. Il n'est pas destiné à offrir l'accès à l'un de ces produits ou services. Vous pouvez obtenir l'accès à ces produits et services sur l'application Crypto.com.",
    "Veuillez noter que la disponibilité des produits et services sur l'application Crypto.com est soumise à des restrictions territoriales ou de juridictions. Crypto.com peut ne pas être en mesure de proposer certains produits, fonctionnalités et/ou services sur l'application Crypto.com dans certaines juridictions en raison de restrictions réglementaires effectives ou potentielles.",
    'Foris DAX MT Limited, une société maltaise portant le numéro de société (C88392) et opérant sous le nom commercial de "Crypto.com" via l\'application Crypto.com, est agréée à Malte en tant que prestataire de services sur actifs financiers virtuels (VFA) de classe 3 par la Malta Financial Services Authority (l’Autorité des services financiers maltaise). Foris DAX MT Limited est autorisée à fournir les services sur VFA suivants à Malte : 1. Exécution d\'ordres pour compte de tiers ; 2. Négociation pour compte propre ; 3. Services de conservation ou d’administration ; et 4. Transfert de VFA, à des investisseurs expérimentés ou non-expérimentés.',
    "Foris DAX MT Limited est également enregistrée en France auprès de l'Autorité des marchés financiers (AMF) en tant que prestataire de services sur actifs numériques (PSAN) et par conséquent autorisée à fournir les services sur actifs numériques suivants en France : 1. Service de conservation pour le compte de tiers d'actifs numériques ou d'accès à des actifs numériques ; 2. Service d'achat ou de vente d'actifs numériques en monnaie ayant cours légal ; et 3. Service d'échange d'actifs numériques contre d'autres actifs numériques.",
    "Tout autre produit ou service proposé via l'application Crypto.com et décrit sur ce site Internet est fourni par d'autres sociétés du groupe et ne relève pas des services réglementés fournis par Foris DAX MT Limited.",
    "Courriel : <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Adresse : Niveau 7, Parc Spinola, Triq Mikiel Ang Borg, St Julians SPK 1000 Malte",
];
const caDisclaimers = [
    "Foris DAX, Inc. and Foris, Inc., collectively doing business as Crypto.com, are each registered with FINTRAC as a foreign Money Services Business. By using this website, you accept our Legal Disclosures, including but not limited to our <a href='https://crypto.com/document/entity_canada.pdf' target='_blank' style='color: #FFFFFF' >Terms & Conditions</a> and <a href='https://crypto.com/document/ca_risk_statement' target='_blank' style='color: #FFFFFF'>Risk Disclosure</a>, and Privacy Notice. All offers, terms, and conditions are subject to change and may be modified by Crypto.com at any time and at its sole discretion.",
    "Crypto.com’s Main App and Exchange are offered through Foris DAX, Inc. Foris DAX, Inc. has filed an application for registration as a restricted dealer in certain Canadian jurisdictions but has not yet obtained registration. Until such time as Foris DAX, Inc. obtains registration, Foris DAX, Inc. has agreed to abide by the terms of an undertaking available at the following <a href='https://www.osc.ca/sites/default/files/2022-08/pre-reg-undertaking_20220803_foris-dax.pdf' target='_blank' style='color: #FFFFFF'>link</a>.",
    "Please read this <a href='https://www.crypto.com/privacy/canada' target='_blank' style='color: #FFFFFF'>Privacy Notice</a> carefully before providing any information about you or any other person.",
];
const caDisclaimersInFr = [
    "Les sociétés Foris DAX, Inc. et Foris, Inc., faisant affaire collectivement sous le nom de Crypto.com, sont, chacune d’elles, dûment inscrites auprès du Centre d’analyse des opérations et déclarations financières du Canada (CANAFE) à titre d’entreprises de services monétaires (ESM). En utilisant ce site Web, vous acceptez notre notice légale, y compris, sans s’y limiter, <a href='https://crypto.com/document/entity_canada_fr.pdf' target='_blank' style='color: #FFFFFF'>les modalités et conditions</a>, <a href='https://crypto.com/document/ca_risk_statement_fr' target='_blank' style='color: #FFFFFF'>la divulgation des risques</a> et l’avis de confidentialité. Toutes les offres, modalités et conditions sont sujettes à changement et peuvent être modifiées par Crypto.com à tout moment et à son entière discrétion.",
    "L’application principale et la plateforme d’échange de Crypto.com sont fournies par Foris DAX, Inc. La société Foris DAX, Inc. a déposé une demande d’inscription à titre de courtier d’exercice restreint dans certaines provinces ou certains territoires canadiens, mais elle n’est pas encore inscrite en tant que tel. En attendant son inscription, Foris DAX, Inc. s’engage à respecter les modalités de l’engagement disponible au <a href='https://www.osc.ca/sites/default/files/2022-08/pre-reg-undertaking_20220803_foris-dax.pdf' target='_blank' style='color: #FFFFFF'>lien suivant.</a>",
];
const itDisclaimersInEN = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.',
    'Foris DAX MT Limited, a company incorporated in Malta with Company number (C88392) trading under the name “Crypto.com” via the Crypto.com app is licensed as a Class 3 Virtual Financial Assets Service Provider by the Malta Financial Services Authority. Foris DAX MT Limited is authorised to provide the following VFA services: 1. execution of orders on behalf of other persons; 2. dealing on own account; 3. custodian or nominee services, 4. transfer of VFAs, to experienced and non-experienced investors.',
    'Foris DAX MT Limited Italian branch, is registered in the special section of the Register for operators in virtual currency managed by the Organismo Agenti e Mediatori (“OAM”) for the purpose of ensuring compliance with applicable obligations provided under Legislative Decree 21 November 2007, No. 231, as from time to time amended and supplemented (“AML Decree”) and implementing regulations thereto, in relation to customers in the Italian territory served by Foris DAX MT Limited.',
    'Any other product or service offered in the Crypto.com App and advertised on this website is provided by other group companies and does not fall within the Foris DAX MT Limited regulated services.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Office: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
];
const itDisclaimersInIT = [
    'Lo scopo del presente sito web è unicamente quello di fornire informazioni relative ai prodotti ed ai servizi disponibili su Crypto.com App. Il presente sito web non è inteso quale mezzo di accesso a detti prodotti e servizi. Lei può avere accesso a detti prodotti e servizi per il tramite di Crypto.com App.',
    'Si prega di notare che la disponibilità dei prodotti e dei servizi su Crypto.com App è soggetta a limitazioni giurisdizionali. Crypto.com non può offrire determinati prodotti, funzionalità e/o servizi disponibili su Crypto.com App in determinate giurisdizioni a causa di limitazioni regolamentari, attuali o potenziali.',
    'Foris DAX MT Limited, una società costituita a Malta con numero di registrazione (C88392), operante con il nome commerciale “Crypto.com” per il tramite di Crypto.com App, è autorizzata quale Class 3 Virtual Financial Assets Service Provider dalla Malta Financial Services Authority. Foris DAX MT Limited è autorizzata a fornire i seguenti servizi VFA: 1. esecuzione di ordini per conto di soggetti terzi; 2. negoziazione in conto proprio; e 3. servizi di custodia e intestazione, 4. trasferimento di VFA, a favore di investitori esperti e non esperti.',
    "Foris DAX MT Limited, filiale italiana, è registrata nella sezione speciale dell’albo tenuto dall’Organismo Agenti e Mediatori (“OAM”) quale prestatore di servizi relativi all'utilizzo di valuta virtuale, al fine di assicurare la conformità agli obblighi applicabili previsti dal Decreto Legislativo n. 231 del 21 novembre 2007, come di volta in volta modificato (“Decreto AML”) e dai relativi regolamenti attuativi, in relazione ai clienti assistiti da Foris DAX MT Limited nella Repubblica Italiana.",
    'Qualunque altro prodotto o servizio offerto per il tramite della Crypto.com App e pubblicizzato per il tramite del presente sito web è fornito da altre società del gruppo e non rientra tra i servizi regolamentati forniti da Foris DAX MT Limited.',
    "Email: <a href='https://chat.crypto.com/' target='_blank' style='color: #1199FA'>contact@crypto.com</a> | Sede: Level 7, Spinola Park, Triq Mikiel Ang Borg, St Julians SPK 1000 Malta.",
];
const krDisclaimersInEn = [
    'The purpose of this website is solely to display information regarding the products and services available on the Crypto.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Crypto.com App.',
    'Please note that the availability of the products and services on the Crypto.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Crypto.com App in certain jurisdictions due to potential or actual regulatory restrictions.',
    'Foris DAX Korea Limited. Suite 802, 8F, Jongno 3gil 17, Jongno gu, Seoul, South Korea. CEO: Rafa DE MARCO E MELO.\nBusiness Registration Number: 885-88-00694CS. Contact information: 1588-9520',
];
const krDisclaimersInKO = [
    '이 웹사이트는 Crypto.com 앱에서 사용할 수 있는 제품 및 서비스에 대한 정보만을 표기하고 있으며, 제품 및 서비스에 대한 엑세스를 제공하지 않습니다. 귀하는 Crypto.com  앱에서 이러한 제품 및 서비스에 대한 액세스 권한을 얻을 수 있습니다.',
    'Crypto.com  앱에서 제품 및 서비스의 가용성은 관할권 제한에 따릅니다. Crypto.com은 잠재적 또는 실제 규제 제한으로 인해 특정 관할권에서  Crypto.com  앱에 특정제품, 기능 및 서비스를 제공하지 않을 수 있습니다.',
    '대한민국 관할권 내 Crypto.com  웹사이트 및 앱은 주식회사 포리스닥스코리아리미티드가 제공하고 있습니다',
    '주식회사 포리스닥스코리아리미티드(Foris DAX Korea Limited)',
    '주소: 서울시 종로구 종로3길 17 8층, 802호, 대한민국',
    'CEO: 라파엘드마르코이멜로',
    '사업자등록번호: 885-88-00694',
    '전화번호: 1588-9520',
];
const GlobalLegalStatement = `Copyright © 2018 - ${new Date().getFullYear()} Crypto.com. All rights reserved.`;
const CALegalStatement = `© ${new Date().getFullYear()} Foris DAX, Inc. and Foris, Inc. collectively dba Crypto.com . All rights reserved.`;
const CALegalStatementInFR = `© ${new Date().getFullYear()} Foris DAX, Inc. et Foris, Inc. faisant affaire collectivement sous le nom de Crypto.com . Tous droits réservés.`;

const legal_eea = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: 'https://crypto.com/privacy/global/html',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$8 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const getFeaturesEEA = (isStakingAccess, isRewardsAccess) => {
    return {
        tTitle: 'footer.section.features',
        tBadgeTitle: null,
        href: null,
        items: [
            isRewardsAccess ? links$1['products.rewards'] : null,
            links$1['products.buyAndSell'],
            links$1['products.earn'],
            isStakingAccess ? links$1['products.onChainStaking'] : null,
            links$1['products.pay'],
            links$1['products.payMerchant'],
            links$1['products.marginTrading'],
            links$1['products.derivativesTrading'],
            links$1['products.supercharger'],
            links$1['products.tradingArena'],
        ].filter((product) => product !== null),
    };
};
const learn$8 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$7 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_eur_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$8 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$8 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.eea_complaints'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const get_desktop_eea = (isStakingAccess, isRewardsAccess) => [
    [getFeaturesEEA(isStakingAccess, isRewardsAccess)],
    [learn$8],
    [prices$7, news$8],
    [company$8],
];
const get_tablet_eea = (isStakingAccess, isRewardsAccess) => [
    [getFeaturesEEA(isStakingAccess, isRewardsAccess), prices$7, news$8],
    [learn$8, company$8],
];
const get_mobile_eea = (isStakingAccess, isRewardsAccess) => [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$8,
    },
    ...get_desktop_eea(isStakingAccess, isRewardsAccess).flatMap((menu) => menu),
];
const get_footer_eea = (isStakingAccess, isRewardsAccess) => {
    return {
        products: desktop_products$8,
        desktop: get_desktop_eea(isStakingAccess, isRewardsAccess),
        tablet: get_tablet_eea(isStakingAccess, isRewardsAccess),
        mobile: get_mobile_eea(isStakingAccess, isRewardsAccess),
    };
};

const legal_fr = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/france',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$7 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$6 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.onChainStaking'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
    ],
};
const learn$7 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$6 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_eur_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$7 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$7 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$6 = [
    [features$6],
    [learn$7],
    [prices$6, news$7],
    [company$7],
];
const tablet_global$6 = [
    [features$6, prices$6, news$7],
    [learn$7, company$7],
];
const mobile_global$6 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$7,
    },
    ...desktop_global$6.flatMap((menu) => menu),
];
const footer_fr = {
    products: desktop_products$7,
    desktop: desktop_global$6,
    tablet: tablet_global$6,
    mobile: mobile_global$6,
};
const features_noStaking$3 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
    ],
};
const desktop_global_noStaking$3 = [
    [features_noStaking$3],
    [learn$7],
    [prices$6, news$7],
    [company$7],
];
const tablet_global_noStaking$3 = [
    [features_noStaking$3, prices$6, news$7],
    [learn$7, company$7],
];
const mobile_global_noStaking$3 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$7,
    },
    ...desktop_global_noStaking$3.flatMap((menu) => menu),
];
const footer_fr_noStaking = {
    products: desktop_products$7,
    desktop: desktop_global_noStaking$3,
    tablet: tablet_global_noStaking$3,
    mobile: mobile_global_noStaking$3,
};

const legal_global = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/global.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$6 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const getFeatures = (isStakingAccess, isRewardsAccess) => {
    return {
        tTitle: 'footer.section.features',
        tBadgeTitle: null,
        href: null,
        items: [
            isRewardsAccess ? links$1['products.rewards'] : null,
            links$1['products.buyAndSell'],
            links$1['products.earn'],
            isStakingAccess ? links$1['products.onChainStaking'] : null,
            links$1['products.pay'],
            links$1['products.payMerchant'],
            links$1['products.marginTrading'],
            links$1['products.derivativesTrading'],
            links$1['products.supercharger'],
            links$1['products.tradingArena'],
        ].filter((product) => product !== null),
    };
};
const learn$6 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$5 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_usd_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$6 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$6 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const get_desktop_global = (isStakingAccess, isRewardsAccess) => [
    [getFeatures(isStakingAccess, isRewardsAccess)],
    [learn$6],
    [prices$5, news$6],
    [company$6],
];
const get_tablet_global = (isStakingAccess, isRewardsAccess) => [
    [getFeatures(isStakingAccess, isRewardsAccess), prices$5, news$6],
    [learn$6, company$6],
];
const get_mobile_global = (isStakingAccess, isRewardsAccess) => [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$6,
    },
    ...get_desktop_global(isStakingAccess, isRewardsAccess).flatMap((menu) => menu),
];
const get_footer_global = (isStakingAccess, isRewardsAccess) => {
    return {
        products: desktop_products$6,
        desktop: get_desktop_global(isStakingAccess, isRewardsAccess),
        tablet: get_tablet_global(isStakingAccess, isRewardsAccess),
        mobile: get_mobile_global(isStakingAccess, isRewardsAccess),
    };
};

const legal_it = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/italy.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$5 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$5 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.onChainStaking'],
        links$1['products.pay'],
    ],
};
const learn$5 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$4 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_eur_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$5 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$5 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$5 = [
    [features$5],
    [learn$5],
    [prices$4, news$5],
    [company$5],
];
const tablet_global$5 = [
    [features$5, prices$4, news$5],
    [learn$5, company$5],
];
const mobile_global$5 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$5,
    },
    ...desktop_global$5.flatMap((menu) => menu),
];
const footer_it = {
    products: desktop_products$5,
    desktop: desktop_global$5,
    tablet: tablet_global$5,
    mobile: mobile_global$5,
};
const features_noStaking$2 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
    ],
};
const desktop_global_noStaking$2 = [
    [features_noStaking$2],
    [learn$5],
    [prices$4, news$5],
    [company$5],
];
const tablet_global_noStaking$2 = [
    [features_noStaking$2, prices$4, news$5],
    [learn$5, company$5],
];
const mobile_global_noStaking$2 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$5,
    },
    ...desktop_global_noStaking$2.flatMap((menu) => menu),
];
const footer_it_noStaking = {
    products: desktop_products$5,
    desktop: desktop_global_noStaking$2,
    tablet: tablet_global_noStaking$2,
    mobile: mobile_global_noStaking$2,
};

const legal_kr = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: 'https://crypto.com/privacy/southkorea',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$4 = [
    links$1['products.app'],
    links$1['products.NFTtoken'],
];
const features$4 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [links$1['products.buyAndSell']],
};
const learn$4 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const news$4 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$4 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$4 = [[features$4], [learn$4], [news$4], [company$4]];
const tablet_global$4 = [
    [features$4, news$4],
    [learn$4, company$4],
];
const mobile_global$4 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$4,
    },
    ...desktop_global$4.flatMap((menu) => menu),
];
const footer_kr = {
    products: desktop_products$4,
    desktop: desktop_global$4,
    tablet: tablet_global$4,
    mobile: mobile_global$4,
};

const legal_sg = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/entity_singapore.pdf',
    },
    {
        key: 'card_privacy_notice',
        name: 'Card Privacy Notice',
        href: '/privacy/card_singapore.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$3 = [
    links$1['products.app'],
    links$1['products.visaCard'],
];
const features$3 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
    ],
};
const learn$3 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [links$1['learn.research'], links$1['learn.glossary']],
};
const prices$3 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_sgd_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$3 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$3 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$3 = [
    [features$3],
    [learn$3],
    [prices$3, news$3],
    [company$3],
];
const tablet_global$3 = [
    [features$3, prices$3, news$3],
    [learn$3, company$3],
];
const mobile_global$3 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$3,
    },
    ...desktop_global$3.flatMap((menu) => menu),
];
const footer_sg = {
    products: desktop_products$3,
    desktop: desktop_global$3,
    tablet: tablet_global$3,
    mobile: mobile_global$3,
};

const legal_tr = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/turkey.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$2 = [
    links$1['products.app'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$2 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.onChainStaking'],
        links$1['products.payMerchant'],
    ],
};
const learn$2 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices$2 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_usd_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$2 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$2 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$2 = [
    [features$2],
    [learn$2],
    [prices$2, news$2],
    [company$2],
];
const tablet_global$2 = [
    [features$2, prices$2, news$2],
    [learn$2, company$2],
];
const mobile_global$2 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$2,
    },
    ...desktop_global$2.flatMap((menu) => menu),
];
const footer_tr = {
    products: desktop_products$2,
    desktop: desktop_global$2,
    tablet: tablet_global$2,
    mobile: mobile_global$2,
};
const features_noStaking$1 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.payMerchant'],
    ],
};
const desktop_global_noStaking$1 = [
    [features_noStaking$1],
    [learn$2],
    [prices$2, news$2],
    [company$2],
];
const tablet_global_noStaking$1 = [
    [features_noStaking$1, prices$2, news$2],
    [learn$2, company$2],
];
const mobile_global_noStaking$1 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$2,
    },
    ...desktop_global_noStaking$1.flatMap((menu) => menu),
];
const footer_tr_noStaking = {
    products: desktop_products$2,
    desktop: desktop_global_noStaking$1,
    tablet: tablet_global_noStaking$1,
    mobile: mobile_global_noStaking$1,
};

const legal_uk = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/uk',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
];
const desktop_products$1 = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.exchange'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features$1 = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.onChainStaking'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
        links$1['products.supercharger'],
    ],
};
const learn$1 = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
    ],
};
const prices$1 = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_gbp_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news$1 = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company$1 = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global$1 = [
    [features$1],
    [learn$1],
    [prices$1, news$1],
    [company$1],
];
const tablet_global$1 = [
    [features$1, prices$1, news$1],
    [learn$1, company$1],
];
const mobile_global$1 = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$1,
    },
    ...desktop_global$1.flatMap((menu) => menu),
];
const footer_uk = {
    products: desktop_products$1,
    desktop: desktop_global$1,
    tablet: tablet_global$1,
    mobile: mobile_global$1,
};
const features_noStaking = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
        links$1['products.supercharger'],
    ],
};
const desktop_global_noStaking = [
    [features_noStaking],
    [learn$1],
    [prices$1, news$1],
    [company$1],
];
const tablet_global_noStaking = [
    [features_noStaking, prices$1, news$1],
    [learn$1, company$1],
];
const mobile_global_noStaking = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products$1,
    },
    ...desktop_global_noStaking.flatMap((menu) => menu),
];
const footer_uk_noStaking = {
    products: desktop_products$1,
    desktop: desktop_global_noStaking,
    tablet: tablet_global_noStaking,
    mobile: mobile_global_noStaking,
};

const legal_us = [
    {
        key: 'privacy_notice',
        name: 'Privacy Notice',
        href: '/privacy/privacy_us.pdf',
    },
    {
        key: 'Do Not Sell My Personal Information',
        name: 'Do Not Sell My Personal Information',
        href: '/us/personal',
    },
    {
        key: 'legal',
        name: 'Legal',
        href: '/document/legal_us.pdf',
    },
    {
        key: 'status',
        name: 'Status',
        href: 'https://status.crypto.com',
    },
    {
        key: 'usT&C',
        name: 'U.S. Terms and Conditions',
        href: 'https://crypto.com/document/entity_us.pdf',
    },
];
const desktop_products = [
    links$1['products.app'],
    links$1['products.visaCard'],
    links$1['products.defiWallet'],
    links$1['products.NFTtoken'],
];
const features = {
    tTitle: 'footer.section.features',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.rewards'],
        links$1['products.buyAndSell'],
        links$1['products.earn'],
        links$1['products.pay'],
        links$1['products.payMerchant'],
        links$1['products.updownOptions'],
        links$1['products.strikeOptions'],
    ],
};
const learn = {
    tTitle: 'footer.section.learn',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.university'],
        links$1['learn.research'],
        links$1['learn.glossary'],
        links$1['learn.bitcoin'],
        links$1['learn.eth'],
        links$1['learn.blockchain'],
        links$1['learn.buyBitcoin'],
        links$1['learn.buyEth'],
        links$1['learn.buyCrypto'],
        links$1['learn.crypto'],
        links$1['learn.defi'],
    ],
};
const prices = {
    tTitle: 'footer.section.prices',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['products.prices'],
        links$1['products.pricesBitcoin'],
        links$1['products.pricesEth'],
        links$1['products.btc_usd_converter'],
        links$1['products.siteWidgets'],
    ],
};
const news = {
    tTitle: 'footer.section.news',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['learn.trending'],
        links$1['learn.marketUpdates'],
        links$1['learn.productNews'],
        links$1['company.news'],
        links$1['learn.events'],
    ],
};
const company = {
    tTitle: 'footer.section.company',
    tBadgeTitle: null,
    href: null,
    items: [
        links$1['company.aboutUs'],
        links$1['company.partners'],
        links$1['company.security'],
        links$1['products.proofOfReserves'],
        links$1['products.tax'],
        links$1['company.climate'],
        links$1['company.capital'],
        links$1['company.affiliate'],
        links$1['company.careers'],
        links$1['company.listing'],
        links$1['company.support'],
    ],
};
const desktop_global = [
    [features],
    [learn],
    [prices, news],
    [company],
];
const tablet_global = [
    [features, prices, news],
    [learn, company],
];
const mobile_global = [
    {
        tTitle: 'footer.section.products',
        tBadgeTitle: null,
        href: null,
        items: desktop_products,
    },
    ...desktop_global.flatMap((menu) => menu),
];
const footer_us = {
    products: desktop_products,
    desktop: desktop_global,
    tablet: tablet_global,
    mobile: mobile_global,
};

const StyledContainer = styled(Flex) `
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  flex-wrap: wrap;
  display: none;

  @media ${mobileFirstDevice.tablet} {
    align-items: center;
    justify-content: flex-start;
    display: flex;
    margin-top: 24px;
  }
  @media ${mobileFirstDevice.laptop} {
    align-items: center;
    max-width: 173px;
    justify-content: space-between;
    row-gap: 16px;
  }
`;
const Img = styled.img `
  height: 100%;
`;
const Certificates = () => {
    return (jsx(StyledContainer, { children: certificates.map((props, index) => (jsx(Box, { height: "50px", width: '50px', children: jsx(Img, { ...props, loading: "lazy", referrerPolicy: "no-referrer", style: { height: '100%', width: '100%' } }) }, index))) }));
};

const DEFAULT_GEO_COUNTRY = 'GLOBAL';
const useGeoLocation = () => {
    const [geoCountry, setGeoCountry] = useState(DEFAULT_GEO_COUNTRY);
    useEffect(() => {
        if (localStorage && localStorage.getItem('@NAV/CUSTOM_COUNTRY')) {
            setGeoCountry(localStorage.getItem('@NAV/CUSTOM_COUNTRY') ?? DEFAULT_GEO_COUNTRY);
            return;
        }
        const fetchGeoLocation = async () => {
            const result = await fetch('https://crypto.com/cdn-cgi/trace').then((response) => response.text());
            const matches = result.match(/loc=([A-Z]+)/);
            if (matches && matches[1]) {
                return matches[1];
            }
            return DEFAULT_GEO_COUNTRY;
        };
        fetchGeoLocation().then((country) => setGeoCountry(country));
    }, []);
    return { geoCountry, geoRegion: getRegion(geoCountry) };
};

const geoLocationDefault = {
    geoCountry: DEFAULT_GEO_COUNTRY,
    geoRegion: RegionsEnum.GLOBAL,
};
const NavFooterContext = createContext({
    country: RegionsEnum.GLOBAL,
    geoLocation: geoLocationDefault,
    site: Site.MKT,
});
const NavFooterProvider = ({ Link, langChangeCallback, countryChangeCallback, hasLangCountrySwitch, hasSearchBar, onSearch, country, geoLocation, children, site, }) => {
    return (jsx(NavFooterContext.Provider, { value: {
            Link,
            country,
            langChangeCallback,
            countryChangeCallback,
            hasLangCountrySwitch,
            hasSearchBar,
            onSearch,
            geoLocation: geoLocation ?? geoLocationDefault,
            site,
        }, children: children }));
};

const chUniversityAvailableLanguages = [
    'en',
    'es',
    'fr',
    'it',
    'pt',
    'tr',
    'id',
    'pt-BR',
    'ko',
];
const chEventsAvailableLanguages = ['en', 'fr', 'it', 'tr', 'pt-BR'];
const Link = ({ href, id, style, isExternal, base, ...restProps }) => {
    const context = useContext(NavFooterContext);
    const { i18n } = useTranslation();
    //For multiple-lang university
    let chref = href;
    if ((/^https?:\/\/[^/]+\/university/.test(href) || href === '/university') &&
        chUniversityAvailableLanguages.includes(i18n.language) &&
        i18n.language !== 'en') {
        chref = href.replace('/university', `/university/${i18n.language.toLowerCase()}`);
    }
    if ((/^https?:\/\/[^/]+\/events/.test(href) || href === '/events') &&
        chEventsAvailableLanguages.includes(i18n.language) &&
        i18n.language !== 'en') {
        chref = href.replace('/events', `/events/${i18n.language.toLowerCase()}`);
    }
    //For mkt region
    if (base === Site.MKT &&
        !chref.startsWith('http') &&
        context.country !== RegionsEnum.GLOBAL) {
        chref = `/${context.country.toLowerCase()}${href}`;
    }
    if (isExternal ||
        chref.startsWith('http') ||
        chref.startsWith('mailto:') ||
        // NOTE removed header and footer on all `/privacy/xxx` path page, therefore need a new tab for privacies
        chref.startsWith('/privacy') ||
        context.Link === undefined) {
        return jsx("a", { href: chref, id: id, style: style, ...restProps });
    }
    return base !== context.site ? (jsx("div", { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = chref;
        }, children: jsx("a", { href: `${chref}`, style: style, ...restProps }) })) : (jsx("div", { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = chref;
        }, children: jsx(context.Link, { href: chref, style: style, ...restProps }) }));
};

const CSContact = () => {
    const { t } = useTranslation('navigation');
    return (jsxs(Flex, { flexDirection: 'row', customCss: { gap: [2, '20px'] }, children: [jsxs(Flex, { flexDirection: 'column', children: [jsx(ForwardedTypography, { color: '#F7F9FA', variant: "p", fontWeight: 700, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: t('footer.br_contact_info') }), jsx(Link, { href: `mailto:${email}`, children: jsx(ForwardedTypography, { color: 'primaryBrightBlue', variant: "p", fontWeight: 400, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: email }) }), jsx(ForwardedTypography, { color: 'primaryBrightBlue', variant: "p", fontWeight: 400, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: phoneDepartment }), jsx(ForwardedTypography, { color: '#C9CFDD', variant: "p", fontWeight: 400, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: t('footer.br_contact_schedule') })] }), jsxs(Flex, { flexDirection: 'column', children: [jsx(ForwardedTypography, { color: '#F7F9FA', variant: "p", fontWeight: 700, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: t('footer.br_ombudsman') }), jsx(ForwardedTypography, { color: 'primaryBrightBlue', variant: "p", fontWeight: 400, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: phoneOmbudsman }), jsx(ForwardedTypography, { color: '#C9CFDD', variant: "p", fontWeight: 400, fontSize: 12, lineHeight: '150%', letterSpacing: '0.01em', children: t('footer.br_ombudsman_schedule') })] })] }));
};
const email = 'contact@crypto.com';
const phoneDepartment = '0800-878-4083';
const phoneOmbudsman = '0800-878-3059';

const Social$1 = ({ iconSize, ...restProps }) => {
    return (jsx(Box, { ...restProps, children: socials.map(({ href, IconComponent, label }) => (jsx(Link, { href: href, "aria-label": label, style: { lineHeight: '0' }, children: jsx(IconComponent, { width: iconSize, height: iconSize, alignItems: "center", justifyContent: "center", border: "1px solid #323C52", borderRadius: "24px", customCss: { '&:hover': { border: '1px solid #EAEEF4' } } }) }, href))) }));
};
const IconHeight = ['30px', '30px', '40px'];
const HeroLogo = ({ ...restProps }) => {
    return (jsxs(Flex, { width: "100%", height: IconHeight, alignItems: 'center', ...restProps, children: [jsx(CdcLogo, { height: IconHeight }), jsx(Box, { height: "1px", backgroundColor: '#323C52', display: ['none', 'flex', 'flex'], flex: "1 1", mx: "20px" }), jsx(Social$1, { display: ['none', 'flex', 'flex'], customCss: { gap: ['8px', '8px', '12px'] }, iconSize: IconHeight })] }));
};

const LegalSection = ({ links, isShowEALogo, legalStatement, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Flex, { flexDirection: ['column', 'column', 'row'], children: jsxs(Flex, { flexDirection: ['column', 'row'], alignItems: ['start', 'center'], flexWrap: 'wrap', flex: '1 1', customCss: { rowGap: '12px' }, justifyContent: 'space-between', children: [jsx(ForwardedTypography, { variant: "p", fontSize: [12], lineHeight: '11px', fontWeight: 400, color: "#A0A9BE", marginRight: [0, 2, 3], children: legalStatement }), jsxs(Flex, { alignItems: "center", flexWrap: "wrap", mt: [1, 0, 0], customCss: { rowGap: '8px' }, children: [links.map(({ key, name, href }, index) => (jsx(Flex, { paddingRight: 1, marginRight: index !== links.length - 1 ? 1 : 0, borderRight: index !== links.length - 1
                                ? '1px solid rgba(244, 244, 244, 0.5)'
                                : 'unset', children: jsx(Link, { href: href, isExternal: true, children: jsx(ForwardedTypography, { variant: "p", fontSize: [12], lineHeight: '11px', fontWeight: 500, color: "#A0A9BE", children: t(`footer.${key}`, name) }) }) }, key))), jsx(ForwardedTypography, { variant: "p", fontSize: [12], lineHeight: '11px', fontWeight: 500, color: "#A0A9BE", paddingLeft: 1, borderLeft: '1px solid rgba(244, 244, 244, 0.5)', children: jsx("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings", style: {
                                    fontSize: 12,
                                    fontWeight: 500,
                                    backgroundColor: 'transparent',
                                    color: '#A0A9BE',
                                    border: 'none',
                                    padding: 0,
                                }, children: "Cookie Preferences" }) })] })] }) }));
};

// TODO: hardcoded. need to abstract to theme
const Row = styled(Flex) `
  ${css({
    mx: ['-8px', '0px', '-10px'],
    flexWrap: 'wrap',
})}
`;

const LinkSections = ({ menuData, menuWidth, ...restProps }) => {
    const { t } = useTranslation('navigation');
    const renderMenuItem = ({ tTitle, href, base }) => (jsx(Link, { href: href, base: base, children: jsx(Text, { variant: "t4", color: "#EAEEF4", as: "p", children: t(tTitle) }) }));
    const renderColumn = ({ tTitle, items }) => (jsxs(Fragment, { children: [jsx(Text, { variant: "h4", color: "#EAEEF4", mb: 2, children: t(tTitle) }), items.map((item, i) => (jsx(Box, { mb: i !== items.length - 1 ? 1 : 0, width: "fit-content", children: renderMenuItem(item) }, item.tTitle)))] }));
    return (jsx(Row, { ...restProps, justifyContent: "space-between", children: menuData.map((columnItems, i) => {
            return (jsx(Flex, { flexDirection: "column", width: menuWidth, pl: "0px", flex: "1 1", children: columnItems.map((column, i) => (jsx(Box, { mb: i !== columnItems.length - 1 ? 4 : 0, children: renderColumn(column) }, i))) }, i));
        }) }));
};

const buttonFontBase = {
    fontFamily: 'heading',
    fontSize: [17, 16, 21],
    lineHeight: '1em',
    letterSpacing: ['0.02em', '0.015em', '0.02em'],
    fontWeight: ['600', '600', '600'],
};
const leadingTrimStyle = {
    mt: buttonFontBase.fontSize.map((fontSize) => `-${fontSize * 0.25}px`),
    transform: buttonFontBase.fontSize.map((fontSize) => `translateY(${fontSize * 0.25}px)`),
};
const primaryButtonBase = {
    ...buttonFontBase,
    whiteSpace: 'nowrap',
    borderWidth: 1.5,
    borderStyle: 'solid',
    transition: 'all 0.2s',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    display: 'inline-flex',
};
const secondaryButtonBase = {
    ...buttonFontBase,
    whiteSpace: 'nowrap',
    px: 3,
    height: 58,
    borderWidth: [1, 0.5],
    borderStyle: 'solid',
    transition: 'all 0.2s',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    display: 'inline-flex',
};
const Button = styled(Box) `
  border: none;
  cursor: pointer;
  outline: none;
  ${variant({
    variants: {
        primaryBlueLightBg: {
            ...primaryButtonBase,
            px: 4,
            height: 60,
            bg: '#0058AA',
            color: '#fff',
            borderColor: 'transparent',
        },
        primaryBlue: {
            ...primaryButtonBase,
            px: 4,
            height: 60,
            bg: '#1199FA',
            color: '#fff',
            borderColor: 'transparent',
        },
        primaryDark: {
            ...primaryButtonBase,
            px: 4,
            height: 60,
            bg: 'primaryPaleWhite',
            color: 'secondaryDarkNavy',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'primaryBrightBlue',
                bg: 'transparent',
                color: 'primaryPaleWhite',
            },
        },
        primaryLight: {
            ...primaryButtonBase,
            px: 4,
            height: 60,
            bg: 'secondaryDarkNavy',
            color: 'primaryPaleWhite',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'secondaryDarkNavy',
                bg: 'transparent',
                color: 'secondaryDarkNavy',
            },
        },
        primarySmallDark: {
            ...primaryButtonBase,
            px: 3,
            height: 52,
            bg: 'primaryPaleWhite',
            color: 'secondaryDarkNavy',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'primaryBrightBlue',
                bg: 'transparent',
                color: 'primaryPaleWhite',
            },
        },
        primarySmallLight: {
            ...primaryButtonBase,
            px: 3,
            height: 52,
            bg: 'secondaryDarkNavy',
            color: 'primaryPaleWhite',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'secondaryDarkNavy',
                bg: 'transparent',
                color: 'secondaryDarkNavy',
            },
        },
        primaryExtraSmallDark: {
            ...primaryButtonBase,
            px: [1.5, 3, 3],
            height: [40, 42, 48],
            bg: 'primaryPaleWhite',
            color: 'secondaryDarkNavy',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'primaryBrightBlue',
                bg: 'transparent',
                color: 'primaryPaleWhite',
            },
        },
        primaryExtraSmallLight: {
            ...primaryButtonBase,
            px: [1.5, 3, 3],
            height: [40, 42, 48],
            bg: 'secondaryDarkNavy',
            color: 'primaryPaleWhite',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: 'secondaryDarkNavy',
                bg: 'transparent',
                color: 'secondaryDarkNavy',
            },
        },
        secondaryDark: {
            ...secondaryButtonBase,
            borderColor: 'primaryPaleWhite',
            bg: 'transparent',
            color: 'white',
            '&:hover': {
                bg: 'secondaryDarkButtonHoverBg',
            },
        },
        exchangeButton: {
            ...secondaryButtonBase,
            bg: 'transparent',
            borderColor: 'secondaryDarkNavy',
            color: 'secondaryDarkNavy',
        },
        secondaryLight: {
            ...secondaryButtonBase,
            borderColor: 'secondaryDarkNavy',
            bg: 'transparent',
            color: 'secondaryDarkNavy',
            '&:hover': {
                bg: 'secondaryLightButtonHoverBg',
            },
        },
        secondaryBlue: {
            ...secondaryButtonBase,
            borderColor: 'secondaryPartnerBlue',
            bg: 'transparent',
            color: 'secondaryPartnerBlue',
            '&:hover': {
                bg: 'secondaryLightButtonHoverBg',
            },
        },
        plain: {
            bg: 'transparent',
            p: 0,
            textAlign: 'left',
        },
        navMenu: {
            bg: 'transparent',
            px: [4, 8],
            textAlign: 'left',
        },
    },
})}
`;
const ForwardedButton = ({ children, ...props }) => {
    return (jsx(Button, { as: "button", ...props, children: Children.map(children, (child) => {
            if (typeof child === 'string') {
                return jsx(Box, { customCss: leadingTrimStyle, children: child });
            }
            return child;
        }) }));
};
ForwardedButton.displayName = 'Button';

const MobileMenuItem$1 = ({ title, menuContent, href, isExpanded, onClick, }) => {
    const renderContent = () => (jsxs(Fragment, { children: [jsxs(Flex, { alignItems: "center", justifyContent: "space-between", children: [jsx(Flex, { alignItems: "center", children: jsx(Text, { variant: "h3_m", color: "#EAEEF4", children: title }) }), onClick && menuContent && (jsx(ChevronDown, { width: "14px", color: "#EAEEF4", customCss: isExpanded
                            ? {
                                fill: '#EAEEF4',
                                transform: 'rotate(180deg)',
                                transition: 'transform 0.5s ease',
                            }
                            : {
                                fill: '#EAEEF4',
                                transform: 'rotate(0deg)',
                                transition: 'transform 0.5s ease',
                            } }))] }), jsx(AnimatePresence, { initial: false, children: isExpanded && (jsx(m.div, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                        open: { opacity: 1, height: 'auto', marginTop: '12px' },
                        collapsed: { opacity: 1, height: 0, marginTop: '0px' },
                    }, transition: { duration: 0.3 }, style: {
                        overflow: 'hidden',
                        marginLeft: '-24px',
                        marginRight: '-24px',
                    }, children: menuContent })) })] }));
    if (href) {
        return jsx(Link, { href: href, children: renderContent() });
    }
    return (jsx(ForwardedButton, { variant: "plain", width: "100%", onClick: onClick, children: renderContent() }));
};

const MobileMenu$1 = ({ menuData }) => {
    const { t } = useTranslation('navigation');
    const [expandedIndex, setExpandedIndex] = useState(null);
    const handleMenuItemClick = (i) => () => {
        if (i === expandedIndex) {
            setExpandedIndex(null);
            return;
        }
        setExpandedIndex(i);
    };
    const renderSubmenuItem = ({ tTitle, href, base }) => (jsx(Link, { href: href, base: base, children: jsx(Text, { variant: "t1_m", color: "#C9CFDD", children: t(tTitle) }) }));
    return (jsx(Fragment, { children: menuData.map(({ tTitle, href, items }, i) => {
            return (jsx(Box, { mb: i !== menuData.length - 1 ? 4 : 0, children: jsx(MobileMenuItem$1, { title: t(tTitle), href: href, menuContent: items?.length > 0 && (jsx(Box, { py: '16px', backgroundColor: "rgba(17, 153, 250, 0.05);", children: items.map((item, i) => (jsx(Box, { mb: i !== items.length - 1 ? 3 : 0, ml: 5, children: renderSubmenuItem(item) }, item.tTitle))) })), isExpanded: expandedIndex === i, onClick: handleMenuItemClick(i) }) }, tTitle));
        }) }));
};

const iconHeight = '24px';
const iconAnimationCss = {
    borderLeft: '1px solid #fff',
    transition: 'padding 0.3s, border-left 0.3s',
    '&:hover': {
        borderLeft: '2px solid #1199fa',
        paddingLeft: '5px',
    },
};
const Products = ({ products, ...restProps }) => (jsx(Flex, { flexDirection: 'column', customCss: { gap: '20px' }, justifyContent: 'flex-start', ...restProps, children: products.map((product) => {
        return (jsx(Link, { href: product.href, "aria-label": product.tTitle, children: product.icon && (jsx(product.icon, { height: iconHeight, customCss: iconAnimationCss })) }, product.href));
    }) }));

// TODO: Move to ./reactHelpers
const useEffectOnce = (effect) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, []);
};

// TODO: Move to ./reactHelpers
const useMount = (fn) => {
    useEffectOnce(fn);
};

const NoSSR = ({ children }) => {
    const [isMounted, setIsMounted] = useState(false);
    useMount(() => {
        setIsMounted(true);
    });
    if (!isMounted || !children)
        return null;
    return jsx(Fragment, { children: children });
};

const DownloadButtonBox = styled(Flex) `
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  height: 48px;
  background-color: #0577da;
  color: #f7f9fa;
  width: 100%;
  border-radius: 40px;
  cursor: pointer;
`;
const DownloadButton = ({ ...props }) => {
    const { t } = useTranslation('navigation');
    const { queryString } = useOneLink();
    const [isIOS, setIsIOS] = useState(false);
    useEffect(() => {
        setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent));
    }, []);
    return (jsx(Box, { ...props, children: jsxs(NoSSR, { children: [isIOS && (jsx(Link, { href: `https://crypto.onelink.me/RSfq${queryString}`, style: { width: '100%' }, children: jsxs(DownloadButtonBox, { children: [jsx(Apple, { width: '16px', color: 'white' }), jsx(ForwardedTypography, { color: '#FFF', variant: "p", fontWeight: 600, fontSize: 16, lineHeight: '150%', children: t('footer.qrcode.downloadBtn') })] }) })), !isIOS && (jsx(Link, { href: `https://crypto.onelink.me/veNW${queryString}`, style: { width: '100%' }, children: jsxs(DownloadButtonBox, { children: [jsx(GooglePlay, { width: '16px', color: 'white' }), jsx(ForwardedTypography, { variant: "p", fontWeight: 600, fontSize: 16, lineHeight: '150%', children: t('footer.qrcode.downloadBtn') })] }) }))] }) }));
};
const Qrcode = ({ ...restProps }) => {
    const { t } = useTranslation('navigation');
    return (jsxs(Flex, { flexDirection: "column", alignItems: "center", width: ['100%', '185px', '153px'], customCss: {
            gap: ['24px', '16px'],
        }, ...restProps, children: [jsx(Text, { variant: "h4", color: "#EAEEF4", textAlign: 'center', width: ['100%', '120px', '120px'], children: t('footer.qrcode.title') }), jsx(DownloadButton, { width: '100%', display: ['flex', 'flex', 'none'] }), jsx(Text, { variant: "h4", color: "#EAEEF4", textAlign: 'center', display: ['none', 'flex', 'none'], children: t('footer.qrcode.or') }), jsx(Box, { display: ['none', 'flex'], flexDirection: "column", border: " 1.5px solid rgba(17, 153, 249, 0.5)", p: ['32px 32px 16px', '32px 32px 16px', '16px'], borderRadius: '20px', width: "100%", alignItems: 'center', children: jsxs(Box, { width: "121px", children: [jsx("img", { src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/qrCode.webp`, alt: "qrCode", width: "121", height: "121", loading: "lazy", style: { width: '100%' } }), jsx(Text, { variant: "l3", color: "#EAEEF4", mt: "14px", textAlign: "center", children: t('footer.qrcode.scan') })] }) })] }));
};

const Social = ({ ...restProps }) => {
    return (jsx(Box, { width: '100%', style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '12px',
        }, ...restProps, children: socials.map(({ href, IconComponent, label }) => (jsx(Link, { href: href, "aria-label": label, style: { lineHeight: '0', textAlign: 'center' }, children: jsx(IconComponent, { width: 48, border: "1px solid #323C52", borderRadius: "24px", customCss: { '&:hover': { border: '1px solid #EAEEF4' } } }) }, href))) }));
};

const useRewardsAccess = (geoCountry, region) => {
    const [isRewardsAccess, setRewardsAccess] = useState(true);
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (region === RegionsEnum.GLOBAL &&
                [
                    'AS',
                    'AG',
                    'AR',
                    'BS',
                    'BH',
                    'BB',
                    'BY',
                    'BM',
                    'VG',
                    'KY',
                    'CL',
                    'CO',
                    'CR',
                    'CW',
                    'DO',
                    'EG',
                    'SV',
                    'FO',
                    'FJ',
                    'GF',
                    'PF',
                    'GI',
                    'GL',
                    'GP',
                    'GU',
                    'GT',
                    'GG',
                    'HN',
                    'IN',
                    'ID',
                    'IM',
                    'IL',
                    'JP',
                    'JE',
                    'JO',
                    'KE',
                    'KW',
                    'LI',
                    'MK',
                    'MY',
                    'MQ',
                    'MX',
                    'MC',
                    'NC',
                    'NG',
                    'MP',
                    'OM',
                    'PY',
                    'PE',
                    'PR',
                    'QA',
                    'RE',
                    'KN',
                    'LC',
                    'MF',
                    'SM',
                    'SA',
                    'RS',
                    'SC',
                    'SX',
                    'ZA',
                    'LK',
                    'PM',
                    'TH',
                    'TT',
                    'TN',
                    'TC',
                    'UA',
                    'AE',
                    'VI',
                    'UY',
                    'VN',
                    'MT',
                    'CH',
                ].includes(geoCountry)) {
                setRewardsAccess(true);
            }
            else if (region === RegionsEnum.EEA && geoCountry !== 'BE') {
                setRewardsAccess(true);
            }
            else {
                setRewardsAccess(false);
            }
        }
        return () => {
            isMounted = false;
        };
    }, [geoCountry, region]);
    return isRewardsAccess;
};

const useSpanishAccess = (geoCountry) => {
    const [isSpanishAccess, setSpanishAccess] = useState(false);
    useEffect(() => {
        let isMounted = true;
        const isSpanishAccess = 'ES' === geoCountry;
        isMounted && setSpanishAccess(isSpanishAccess);
        return () => {
            isMounted = false;
        };
    }, [geoCountry]);
    return isSpanishAccess;
};

const useStakingAccess = (geoCountry) => {
    const [isStakingAccess, setStakingAccess] = useState(true);
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if ([
                'AS',
                'GU',
                'MP',
                'PR',
                'VI',
                'US',
                'SC',
                'SG',
                'CA',
                'HK',
                'KR',
                'TH',
                'MT',
            ].includes(geoCountry)) {
                setStakingAccess(false);
            }
            else {
                setStakingAccess(true);
            }
        }
        return () => {
            isMounted = false;
        };
    }, [geoCountry]);
    return isStakingAccess;
};

const useRegionConfig = (region) => {
    const navContext = useContext(NavFooterContext);
    const isSpanish = useSpanishAccess(navContext.geoLocation.geoCountry);
    const isStakingAvailable = useStakingAccess(navContext.geoLocation.geoCountry);
    const isRewardsAccess = useRewardsAccess(navContext.geoLocation.geoCountry, region);
    const isBelgium = navContext.geoLocation.geoCountry === 'BE' ||
        navContext.geoLocation.geoCountry === 'BEL';
    const { i18n } = useTranslation();
    const defaultConfig = {
        desktopMenu: get_footer_global(isStakingAvailable, isRewardsAccess).desktop,
        desktopProducts: get_footer_global(isStakingAvailable, isRewardsAccess)
            .products,
        tabletMenu: get_footer_global(isStakingAvailable, isRewardsAccess).tablet,
        mobileMenu: get_footer_global(isStakingAvailable, isRewardsAccess).mobile,
        disclaimers: globalDisclaimers,
        legalLinks: legal_global,
        legalStatement: GlobalLegalStatement,
        menuWidth: '16%',
        isShowEALogo: false,
        isShowCardPN: false,
        isShowCSContact: false,
    };
    if (region === RegionsEnum.US) {
        return {
            ...defaultConfig,
            desktopMenu: footer_us.desktop,
            tabletMenu: footer_us.tablet,
            mobileMenu: footer_us.mobile,
            desktopProducts: footer_us.products,
            disclaimers: usDisclaimers,
            legalLinks: legal_us,
            isShowEALogo: true,
        };
    }
    // NOTE GB special case
    if (region === RegionsEnum.EEA) {
        const menu = {
            desktopMenu: get_footer_eea(isStakingAvailable, isRewardsAccess).desktop,
            tabletMenu: get_footer_eea(isStakingAvailable, isRewardsAccess).tablet,
            mobileMenu: get_footer_eea(isStakingAvailable, isRewardsAccess).mobile,
        };
        const desktopProducts = get_footer_eea(isStakingAvailable, isRewardsAccess).products;
        if (isSpanish) {
            return {
                ...defaultConfig,
                ...menu,
                desktopProducts,
                disclaimers: [...globalDisclaimers, ...spDisclamiers],
                legalLinks: legal_eea,
            };
        }
        else if (isBelgium) {
            return {
                ...defaultConfig,
                ...menu,
                desktopProducts,
                disclaimers: [...globalDisclaimers, ...belguimDisclaimers],
                legalLinks: legal_eea,
            };
        }
        else {
            return {
                ...defaultConfig,
                ...menu,
                desktopProducts,
                disclaimers: [...globalDisclaimers, ...eeaDisclaimers],
                legalLinks: legal_eea,
            };
        }
    }
    if (region === RegionsEnum.SG) {
        return {
            ...defaultConfig,
            desktopMenu: footer_sg.desktop,
            tabletMenu: footer_sg.tablet,
            mobileMenu: footer_sg.mobile,
            desktopProducts: footer_sg.products,
            disclaimers: sgDisclaimers,
            legalLinks: legal_sg,
        };
    }
    if (region === RegionsEnum.AU) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_au.desktop
                : footer_au_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_au.tablet
                : footer_au_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_au.mobile
                : footer_au_noStaking.mobile,
            desktopProducts: footer_au.products,
            disclaimers: auDisclaimers,
            legalLinks: legal_au,
        };
    }
    if (region === RegionsEnum.BR) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_br.desktop
                : footer_br_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_br.tablet
                : footer_br_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_br.mobile
                : footer_br_noStaking.mobile,
            desktopProducts: footer_br.products,
            legalLinks: legal_br,
            isShowCSContact: true,
        };
    }
    if (region === RegionsEnum.TR) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_tr.desktop
                : footer_tr_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_tr.tablet
                : footer_tr_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_tr.mobile
                : footer_tr_noStaking.mobile,
            desktopProducts: footer_tr.products,
            disclaimers: trDisclaimers,
            legalLinks: legal_tr,
        };
    }
    if (region === RegionsEnum.FR) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_fr.desktop
                : footer_fr_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_fr.tablet
                : footer_fr_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_fr.mobile
                : footer_fr_noStaking.mobile,
            desktopProducts: footer_fr.products,
            disclaimers: i18n.language === 'fr' ? frDisclaimersInFr : frDisclaimers,
            legalLinks: legal_fr,
        };
    }
    if (region === RegionsEnum.CA) {
        return {
            ...defaultConfig,
            desktopMenu: footer_ca.desktop,
            tabletMenu: footer_ca.tablet,
            mobileMenu: footer_ca.mobile,
            desktopProducts: footer_ca.products,
            disclaimers: i18n.language === 'fr-CA' ? caDisclaimersInFr : caDisclaimers,
            legalStatement: i18n.language === 'fr-CA' ? CALegalStatementInFR : CALegalStatement,
            legalLinks: legal_ca,
        };
    }
    if (region === RegionsEnum.IT) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_it.desktop
                : footer_it_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_it.tablet
                : footer_it_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_it.mobile
                : footer_it_noStaking.mobile,
            desktopProducts: footer_it.products,
            disclaimers: i18n.language === 'it' ? itDisclaimersInIT : itDisclaimersInEN,
            legalLinks: legal_it,
        };
    }
    if (region === RegionsEnum.KR) {
        return {
            ...defaultConfig,
            desktopMenu: footer_kr.desktop,
            tabletMenu: footer_kr.tablet,
            mobileMenu: footer_kr.mobile,
            desktopProducts: footer_kr.products,
            legalLinks: legal_kr,
            disclaimers: i18n.language === 'ko' ? krDisclaimersInKO : krDisclaimersInEn,
        };
    }
    if (region === RegionsEnum.UK) {
        return {
            ...defaultConfig,
            desktopMenu: isStakingAvailable
                ? footer_uk.desktop
                : footer_uk_noStaking.desktop,
            tabletMenu: isStakingAvailable
                ? footer_uk.tablet
                : footer_uk_noStaking.tablet,
            mobileMenu: isStakingAvailable
                ? footer_uk.mobile
                : footer_uk_noStaking.mobile,
            desktopProducts: footer_uk.products,
            disclaimers: ukDisclaimers,
            legalLinks: legal_uk,
        };
    }
    return defaultConfig;
};

const Footer = ({ region }) => {
    const { desktopMenu, tabletMenu, mobileMenu, desktopProducts, disclaimers, legalLinks, isShowEALogo, isShowCSContact, legalStatement, } = useRegionConfig(region);
    return (jsx(LazyMotion, { features: domAnimation, strict: true, children: jsx(Box, { backgroundColor: "#0B1426", children: jsxs(Container, { paddingTop: 8, paddingBottom: 8, children: [jsx(HeroLogo, { mb: '64px' }), jsxs(Box, { customCss: { gap: ['92px', '92px', '20px'] }, display: ['none', 'flex'], children: [jsxs(Flex, { width: '200px', display: ['none', 'flex', 'flex'], flexDirection: 'column', justifyItems: "center", children: [jsx(Products, { width: '100%', products: desktopProducts }), jsx(Qrcode, { display: ['none', 'flex', 'none'], mt: "64px", width: "185px" })] }), jsx(LinkSections, { flex: '730px 0', display: ['none', 'none', 'flex'], menuData: desktopMenu, menuWidth: '25%' }), jsx(LinkSections, { flex: '364px 1', display: ['none', 'flex', 'none'], menuData: tabletMenu, menuWidth: '33%', alignItems: "space-around", customCss: { gap: '20px' } }), jsx(Qrcode, { display: ['none', 'none', 'flex'] })] }), jsxs(Box, { display: ['flex', 'none'], flexDirection: 'column', children: [jsx(Box, { width: "100%", children: jsx(MobileMenu$1, { menuData: mobileMenu }) }), jsx(Qrcode, { mt: 8, width: "100%" }), jsx(Social, { mt: 8 })] }), jsxs(Box, { mt: [8, 5], children: [jsx(Box, { mb: 5, height: 1, bg: "#323C52", display: ['none', 'block'] }), jsxs(Flex, { alignItems: "flex-end", justifyContent: "space-between", flexDirection: ['column', 'column', 'row'], children: [jsxs(Box, { width: [1, 1, 5 / 8], children: [isShowCSContact && (jsx(Box, { mb: [8, 5], children: jsx(CSContact, {}) })), disclaimers.map((disclaimer, index) => (jsx(ForwardedTypography, { variant: "p", fontSize: 12, fontWeight: 400, lineHeight: "135%", color: "#A0A9BE", customCss: {
                                                    '& + &': {
                                                        marginTop: '16px',
                                                    },
                                                }, dangerouslySetInnerHTML: { __html: disclaimer } }, index)))] }), jsx(Box, { padding: "0px", alignSelf: ['flex-start', 'flex-start', 'flex-end'], children: jsx(Certificates, {}) })] })] }), jsx(Box, { mt: 5, mb: 2, height: 1, bg: "#323C52" }), jsx(LegalSection, { links: legalLinks, isShowEALogo: isShowEALogo, legalStatement: legalStatement })] }) }) }));
};
const GlobalFooter = () => jsx(Footer, { region: RegionsEnum.GLOBAL });
const USFooter = () => jsx(Footer, { region: RegionsEnum.US });
const EEAFooter = () => jsx(Footer, { region: RegionsEnum.EEA });
const SGFooter = () => jsx(Footer, { region: RegionsEnum.SG });
const AUFooter = () => jsx(Footer, { region: RegionsEnum.AU });
const BRFooter = () => jsx(Footer, { region: RegionsEnum.BR });
const TRFooter = () => jsx(Footer, { region: RegionsEnum.TR });
const FRFooter = () => jsx(Footer, { region: RegionsEnum.FR });
const CAFooter = () => jsx(Footer, { region: RegionsEnum.CA });
const ITFooter = () => jsx(Footer, { region: RegionsEnum.IT });
const KRFooter = () => jsx(Footer, { region: RegionsEnum.KR });
const UKFooter = () => jsx(Footer, { region: RegionsEnum.UK });

const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState();
    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor;
        if (/android/i.test(ua)) {
            setUserAgent('android');
            return;
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if ([
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document)) {
            setUserAgent('ios');
            return;
        }
        setUserAgent('others');
    }, []);
    return userAgent;
};

const DownloadBox = styled((props) => (jsx(Flex, { p: ['10px 8px', '10px 16px', '12px 24px'], border: [
        '2px solid rgba(17, 153, 249, 0.5)',
        '1.5px solid rgba(17, 153, 249, 0.5)',
    ], borderRadius: ['4px', '40px'], height: '44px', alignItems: "center", justifyContent: "center", ...props, children: props.children }))) ``;
const DownloadButtons = () => {
    const userAgent = useUserAgent();
    const isIos = userAgent === 'ios';
    const isAndroid = userAgent === 'android';
    const neitherIosNorAndroid = !isIos && !isAndroid;
    const [isQrOpen, setIsQrOpen] = useState(false);
    const { queryString } = useOneLink();
    const { i18n, t } = useTranslation('navigation');
    return (jsxs(Flex, { alignItems: "center", className: `mkt-navbar-download-${i18n.language}`, customCss: css$1 `
        &.mkt-navbar-download-ru {
          max-width: 174px;
        }
      `, children: [isAndroid && (jsx(DownloadBox, { children: jsx(Link, { href: `https://crypto.onelink.me/veNW${queryString}`, children: jsxs(Flex, { alignItems: 'center', children: [jsx(Box, { display: ['block', 'block', 'none'], children: jsx(PlayStore, { width: "24px", height: "24px" }) }), jsx(Text, { variant: ['l2_m', 'l2_m', 'l3'], ml: 1, color: "white", display: ['none', 'block'], width: "min-content", children: t('navbar.download') })] }) }) })), isIos && (jsx(DownloadBox, { children: jsx(Link, { href: `https://crypto.onelink.me/RSfq${queryString}`, children: jsxs(Flex, { alignItems: 'center', children: [jsx(Box, { display: ['block', 'block', 'none'], children: jsx(AppStore, { width: "24px", height: "24px" }) }), jsx(Text, { variant: ['l2_m', 'l2_m', 'l3'], ml: 1, color: "white", display: ['none', 'block'], children: t('navbar.download') })] }) }) })), neitherIosNorAndroid && (jsxs(DownloadBox, { className: "main-nav-cta-download", minWidth: ['44px', '174px'], position: 'relative', customCss: {
                    cursor: 'default',
                    backgroundColor: '#061121',
                    '&:hover': {
                        backgroundColor: '#23273a',
                    },
                }, onClick: () => setIsQrOpen((prev) => !prev), children: [jsxs(Flex, { justifyContent: "center", alignItems: "center", children: [isQrOpen ? (jsx(Text, { variant: ['l2_m', 'l2_m', 'l3'], color: "white", display: ['none', 'block', 'block'], children: t('footer.qrcode.scan') })) : (jsx(Text, { variant: ['l2_m', 'l2_m', 'l3'], color: "white", display: ['none', 'block', 'block'], children: t('navbar.downloadButton') })), !isQrOpen && (jsx(QrIcon, { ml: [0, 1], width: "16px", height: "16px", display: ['block', 'none', 'block'] }))] }), jsx(AnimatePresence, { initial: false, children: isQrOpen && (jsx(m.div, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                                open: { opacity: 1, top: '50px' },
                                collapsed: { opacity: 0, top: '0px' },
                            }, transition: { duration: 0.3 }, style: {
                                backgroundColor: 'inherit',
                                position: 'absolute',
                                top: '50px',
                                padding: '16px',
                                border: ' 1.5px solid rgba(17, 153, 249, 0.5)',
                                borderRadius: '20px',
                                marginLeft: '-24px',
                                marginRight: '-24px',
                            }, children: jsx(Box, { width: ['60px', '135px'], height: ['60px', '135px'], children: jsx("img", { src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/footer/qrCode.webp`, alt: "qrCode", width: "242", height: "242", loading: "lazy", style: { width: '100%', height: '100%' } }) }) })) })] }))] }));
};

const NavBarBanner = () => {
    const { t } = useTranslation('navigation');
    return (jsx(Flex, { id: 'navbar-banner', position: "sticky", py: 1, top: 0, left: 0, width: "100%", zIndex: 98, justifyContent: 'center', alignItems: "center", backgroundColor: "#EAEEF4", maxWidth: '100vw', children: jsx(ForwardedTypography, { textAlign: 'center', variant: "p", fontSize: [16], fontWeight: [400], lineHeight: ['155%'], letterSpacing: '-0.04em', color: '#323c52', children: jsx(Trans, { i18nKey: 'navbar.banner', t: t, components: {
                    a: (jsx(Link, { href: 'https://crypto.com/document/risk_summary_uk', isExternal: true, style: {
                            fontWeight: '500',
                            textDecorationLine: 'underline',
                            color: '#323C52',
                        } })),
                } }) }) }));
};

styled.img `
  width: 147px;
`;
const Logo = ({ href = '/', variant = 'dark', onClick, isShowLogoFlag, }) => {
    return (jsx(Link, { href: href, onClick: onClick, style: { display: 'flex' }, children: jsxs(Flex, { alignItems: 'center', customCss: { gap: 1 }, children: [jsx(Box, { width: "147px", height: "28px", children: variant === 'dark' ? (jsx("img", { className: "main-nav-crypto.com-logo", src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/cdc_logo.svg`, alt: "Crypto.com white logo", width: "199", height: "40", style: { height: '100%', width: '100%' }, loading: "eager" })) : (jsx("img", { className: "main-nav-crypto.com-logo", src: `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/cdc_logo.svg`, alt: "Crypto.com white logo", width: "199", height: "40", style: { height: '100%', width: '100%' }, loading: "eager" })) }), isShowLogoFlag && (jsxs(Fragment, { children: [jsx(Box, { width: '1px', backgroundColor: 'backgroundWhite', height: '20px', opacity: 0.5 }), getRegionFlagIcon(isShowLogoFlag)] }))] }) }));
};
const getRegionFlagIcon = (region) => {
    const flagStr = `${process.env.MKT_NAV_STATIC_BASE_URL ?? ''}/__assets/mkt-nav-footer/images/navbar/countryFlags/${region.toLowerCase()}.webp`;
    return jsx("img", { src: flagStr, width: "24px", alt: region.toLowerCase() });
};

const LangMenu = ({ suggestLangs, allLangs, onClick, ...restProps }) => {
    const { t, i18n } = useTranslation('navigation');
    const { language: currentLanguage } = i18n;
    const navContext = useContext(NavFooterContext);
    const renderLang = (language) => (jsxs(Flex, { onClick: () => {
            //  TODO improve lower case an upper case, cookie now is UPPERCASE❗️
            i18n.changeLanguage(language);
            if (navContext.langChangeCallback) {
                navContext.langChangeCallback(language);
            }
            onClick(language.toUpperCase());
        }, justifyContent: "flex-start", alignItems: "center", width: "calc(100% / 3)", borderRadius: "8px", marginBottom: 0.5, customCss: {
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: '#EAEEF4',
                '.text': {
                    textDecoration: 'underline',
                },
            },
        }, children: [jsx(ForwardedTypography, { variant: "subtitle6", color: currentLanguage === language
                    ? 'primaryBrightBlue'
                    : 'primaryDeepBlack', maxWidth: ['200px', 'max-content'], className: "text", paddingTop: 1, paddingBottom: "6px", paddingRight: "6px", marginLeft: 2, children: i18nLanguageToDisplayString(language) }), jsx(ForwardedTypography, { variant: "subtitle4", color: currentLanguage === language ? 'primaryBrightBlue' : '#656E85', opacity: currentLanguage === language ? 1 : 0.72, children: language.toUpperCase() })] }, language));
    const renderSection = (title, languages) => languages && languages.length > 0 ? (jsxs(Fragment, { children: [jsx(ForwardedTypography, { variant: "subtitle2", color: "#000", marginBottom: "20px", children: title }), jsx(Box, { display: "flex", flexWrap: "wrap", marginBottom: 4, children: languages.map(renderLang) })] })) : null;
    return (jsxs(Box, { ...restProps, children: [renderSection(t('geolocation.suggestion'), suggestLangs), renderSection(t('geolocation.allLang'), allLangs)] }));
};

const Portal = ({ children, className = 'root-portal', el = 'div', zIndex = 99999, }) => {
    const [container] = useState(() => {
        // This will be executed only on the initial render
        // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
        if (document)
            return document.createElement(el);
        return undefined;
    });
    useEffect(() => {
        if (container && document) {
            container.classList.add(className);
            document.body.appendChild(container);
        }
        return () => {
            if (container && document) {
                document.body.removeChild(container);
            }
        };
    }, [className, container]);
    if (typeof document === `undefined`)
        return null;
    if (container)
        return ReactDOM.createPortal(React__default.cloneElement(children, {
            zIndex,
        }), container);
    return jsx(Fragment, {});
};

const ModalBackground = styled(Flex) `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(6, 17, 33, 0.6);
  backdrop-filter: blur(16px);

  height: 100%;
  flex-direction: column;
  justify-content: center;
`;
const Modal = ({ onClose, zIndex = 99, ...restProps }) => {
    // TODO should check why works on desktop size, but not on mobile
    useEffect(() => {
        document.body.style.overflowY = 'hidden';
        return () => {
            document.body.style.overflowY = 'unset';
        };
    }, []);
    return (jsxs(Fragment, { children: [jsx(ModalBackground, { zIndex: zIndex, onClick: onClose }), jsx(Portal, { children: jsx(Box, { zIndex: zIndex + 1, borderRadius: "8px", mx: "auto", backgroundColor: "primaryPaleWhite", position: "fixed", left: "50%", top: "50%", customCss: {
                        transform: 'translate(-50%, -50%)',
                    }, ...restProps, children: restProps.children }) })] }));
};

const RegionColLayout = {
    oneCol: '100%',
    twoCol: 'calc(100% / 2)',
};
const RegionMenu$1 = ({ suggestRegion, allRegion, onClick, ...restProps }) => {
    const { t } = useTranslation('navigation');
    const context = useContext(NavFooterContext);
    // const getRegionFlagIcon = (region: string) => {
    //   const flagStr = `${region.toUpperCase()}Flag`
    //   const RegionIcon = (Icon as any)[flagStr]
    //   return React.createElement(RegionIcon, {
    //     fontSize: '24px',
    //     border:
    //       context.country === region ||
    //       (region === 'global' && context.country === '')
    //         ? '1.5px solid #1199FA'
    //         : '1.5px solid #000000',
    //     borderRadius: '50%',
    //     marginLeft: '16px',
    //   })
    // }
    const renderRegionItem = (region) => {
        return (jsx(Fragment, { children: jsx(ForwardedTypography, { variant: "subtitle6", color: context.country === region
                    ? 'primaryBrightBlue'
                    : 'primaryDeepBlack', maxWidth: ['200px', 'max-content'], className: "text", mx: "6px", children: t(`geolocation.${region.toLowerCase()}`) }) }));
    };
    const renderRegionList = (region, width) => (jsx(Flex, { onClick: () => {
            //  TODO improve lower case an upper case, cookie now is UPPERCASE❗️
            onClick(region.toUpperCase());
        }, justifyContent: "flex-start", alignItems: "center", width: width, borderRadius: "8px", py: 0.5, marginBottom: 1, customCss: {
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: '#EAEEF4',
                '.text': {
                    textDecoration: 'underline',
                },
            },
        }, children: renderRegionItem(region) }, region));
    const renderSection = (title, regions) => regions && regions.length > 0 ? (jsxs(Fragment, { children: [jsx(ForwardedTypography, { variant: "subtitle2", color: "#000", marginBottom: "16px", customCss: {
                    '&:hover': {
                        cursor: 'pointer',
                    },
                }, children: title }), jsx(Box, { display: "flex", flexWrap: "wrap", marginBottom: 4, children: regions.map((region) => renderRegionList(region, RegionColLayout.twoCol)) })] })) : null;
    return (jsxs(Box, { ...restProps, children: [renderSection(t('geolocation.suggestion'), suggestRegion), renderSection(t('geolocation.allLocation'), allRegion)] }));
};

var NavBarModalTabKey;
(function (NavBarModalTabKey) {
    NavBarModalTabKey["LANG"] = "geolocation.lang_desktop";
    NavBarModalTabKey["REGION"] = "geolocation.location";
})(NavBarModalTabKey || (NavBarModalTabKey = {}));
const NavBarModal = ({ isOpen, setOpen, onSetRegion, suggestLangs, allLangs, suggestRegion, allRegion, }) => {
    const { t } = useTranslation('navigation');
    const [tabKey, setTabKey] = useState(NavBarModalTabKey.LANG);
    if (!isOpen)
        return null;
    return (jsxs(Modal, { onClose: setOpen, zIndex: 199, width: [327, 628, 628], px: [3, 4, 4], children: [jsxs(Box, { marginTop: 3, borderBottom: "1px #A0A9BE solid", display: "flex", justifyContent: "space-between", children: [jsx(Box, { display: "flex", justifyContent: "flex-start", children: Object.keys(NavBarModalTabKey).map((key) => {
                            const keyVal = NavBarModalTabKey[key];
                            return (jsx(ForwardedTypography, { variant: "subtitle2", className: `${tabKey === keyVal ? 'active' : ''}`, color: tabKey === keyVal ? '#1199FA' : '#A0A9BE', borderBottom: tabKey === keyVal ? '#1199FA 1px solid' : 'none', onClick: () => {
                                    setTabKey(keyVal);
                                }, paddingLeft: 3, paddingRight: 3, paddingBottom: 1, customCss: {
                                    userSelect: 'none',
                                }, children: t(keyVal) }, key));
                        }) }), jsx(Close, { width: "20px", color: "secondaryDarkNavy", paddingBottom: "16px", onClick: setOpen })] }), tabKey === NavBarModalTabKey.LANG ? (jsx(LangMenu, { suggestLangs: suggestLangs, allLangs: allLangs, marginTop: 4, marginBottom: 4, onClick: () => setOpen() })) : null, tabKey === NavBarModalTabKey.REGION ? (jsx(RegionMenu$1, { suggestRegion: suggestRegion, allRegion: allRegion, marginTop: 4, marginBottom: 4, onClick: (region) => {
                    onSetRegion(region);
                } })) : null] }));
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, callback, options) {
  var _ref = options || {},
      _ref$atBegin = _ref.atBegin,
      atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}

const useIsPortableDevice = () => {
    const [isIsPortableDevice, setIsPortableDevice] = useState(false);
    const tellSize = () => {
        setIsPortableDevice(window.innerWidth < 1128 ? true : false);
    };
    const debounceTellSize = useCallback(debounce(150, tellSize), []);
    useEffect(() => {
        window.addEventListener('resize', debounceTellSize);
        return () => {
            window.removeEventListener('resize', debounceTellSize);
        };
    }, []);
    useEffect(debounceTellSize, []);
    return isIsPortableDevice;
};

const RiskWarningBanner = () => {
    const { t } = useTranslation('navigation');
    const [isScroll, setScroll] = useState(false);
    const isTablet = useIsPortableDevice();
    const paragraphs = isTablet
        ? [
            [
                'navbar.risk_warn_paragrpah_1',
                'navbar.risk_warn_paragrpah_2',
                'navbar.risk_warn_paragrpah_3',
                'navbar.risk_warn_paragrpah_4',
            ],
            [
                'navbar.risk_warn_paragrpah_5',
                'navbar.risk_warn_paragrpah_6',
                'navbar.risk_warn_paragrpah_7',
            ],
        ]
        : [
            [
                'navbar.risk_warn_paragrpah_1',
                'navbar.risk_warn_paragrpah_2',
                'navbar.risk_warn_paragrpah_3',
            ],
            ['navbar.risk_warn_paragrpah_4', 'navbar.risk_warn_paragrpah_5'],
            ['navbar.risk_warn_paragrpah_6', 'navbar.risk_warn_paragrpah_7'],
        ];
    useEffect(() => {
        const handleScroll = () => {
            setScroll(true);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (jsxs(Flex, { py: 3, px: [2, 4, 10], justifyContent: "center", backgroundColor: '#0B1426', position: "relative", id: 'navbar-banner', children: [jsx(Box, { flexDirection: ['column', null, 'row'], alignItems: ['flex-start'], justifyContent: ['center'], customCss: { gap: [2, '12px', 4] }, width: '100%', display: ['none', 'flex'], children: isScroll ? (jsx(ScrollingBanner, {})) : (jsxs(Fragment, { children: [jsx(TitleSection, {}), jsx(Box, { customCss: { gap: [2, 2, 4] }, display: ['none', 'flex', 'flex'], children: paragraphs.map((column, index) => (jsx(Flex, { flexDirection: "column", children: column.map((content, index) => (jsx(Text, { maxWidth: ['unset', null, 308], color: '#7B849B', fontSize: [12, 12, 10], fontWeight: 400, lineHeight: '140%', children: jsx(Trans, { i18nKey: content, t: t, components: {
                                            a: (jsx(Link, { href: 'https://crypto.com/document/risk_disclosure_be', isExternal: true, style: {
                                                    textDecorationLine: 'none',
                                                    color: '#1199FA',
                                                } })),
                                            li: jsx("li", {}),
                                            ul: (jsx("ul", { style: {
                                                    margin: 0,
                                                    paddingLeft: '1em',
                                                    paddingRight: '1em',
                                                } })),
                                        }, children: content }) }, `risk-warning-${index}`))) }, `risk-warning-column-${index}`))) })] })) }), jsxs(Box, { display: ['flex', 'none', 'none'], flexDirection: 'column', alignItems: 'flex-start', width: '100%', children: [jsx(Box, { mb: 2, children: jsx(TitleSection, {}) }), jsx(Link, { href: 'https://crypto.com/document/risk_disclosure_be', isExternal: true, children: jsx(Text, { color: '#1199FA', variant: 't3', customCss: { textDecoration: 'underline' }, children: t('navbar.banner_be_content_sm') }) })] })] }));
};
const TitleSection = () => {
    const { t } = useTranslation('navigation');
    return (jsxs(Flex, { flexDirection: 'column', alignItems: ['flex-start'], maxWidth: [315, 676, 260], children: [jsx(Text, { color: '#1199FA', fontSize: [24, 24, 28], fontWeight: 600, lineHeight: '140%', children: t('navbar.banner_be_title') }), jsx(Text, { color: '#F7F9FA', fontSize: [18, 18, 15], fontWeight: 600, lineHeight: '140%', children: jsx(Trans, { i18nKey: 'navbar.banner_be_subtitle', t: t, components: {
                        br: (jsx(Box, { display: ['block', 'none', 'none'], children: jsx("br", {}) })),
                    } }) })] }));
};
const ScrollingBanner = () => {
    const { t } = useTranslation('navigation');
    return (jsxs(Box, { width: '100%', flexDirection: ['column', null, 'row'], justifyContent: ['flex-start', 'flex-start', 'center'], alignItems: ['flex-start', null, 'center'], display: ['none', 'flex', 'flex'], children: [jsxs(Flex, { flexDirection: ['column', null, 'row'], customCss: { gap: [0, 0, 4] }, alignItems: ['flex-start', null, 'center'], mr: [0, 0, 4], mb: ['12px', null, 0], children: [jsx(Text, { color: '#1199FA', fontSize: [24, 24, 20], fontWeight: 600, lineHeight: '140%', children: t('navbar.banner_be_title') }), jsx(Text, { color: '#F7F9FA', fontSize: [18, 18, 15], fontWeight: 600, lineHeight: '140%', children: jsx(Trans, { i18nKey: 'navbar.banner_be_subtitle', t: t, components: {
                                br: (jsx(Box, { display: ['block', 'none', 'none'], children: jsx("br", {}) })),
                            } }) })] }), jsx(Link, { href: 'https://crypto.com/document/risk_disclosure_be', isExternal: true, style: {
                    textDecorationLine: 'underline',
                    color: '#1199FA',
                }, children: jsx(Text, { color: '#1199FA', fontSize: [14], fontWeight: 400, lineHeight: '155%', minWidth: 665, textAlign: ['left', 'left', 'right'], children: t('navbar.risk_warn_cta') }) })] }));
};

const useClickAway = (ref, onClickAway) => {
    const handleClick = useCallback((e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            onClickAway();
        }
    }, [onClickAway, ref]);
    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [ref, onClickAway, handleClick]);
};
const Popover = ({ variant = 'default', popMenu, direction = 'down', children, align = 'center', distance = 8, offset = 0, isOpen, onOutsideClick, bgColor, zIndex = 90 /* Set it below header & footer, need to unified then. */, ...props }) => {
    const [translateX, setTranslateX] = useState(0);
    const [hasTranslated, setHasTranslated] = useState(false);
    const containerWrapperRef = useRef();
    const contentWrapperRef = useRef();
    const renderPopover = () => {
        const getAlignmentValue = () => {
            switch (align) {
                case 'start':
                    return '0%';
                case 'end':
                    return '100%';
                case 'center':
                default:
                    return '50%';
            }
        };
        switch (direction) {
            case 'trade':
                return (jsxs(Flex, { position: ['fixed', 'fixed', 'absolute'], right: ['50%', '50%', '100%'], top: getAlignmentValue(), customCss: {
                        transform: [
                            `translateY(-50%) translateY(${offset}px) translateX(50%)`,
                            `translateY(-50%) translateY(${offset}px) translateX(50%)`,
                            `translateY(-50%) translateY(${offset}px)`,
                        ],
                    }, alignItems: "center", zIndex: zIndex, children: [jsx(Box, { bg: bgColor || 'primaryPaleWhite', maxWidth: "100vw", ref: contentWrapperRef, opacity: hasTranslated ? 1 : 0, borderRadius: 4, overflow: "hidden", customCss: {
                                transform: `translateX(${translateX}px)`,
                            }, children: popMenu }), jsx(Box, { display: ['none', 'none', 'flex'], flexDirection: "column", alignItems: "center", justifyContent: "center", width: 8, mr: `${distance}px`, ml: "-1px", children: jsx(PopoverArrowRight, { customCss: {
                                    path: {
                                        fill: bgColor || 'primaryPaleWhite',
                                    },
                                }, width: "31px" }) })] }));
            case 'left':
                return (jsxs(Flex, { position: "absolute", right: "100%", top: getAlignmentValue(), customCss: {
                        transform: `translateY(-50%) translateY(${offset}px)`,
                    }, alignItems: "center", zIndex: zIndex, children: [jsx(Box, { bg: bgColor || 'primaryPaleWhite', maxWidth: "100vw", ref: contentWrapperRef, opacity: hasTranslated ? 1 : 0, borderRadius: 4, overflow: "hidden", customCss: {
                                transform: `translateX(${translateX}px)`,
                            }, children: popMenu }), jsx(Flex, { flexDirection: "column", alignItems: "center", justifyContent: "center", width: 8, mr: `${distance}px`, ml: "-1px", children: jsx(PopoverArrowRight, { customCss: {
                                    path: {
                                        fill: bgColor || 'primaryPaleWhite',
                                    },
                                }, width: "31px" }) })] }));
            case 'up':
            case 'down':
            default:
                return (jsxs(Fragment, { children: [variant === 'container' && (jsx(Box, { position: "fixed", top: 0, left: 0, width: "100vw", children: jsx(Container, { p: 0, ref: containerWrapperRef }) })), jsxs(Box, { position: "absolute", top: direction === 'down' ? '100%' : undefined, bottom: direction === 'up' ? '100%' : undefined, left: getAlignmentValue(), customCss: {
                                transform: `translateX(-50%) translateX(${offset}px)`,
                            }, zIndex: zIndex, children: [direction === 'down' && (jsx(Flex, { alignItems: "center", justifyContent: "center", height: 8, mt: `${distance}px`, mb: "-1px", children: jsx(PopoverArrowUp, { customCss: {
                                            path: {
                                                fill: bgColor || 'primaryPaleWhite',
                                            },
                                        }, width: "31px" }) })), jsx(Box, { ...(variant === 'container' && {
                                        width: 'containerWidth',
                                    }), maxWidth: "100vw", bg: bgColor || 'primaryPaleWhite', borderRadius: 4, ref: contentWrapperRef, opacity: hasTranslated ? 1 : 0, overflow: "hidden", customCss: {
                                        transform: `translateX(${translateX}px)`,
                                    }, children: popMenu }), direction === 'up' && (jsx(Flex, { alignItems: "center", justifyContent: "center", height: 8, mt: "-1px", mb: `${distance}px`, children: jsx(PopoverArrowDown, { customCss: {
                                            path: {
                                                fill: bgColor || 'primaryPaleWhite',
                                            },
                                        }, fontSize: 27 }) }))] })] }));
        }
    };
    useEffect(() => {
        if (!contentWrapperRef.current)
            return;
        const contentWrapperEl = contentWrapperRef.current;
        const contentWrapperRect = contentWrapperEl.getBoundingClientRect();
        let left = 0;
        let right = window.innerWidth;
        if (containerWrapperRef?.current) {
            const containerWrapperEl = containerWrapperRef.current;
            const containerWrapperRect = containerWrapperEl.getBoundingClientRect();
            left = containerWrapperRect.left;
            right = containerWrapperRect.right;
        }
        if (contentWrapperRect.left < left) {
            setTranslateX((prev) => prev + left - contentWrapperRect.left);
        }
        else if (contentWrapperRect.right > right) {
            setTranslateX((prev) => prev + right - contentWrapperRect.right);
        }
        setHasTranslated(true);
    }, [children]);
    const popRef = useRef(null);
    const onClickAway = useCallback((e) => {
        if (isOpen) {
            onOutsideClick(e);
        }
    }, [isOpen, onOutsideClick]);
    useClickAway(popRef, onClickAway);
    return (jsxs(Box, { position: "relative", display: "inline-flex", ref: popRef, ...props, children: [children, jsx(AnimatePresence, { children: isOpen && (jsx(m.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.2 }, children: renderPopover() })) })] }));
};

const links = {
    'products.buyAndSell': {
        tTitle: 'products.buyAndSell',
        tDesc: 'products.appDescription_update',
        href: '/app',
        base: Site.MKT,
    },
    'products.prime': {
        tTitle: 'products.prime',
        tDesc: 'products.prime_description',
        href: '/prime',
        base: Site.MKT,
    },
    'products.metalCards': {
        tTitle: 'products.metalCards',
        tDesc: 'products.metalCardsDescription',
        href: '/cards',
        base: Site.MKT,
    },
    'products.pay': {
        tTitle: 'products.pay',
        tDesc: 'products.payDescription_update',
        href: '/pay',
        base: Site.MKT,
    },
    'products.earn': {
        tTitle: 'products.earn',
        tDesc: 'products.earnDescription',
        href: '/earn',
        base: Site.MKT,
    },
    'products.rewards': {
        tTitle: 'products.rewards',
        tDesc: 'products.rewardsDescription',
        href: '/rewardsplus',
        base: Site.MKT,
    },
    'products.appDerivatives': {
        tTitle: 'products.app_derivatives',
        tDesc: 'products.app_derivatives_description',
        href: '/app/derivatives',
        base: Site.MKT,
    },
    'products.staking': {
        tTitle: 'products.onChainStaking',
        tDesc: 'products.onChainStakingDescription',
        href: '/staking',
        base: Site.MKT,
    },
    'products.exchangeIndex': {
        tTitle: 'products.exchangeIndex',
        tDesc: 'products.exchangeIndexDescription',
        href: 'https://crypto.com/exchange',
    },
    'products.marginTrading': {
        tTitle: 'products.marginTrading',
        tDesc: 'products.marginTradingDescription',
        href: 'https://crypto.com/exchange/trade/BTC_USD',
    },
    'products.derivatives': {
        tTitle: 'products.derivatives',
        tDesc: 'products.derivativesDescription',
        href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
    },
    'products.defiWallet': {
        tTitle: 'products.defiWallet',
        tDesc: 'products.defiWalletDescription',
        href: '/defi-wallet',
        base: Site.MKT,
    },
    'products.browserExt': {
        tTitle: 'products.browserExt',
        tDesc: 'products.browserExtDescription',
        href: '/defi-wallet#wallet_extension',
        base: Site.MKT,
    },
    'products.desktopWallet': {
        tTitle: 'products.desktopWallet',
        tDesc: 'products.desktopWalletDescription',
        href: '/defi-wallet#defi_wallet_desktop',
        base: Site.MKT,
    },
    'products.app': {
        tTitle: 'products.app',
        tDesc: 'products.appDescription_update',
        href: '/app',
        base: Site.MKT,
    },
    'products.nft': {
        tTitle: 'products.nft',
        tDesc: 'products.nftDescription',
        href: 'https://crypto.com/nft',
    },
    'products.payMerchant': {
        tTitle: 'products.payMerchant',
        tDesc: 'products.payMerchantDescription',
        href: '/pay-merchant',
        base: Site.MKT,
    },
    'learn.trending': {
        tTitle: 'learn.trending',
        tDesc: 'learn.trendingDescription',
        href: '/trending',
        base: Site.CHUB,
    },
    'learn.marketUpdates': {
        tTitle: 'learn.marketUpdates',
        tDesc: 'learn.marketUpdatesDescription',
        href: '/market-updates',
        base: Site.CHUB,
    },
    'learn.productNews': {
        tTitle: 'learn.productNews',
        tDesc: 'learn.productNewsDescription',
        href: '/product-news',
        base: Site.CHUB,
    },
    'learn.events': {
        tTitle: 'learn.events',
        tDesc: 'learn.eventsDescription',
        href: '/events',
        base: Site.CHUB,
    },
    'learn.university': {
        tTitle: 'learn.university',
        tDesc: 'learn.universityDescription',
        href: '/university',
        base: Site.CHUB,
    },
    'learn.reportsAndAnalysis': {
        tTitle: 'learn.reportsAndAnalysis',
        tDesc: 'learn.reportsAndAnalysisDescription',
        href: '/research',
        base: Site.CHUB,
    },
    'learn.nftStories': {
        tTitle: 'learn.nftStories',
        tDesc: 'learn.nftStoriesDescription',
        href: '/bitcoin',
        base: Site.CHUB,
    },
    'company.about': {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/about',
        base: Site.MKT,
    },
    'company.careers': {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/careers',
        base: Site.MKT,
    },
    'company.news': {
        tTitle: 'company.news',
        tDesc: 'company.newsDescription',
        href: '/company-news',
        base: Site.CHUB,
    },
    'company.support': {
        tTitle: 'company.support',
        tDesc: 'company.supportDescription',
        href: 'https://help.crypto.com/en',
    },
    'company.security': {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/security',
        base: Site.MKT,
    },
    'company.partners': {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/partners',
        base: Site.MKT,
    },
    'learn.glossary': {
        tTitle: 'learn.glossary',
        tDesc: 'learn.glossaryDescription',
        href: '/glossary',
        base: Site.GLOSSARY,
    },
};

const useToggleMenu = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isLangOpen, setLangOpen] = useState(false);
    const toggleMenu = () => setMenuOpen((prev) => !prev);
    const toggleLang = () => setLangOpen((prev) => !prev);
    return [isMenuOpen, toggleMenu, isLangOpen, toggleLang];
};

const CompanyCategory = ({ href, tTitle, tDesc, base, translateFn, onClick, }) => (jsx(Link, { href: href, onClick: onClick, base: base, children: jsxs(Flex, { flexDirection: "column", paddingLeft: 2, marginBottom: "20px", borderLeftWidth: 2, borderLeftColor: "primaryBrightBlueLightBg", borderLeftStyle: "solid", ml: 5, customCss: {
            '&:hover': {
                borderLeftColor: 'secondaryDarkNavy',
                //NOTE link title will change color when hovered
                '.linkTitle': {
                    color: 'secondaryDarkNavy',
                },
            },
        }, children: [jsx(ForwardedTypography, { variant: "subtitle2", color: "primaryDeepBlack", className: "linkTitle", children: translateFn(tTitle) }), tDesc ? (jsx(ForwardedTypography, { variant: "caption", color: "secondaryDarkGrey", children: translateFn(tDesc) })) : null] }) }, tTitle));

const CompanyMenu$1 = ({ company, onClickMenuLink, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Box, { pl: 5, pr: 8, children: company.map(({ tTitle, items }, i) => {
            const itemFirstCol = [];
            const itemSecondCol = [];
            for (let i = 0; i < items.length; i++) {
                if (i % 2 === 0) {
                    itemFirstCol.push(items[i]);
                }
                else {
                    itemSecondCol.push(items[i]);
                }
            }
            return (jsxs(Box, { children: [jsxs(Flex, { pt: 4, pb: '12px', children: [tTitle && (jsx(ForwardedTypography, { variant: "h5", color: "secondaryDarkGrey", flex: [1 / items.length + 1], minWidth: ['208px'], maxWidth: ['338px'], width: "max-content", children: t(tTitle) })), jsxs(Flex, { width: "516px", flexDirection: 'row', children: [jsx(Flex, { flexDirection: 'column', children: itemFirstCol.map(({ tTitle, tDesc, href, base }) => (jsx(Flex, { flexDirection: 'column', width: "258px", children: jsx(CompanyCategory, { base: base, href: href, tTitle: tTitle, tDesc: tDesc, translateFn: t, onClick: onClickMenuLink }) }, tTitle))) }), jsx(Flex, { flexDirection: 'column', children: itemSecondCol.map(({ tTitle, tDesc, href, base }) => (jsx(Flex, { flexDirection: 'column', width: "258px", children: jsx(CompanyCategory, { base: base, href: href, tTitle: tTitle, tDesc: tDesc, translateFn: t, onClick: onClickMenuLink }) }, tTitle))) })] })] }), i !== company.length - 1 && (jsx(Box, { height: 0.5, bg: "secondaryDarkGrey" }))] }, tTitle));
        }) }));
};

const Badge = ({ children, variant = 'dark', ...props }) => {
    return (jsx(Box, { ...props, display: "inline-flex", alignItems: "center", bg: variant === 'dark' ? 'rgba(5, 119, 218, 1)' : 'primaryBrightBlueLightBg', height: 17, px: 1, borderRadius: '10px', children: jsx(ForwardedTypography, { variant: "badge", color: "primaryPaleWhite", children: children }) }));
};

const DesktopMenuItem = ({ title, titleColor, disableHover = false, badgeTitle, chevron = 'down', ...props }) => {
    const { i18n } = useTranslation();
    const renderChevron = () => {
        switch (chevron) {
            case 'down':
                return (jsx(NavDown, { className: "hoverOpacity", width: "20px", height: "20px", color: 'primaryPaleWhite' }));
            default:
                return null;
        }
    };
    return (jsxs(ForwardedButton, { variant: "plain", display: "flex", alignItems: "center", ...props, customCss: disableHover
            ? {}
            : {
                '.hoverOpacity': {
                    opacity: 0.5,
                },
                '&:hover .hoverOpacity': {
                    opacity: 1,
                },
            }, children: [jsx(Text, { className: "hoverOpacity", variant: "l2", color: titleColor ?? 'primaryPaleWhite', children: title }), badgeTitle && (i18n.language === 'en' || i18n.language === 'en-US') ? (jsx(Badge, { ml: 1, children: badgeTitle })) : (renderChevron())] }));
};

const LearnCategory = ({ href, tTitle, tDesc, base, translateFn, onClick, }) => (jsx(Link, { href: href, onClick: onClick, base: base, children: jsxs(Flex, { flexDirection: "column", paddingLeft: 2, marginBottom: "20px", borderLeftWidth: 2, borderLeftColor: "primaryBrightBlueLightBg", borderLeftStyle: "solid", ml: 5, customCss: {
            '&:hover': {
                borderLeftColor: 'secondaryDarkNavy',
                //NOTE link title will change color when hovered
                '.linkTitle': {
                    color: 'secondaryDarkNavy',
                },
            },
        }, children: [jsx(ForwardedTypography, { variant: "subtitle2", color: "primaryDeepBlack", className: "linkTitle", children: translateFn(tTitle) }), tDesc ? (jsx(ForwardedTypography, { variant: "caption", color: "secondaryDarkGrey", children: translateFn(tDesc) })) : null] }) }, tTitle));

const LearnMenu$1 = ({ learnSec, onClickMenuLink, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Box, { px: 5, children: learnSec.map(({ tTitle, items }, i) => {
            return (jsxs(Box, { children: [jsxs(Flex, { pt: 4, pb: '12px', mr: 3, children: [tTitle && (jsx(ForwardedTypography, { variant: "h5", color: "secondaryDarkGrey", flex: [1 / items.length + 1], minWidth: ['208px'], maxWidth: ['338px'], children: t(tTitle) })), jsx(Flex, { flexWrap: "wrap", width: "516px", children: items.map(({ tTitle, tDesc, href, base }) => (jsx(Box, { width: "50%", children: jsx(LearnCategory, { href: href, tTitle: tTitle, tDesc: tDesc, translateFn: t, base: base, onClick: onClickMenuLink }) }, tTitle))) })] }), i !== learnSec.length - 1 && (jsx(Box, { height: 0.5, bg: "secondaryDarkGrey" }))] }, tTitle));
        }) }));
};

const ProductCategory = ({ category, translateFn, onClick, ...restProps }) => (jsxs(Box, { ...restProps, children: [jsx(ForwardedTypography, { variant: "h7", color: "primaryBrightBlueLightBg", children: translateFn(category.tTitle) }), category.items.map(({ tTitle, tDesc, href, base }) => (jsx(Link, { href: href, onClick: onClick, base: base, children: jsxs(Flex, { flexDirection: "column", borderLeftWidth: 2, borderLeftColor: "primaryBrightBlueLightBg", borderLeftStyle: "solid", paddingLeft: 2, marginTop: 3, customCss: {
                    '&:hover': {
                        borderLeftColor: 'secondaryDarkNavy',
                        //NOTE link title will change color when hovered
                        '.linkTitle': {
                            color: 'secondaryDarkNavy',
                        },
                    },
                }, children: [jsx(ForwardedTypography, { variant: "subtitle2", color: "primaryDeepBlack", className: "linkTitle", children: translateFn(tTitle) }), jsx(ForwardedTypography, { variant: "caption", color: "secondaryDarkGrey", children: translateFn(tDesc) })] }) }, tTitle)))] }));

const ProductMenu$1 = ({ products, onClickMenuLink, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Box, { px: 8, children: products.map(({ tTitle, items }, i) => (jsxs(Box, { children: [jsxs(Flex, { py: 4, children: [tTitle && (jsx(ForwardedTypography, { variant: "h5", color: "secondaryDarkGrey", flex: [1 / items.length + 1], pr: 7, maxWidth: ['257px'], children: t(tTitle) })), items.map((category) => (jsx(Box, { flex: [1 / items.length + 1], paddingRight: i !== items.length - 1 ? 6 : 0, order: 1, children: jsx(ProductCategory, { category: category, translateFn: t, onClick: onClickMenuLink }) }, category.tTitle)))] }), i !== products.length - 1 && (jsx(Box, { height: 0.5, bg: "secondaryDarkGrey" }))] }, tTitle))) }));
};

const DesktopMenu = ({ products, company, isShowRewards, isShowNFT, isShowPrice, learnSec, ...restProps }) => {
    const { t } = useTranslation('navigation');
    const [isProductOpen, toggleProduct] = useToggleMenu();
    const [isCompanyOpen, toggleCompany] = useToggleMenu();
    const [isLearnOpen, toggleLearn] = useToggleMenu();
    return (jsxs(Box, { ...restProps, children: [isShowRewards && (jsx(Box, { className: "main-nav-rewards", children: jsx(Link, { href: links['products.rewards'].href, base: links['products.rewards'].base, children: jsx(DesktopMenuItem, { chevron: null, disableHover: true, titleColor: "rgba(17, 153, 250, 1)", title: t('products.rewards'), badgeTitle: t('navbar.new') }) }) })), isShowPrice && (jsx(Box, { className: "main-nav-prices", children: jsx(Link, { href: "https://crypto.com/price", children: jsx(DesktopMenuItem, { title: t('navbar.price'), chevron: null }) }) })), jsx(Popover, { variant: "container", isOpen: isProductOpen, onOutsideClick: toggleProduct, onMouseEnter: toggleProduct, onMouseLeave: toggleProduct, popMenu: jsx(ProductMenu$1, { products: products, onClickMenuLink: toggleProduct }), align: "center", 
                // Visual adjustment to align arrow to chevron
                offset: -4, children: jsx(Box, { className: "main-nav-products", children: jsx(DesktopMenuItem, { title: t('navbar.product'), onClick: toggleProduct }) }) }), jsx(Popover, { isOpen: isCompanyOpen, onOutsideClick: toggleCompany, onMouseEnter: toggleCompany, onMouseLeave: toggleCompany, popMenu: jsx(CompanyMenu$1, { company: company, onClickMenuLink: toggleCompany }), align: "center", 
                // Visual adjustment to align arrow to chevron
                offset: -4, children: jsx(Box, { className: "main-nav-company", children: jsx(DesktopMenuItem, { title: t('navbar.company'), onClick: toggleCompany }) }) }), learnSec && (jsx(Popover, { isOpen: isLearnOpen, onOutsideClick: toggleLearn, onMouseEnter: toggleLearn, onMouseLeave: toggleLearn, popMenu: jsx(LearnMenu$1, { learnSec: learnSec, onClickMenuLink: toggleLearn }), align: "center", 
                // Visual adjustment to align arrow to chevron
                offset: -4, children: jsx(Box, { className: "main-nav-company", children: jsx(DesktopMenuItem, { title: t('navbar.learn'), onClick: toggleLearn }) }) }))] }));
};

const Input = styled(Box) `
  appearance: none;
  border: none;
  background-color: transparent;
  -moz-appearance: none;
  -webkit-appearance: none;
  ${variant({
    variants: {
        default: {
            fontFamily: 'heading',
            fontSize: [16, 16, 21.5],
            lineHeight: ['100%', '135%', '100%'],
            letterSpacing: ['0.02em', '0.015em', '0.02em'],
            fontWeight: ['600', '600', '600'],
            color: 'primaryPaleWhite',
            height: 46,
            // px: 2,
            border: '2px solid black',
            borderColor: 'primaryBrightBlue',
            borderRadius: 8,
        },
        searchBar: {
            backgroundColor: '#0000',
            color: '#F7F9FA',
            border: 'unset',
            height: '24px',
            outline: 'none',
            lineHeight: '24px',
            fontSize: '24px',
        },
    },
})}
`;
const ForwardedInput = forwardRef(({ variant = 'default', type = 'text', ...props }, ref) => {
    return (jsx(Input, { as: "input", variant: variant, type: type, ...props, ref: ref }));
});
ForwardedInput.displayName = 'Input';

const SearchBar = () => {
    const [toggle, setToggle] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const context = useContext(NavFooterContext);
    const searchOnChange = useCallback((e) => {
        setSearchValue(e?.target?.value ?? '');
    }, []);
    const onSearch = useCallback(() => {
        context.onSearch && context.onSearch(searchValue);
    }, [context, searchValue]);
    return (jsx(Box, { display: ['none', 'none', 'flex'], marginRight: '40px', position: "relative", height: "39px", width: "27px", children: jsx("div", { style: { position: 'absolute', right: '0px' }, children: jsxs(m.div, { initial: 'init', animate: toggle ? 'open' : 'close', style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    padding: '6px 0px',
                }, variants: {
                    init: {
                        backgroundColor: '#06112100',
                        width: '27px',
                        borderBottom: '1px solid rgba(255,255,255,0)',
                    },
                    open: {
                        backgroundColor: [null, '#06112100', '#061121'],
                        width: [null, '502px', '502px'],
                        borderBottom: [
                            null,
                            '1px solid rgba(255,255,255,0)',
                            '1px solid rgba(255,255,255,0.3)',
                        ],
                        transition: { times: [0, 0.2, 1], duration: 0.4 },
                    },
                    close: {
                        backgroundColor: [null, '#06112100', '#06112100'],
                        width: [null, '502px', '27px'],
                        borderBottom: [
                            null,
                            '1px solid rgba(255,255,255,0)',
                            '1px solid rgba(255,255,255,0)',
                        ],
                        transition: { times: [0, 0.8, 1], duration: 0.4 },
                    },
                }, children: [jsx(Search, { width: "27px", tabIndex: 0, role: "button", "aria-label": "Search", opacity: toggle ? 1 : 0.5, customCss: {
                            '&:hover': {
                                opacity: 1,
                            },
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === 'Space') {
                                if (!toggle) {
                                    setToggle(true);
                                }
                                else {
                                    onSearch();
                                }
                            }
                        }, onClick: () => {
                            if (!toggle) {
                                setToggle(true);
                            }
                            else {
                                onSearch();
                            }
                        } }), jsx(AnimatePresence, { initial: false, children: toggle && (jsxs(m.div, { initial: "hide", animate: "open", exit: "hide", style: {
                                display: 'flex',
                            }, variants: {
                                open: { width: '100%', paddingLeft: '12px', opacity: 1 },
                                hide: { width: 0, paddingLeft: '0px', opacity: 0 },
                            }, transition: { type: 'easeInOut', duration: 0.4 }, children: [jsx(ForwardedInput, { width: "100%", variant: "searchBar", onChange: searchOnChange, value: searchValue, autoFocus: true, onKeyDown: (e) => {
                                        if (e.key === 'Enter')
                                            onSearch();
                                    } }), jsx(SearchClose, { display: toggle ? 'flex' : 'none', width: "20px", tabIndex: 0, role: "button", "aria-label": "close search bar", onKeyDown: (e) => {
                                        if (e.key === 'Enter' || e.key === 'Space')
                                            setToggle(false);
                                    }, onClick: () => {
                                        setToggle(false);
                                    } })] }, "content")) })] }) }) }));
};

const Line$6 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem$7 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const CompanyMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData.map((item, i) => (jsx(MotionItem$7, { children: jsx(Link, { href: item.href, base: item.base, onClick: onMenuItemClick, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$6, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const Line$5 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem$6 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const DefiMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData.map((item, i) => (jsx(MotionItem$6, { children: jsx(Link, { href: item.href, base: item.base, onClick: onMenuItemClick, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$5, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const Line$4 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem$5 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const EcoMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData.map((item, i) => (jsx(MotionItem$5, { children: jsx(Link, { href: item.href, base: item.base, onClick: onMenuItemClick, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$4, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const Line$3 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem$4 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const ExchangeMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData?.map((item, i) => (jsx(MotionItem$4, { children: jsx(Link, { href: item.href, base: item.base, onClick: onMenuItemClick, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$3, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const getRegions = (userRegion, country) => {
    let suggestRegion = [];
    let allRegion = [];
    // NOTE: user with SG region ip, cannot change region
    if (userRegion === RegionsEnum.SG) {
        suggestRegion = [RegionsEnum.SG];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    if (userRegion === RegionsEnum.UK) {
        suggestRegion = [RegionsEnum.UK];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    // NOTE: user from EEA Spanish, cannot change region
    if (userRegion === RegionsEnum.EEA) {
        suggestRegion = [RegionsEnum.EEA];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    if (userRegion === RegionsEnum.CA) {
        suggestRegion = [RegionsEnum.CA];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    if (userRegion === RegionsEnum.IT) {
        suggestRegion = [RegionsEnum.IT];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    if (userRegion === RegionsEnum.KR) {
        suggestRegion = [RegionsEnum.KR];
        allRegion = [];
        return [suggestRegion, allRegion];
    }
    if (userRegion === country) {
        suggestRegion.push(country);
    }
    else {
        suggestRegion.push(country, userRegion);
    }
    allRegion = navAvailRegions.filter((region) => {
        if (region === RegionsEnum.GLOBAL && country === RegionsEnum.GLOBAL)
            return false;
        return country !== region && userRegion !== region;
    });
    return [suggestRegion, allRegion];
};
const getLanguages = (currentLanguage, languages) => {
    const suggestLangs = [currentLanguage];
    const allLangs = languages.filter((language) => language !== (currentLanguage || fallback));
    return [suggestLangs, allLangs];
};

const useFreeze = () => {
    // Disable body scrolling when mobile menu open
    useEffect(() => {
        document.body.style.overflowY = 'hidden';
        return () => {
            document.body.style.overflowY = 'unset';
        };
    }, []);
};

const LangLocMenuItem = ({ title, menuContent, isExpandable, isExpanded = false, onClick, ...props }) => {
    return (jsxs(Box, { ...props, children: [jsx(ForwardedButton, { width: "100%", variant: "navMenu", onClick: isExpandable ? onClick : undefined, height: "56px", children: jsxs(Flex, { alignItems: "center", justifyContent: "space-between", children: [jsx(Flex, { alignItems: "center", children: jsx(ForwardedTypography, { variant: "langTitle", color: "primaryDeepBlack", children: title }) }), isExpandable && onClick && (jsx(ChevronDown, { width: "12px", color: "#0E213B", customCss: isExpanded
                                ? {
                                    fill: '#0E213B',
                                    transform: 'rotate(180deg)',
                                    transition: 'transform 0.5s ease',
                                }
                                : {
                                    fill: '#0E213B',
                                    transform: 'rotate(0deg)',
                                    transition: 'transform 0.5s ease',
                                } }))] }) }), jsx(AnimatePresence, { children: isExpanded && (jsx(m.section, { initial: "collapsed", animate: "open", exit: 'collapsed', variants: {
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 },
                    }, transition: { duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }, children: menuContent })) })] }));
};

const MotionItem$3 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const LanguageMenu = ({ languages, onClick, margin, ...restProps }) => {
    const { i18n } = useTranslation();
    const { language: currentLanguage } = i18n;
    const navContext = useContext(NavFooterContext);
    const languageOptions = languages.filter((language) => language !== (currentLanguage || fallback));
    return (jsx(Box, { ...restProps, pl: 0, bg: '#F7F9FA', style: {
            boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
        }, children: languages.map((language, i) => (jsx(MotionItem$3, { children: jsxs(Flex, { margin: margin, alignItems: 'center', width: '100%', height: '46px', onClick: () => {
                    i18n.changeLanguage(language);
                    if (navContext.langChangeCallback) {
                        navContext.langChangeCallback(language);
                    }
                    onClick();
                }, borderBottom: i !== languageOptions.length ? '2px solid #fff' : 0, children: [jsx(ForwardedTypography, { variant: "menuTitle", color: language === currentLanguage ? '#0058AA' : '#061121', pl: [6, 10], pr: '18px', mt: 4.5, children: i18nLanguageToDisplayString(language) }), language === currentLanguage ? jsx(Select, { width: "21px" }) : null] }, language) }, language))) }));
};

const MotionItem$2 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const RegionMenu = ({ onClick, ...restProps }) => {
    const { t } = useTranslation('navigation');
    const context = useContext(NavFooterContext);
    // const getRegionFlagIcon = (region: string) => {
    //   const flagStr = `${region.toUpperCase()}Flag`
    //   const RegionIcon = (Icon as any)[flagStr]
    //   return React.createElement(RegionIcon, {
    //     fontSize: '22px',
    //     border: '1.5px solid #000000',
    //     borderRadius: '50%',
    //   })
    // }
    return (jsx(Box, { ...restProps, pl: 0, bg: '#F7F9FA', style: {
            boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
        }, children: navAvailRegions.map((region, i) => (jsx(MotionItem$2, { children: jsxs(Flex, { onClick: () => {
                    //  TODO improve lower case an upper case, cookie now is UPPERCASE❗️
                    onClick(region);
                }, alignItems: "center", height: '46px', pl: [6, 9], borderBottom: i !== navAvailRegions.length - 1 ? '2px solid #fff' : 0, children: [jsx(ForwardedTypography, { variant: "menuTitle", color: context.country === region ? '#0058AA' : '#061121', maxWidth: ['200px', 'max-content'], marginLeft: '12px', mr: '9px', mt: 4.5, className: "text", whiteSpace: "nowrap", children: t(`geolocation.${region.toLowerCase()}`) }), context.country === region ? jsx(Select, { width: "21px" }) : null] }, region) }, region))) }));
};

const LangHeader = styled(Flex) `
  height: 62px;
  justify-content: space-between;
  align-items: center;
`;
const LangMobileMenu = ({ onCloseButtonClick, onSubMenuItemClick, onSetRegion, languages, }) => {
    const [expandedIndex, setExpandedIndex] = useState(-1);
    const { t, i18n } = useTranslation('navigation');
    const context = useContext(NavFooterContext);
    const currentLocation = t(context.country ? `geolocation.${context.country.toLowerCase()}` : `Global`);
    const currentLanguage = i18nLanguageToDisplayString(i18n.language);
    const languageOptions = languages.filter((language) => language !== (currentLanguage || fallback));
    const [, regionList] = getRegions(context.geoLocation.geoRegion, context.country);
    // TODO why creating this kind of function :-(
    const handleMenuItemClick = (i) => () => {
        if (i === expandedIndex) {
            setExpandedIndex(-1);
            return;
        }
        setExpandedIndex(i);
    };
    useFreeze();
    return (jsxs(Box, { width: "100%", height: "100%", bg: "#fff", overflowY: "scroll", display: 'flex', flexDirection: 'column', customCss: { WebkitOverflowScrolling: 'touch' }, children: [jsxs(LangHeader, { px: [4, 8], borderBottom: '1px solid #CED0D0', children: [jsxs(Flex, { color: 'black', onClick: onCloseButtonClick, alignItems: 'center', children: [jsx(ForwardedButton, { variant: "plain", onClick: onCloseButtonClick, ml: ['3px', '3px'], mr: '13px', children: jsx(ChevronLeftNarrow, { width: "8px", color: "#061121" }) }), jsx(ForwardedTypography, { variant: "menuSubTitle", color: "#061121", mt: 4.5, mr: 1, children: t('navbar.back') })] }), jsx(Flex, { children: jsx(ForwardedButton, { variant: "plain", onClick: onCloseButtonClick, ml: [2, 5], mr: '3px', children: jsx(Close, { width: "20px", color: "secondaryDarkNavy" }) }) })] }), jsxs(Box, { flex: 1, overflow: 'auto', pt: '20px', children: [jsx(LangLocMenuItem, { title: t('geolocation.location'), isExpandable: regionList.length !== 0, isExpanded: expandedIndex === 0, onClick: handleMenuItemClick(0), menuContent: jsx(RegionMenu, { onClick: (region) => {
                                onSetRegion(region);
                            }, paddingLeft: [3, 5], margin: 0 }) }), expandedIndex === -1 || expandedIndex !== 0 ? (jsx(Flex, { ml: [6, 10], alignItems: 'center', children: jsx(ForwardedTypography, { variant: "menuTitle", color: '#061121', mt: 4.5, children: currentLocation }) })) : null, jsx(LangLocMenuItem, { title: t('geolocation.lang_mobile'), isExpandable: languageOptions.length !== 1, isExpanded: expandedIndex === 1, onClick: handleMenuItemClick(1), menuContent: jsx(LanguageMenu, { onClick: onSubMenuItemClick, languages: languages, paddingLeft: [3, 5], margin: 0 }) }), expandedIndex === -1 || expandedIndex !== 1 ? (jsx(ForwardedTypography, { variant: "menuTitle", color: '#061121', mt: 4.5, ml: [6, 10], children: currentLanguage })) : null] })] }));
};

const Line$2 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem$1 = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const LearnMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { className: "mobile-nav-learn", bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData.map((item, i) => (jsx(MotionItem$1, { children: jsx(Link, { href: item.href, onClick: onMenuItemClick, base: item.base, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$2, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const MobileMenuItem = ({ title, badgeTitle, menuContent, isExpanded = false, onClick, ...props }) => {
    return (jsxs(Box, { ...props, children: [jsx(ForwardedButton, { width: "100%", variant: "navMenu", onClick: onClick, height: "56px", children: jsxs(Flex, { alignItems: "center", justifyContent: "space-between", children: [jsxs(Flex, { alignItems: "center", children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "primaryDeepBlack", children: title }), badgeTitle && (jsx(Badge, { variant: "light", ml: 1, children: badgeTitle }))] }), onClick && (jsx(ChevronDown, { width: "12px", color: "#0E213B", customCss: isExpanded
                                ? {
                                    fill: '#0E213B',
                                    transform: 'rotate(180deg)',
                                    transition: 'transform 0.5s ease',
                                }
                                : {
                                    fill: '#0E213B',
                                    transform: 'rotate(0deg)',
                                    transition: 'transform 0.5s ease',
                                } }))] }) }), jsx(AnimatePresence, { children: isExpanded && (jsx(m.section, { initial: "collapsed", animate: "open", exit: 'collapsed', variants: {
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 },
                    }, transition: { duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }, children: menuContent })) })] }));
};

const Line$1 = styled(Box) `
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`;
const MotionItem = ({ children }) => {
    return (jsx(m.div, { variants: {
            open: { scale: 1 },
            collapsed: { scale: 1 },
        }, transition: { duration: 0.3 }, children: children }));
};
const ProductMenu = ({ menuData, onMenuItemClick, }) => {
    const { t } = useTranslation('navigation');
    return (jsx(Fragment, { children: jsx(Box, { bg: '#F7F9FA', style: {
                boxShadow: 'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
            }, children: jsx(AnimatePresence, { children: menuData.map((item, i) => (jsx(MotionItem, { children: jsx(Link, { href: item.href, base: item.base, onClick: onMenuItemClick, children: jsxs(Flex, { pl: [5, 9], py: 1.5, alignItems: 'center', borderBottom: i !== menuData.length - 1 ? '2px solid #fff' : 0, children: [jsx(Line$1, {}), jsxs(Box, { mt: '2px', children: [jsx(ForwardedTypography, { variant: "menuTitle", color: "#061121", mb: '2px', children: t(item.tTitle) }), jsx(ForwardedTypography, { variant: "menuDescription", color: "#7B849B", children: t(item.tDesc) })] })] }, item.tTitle) }) }, item.tTitle))) }) }) }));
};

const MenuHeader = styled(Flex) `
  height: 62px;
  justify-content: space-between;
  align-items: center;
`;
const Line = styled(Box) `
  width: 1px;
  height: 16px;
  background: #424242;
`;
const MenuFooter = styled(Box) `
  padding: 0 32px;
`;
const DownloadApp = styled(Flex) `
  height: 48px;
  padding: 0 20px;
  border: 1.5px solid #0b1426;
  border-radius: 4px;
  align-items: center;
`;
const MobileMenu = ({ onCloseButtonClick, onSubMenuItemClick, products, isExchange, exchange, isDefi, defi, isEco, eco, company, isShowRewards, isShowNFT, isShowPrice, languages, learn, allRegion, }) => {
    const [expandedIndex, setExpandedIndex] = useState(-1);
    const [isLangOpen, toggleLang] = useToggleMenu();
    const { t, i18n } = useTranslation('navigation');
    const userAgent = useUserAgent();
    const isIos = userAgent === 'ios';
    const { queryString } = useOneLink();
    const navContext = useContext(NavFooterContext);
    const { language: currentLanguage } = i18n;
    // TODO why creating this kind of function :-(
    const handleMenuItemClick = (i) => () => {
        if (i === expandedIndex) {
            setExpandedIndex(-1);
            return;
        }
        setExpandedIndex(i);
    };
    useFreeze();
    return (jsxs(Box, { width: "100%", height: "100%", bg: "#fff", overflowY: "scroll", display: 'flex', flexDirection: 'column', customCss: { WebkitOverflowScrolling: 'touch' }, children: [jsxs(MenuHeader, { px: [4, 8], borderBottom: '1px solid #CED0D0', children: [jsx(Flex, { onClick: toggleLang, alignItems: 'center', children: navContext.hasLangCountrySwitch && (jsxs(Fragment, { children: [jsx(GLOBALFlag, { width: '24px', border: '1.5px solid #000000', borderRadius: '50%', mr: '10px' }), jsx(ForwardedTypography, { variant: "subtitle5", color: "#424242", mt: 4.5, children: navContext.country.toUpperCase() }), jsx(Line, { ml: navContext.country ? 1 : 0, mr: 1 }), jsx(ForwardedTypography, { variant: "subtitle5", color: "#424242", mt: 4.5, children: currentLanguage.toUpperCase() })] })) }), jsx(AnimatePresence, { children: isLangOpen && (jsx(m.div, { className: "mobile-nav-language", style: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                zIndex: 999,
                            }, initial: { x: '100%' }, animate: { x: 0 }, exit: { x: '100%' }, transition: { bounce: 0, duration: 0.2 }, children: jsx(LangMobileMenu, { onCloseButtonClick: toggleLang, onSubMenuItemClick: toggleLang, languages: languages, allRegion: allRegion, onSetRegion: (region) => {
                                    if (navContext.countryChangeCallback) {
                                        navContext.countryChangeCallback(region.toLowerCase());
                                    }
                                } }) })) }), jsx(Flex, { alignItems: "center", children: jsx(ForwardedButton, { variant: "plain", onClick: onCloseButtonClick, ml: [2, 5], mr: '3px', children: jsx(Close, { width: "20px", color: "secondaryDarkNavy" }) }) })] }), jsx(Box, { flex: 1, overflow: 'auto', children: jsxs(Flex, { display: 'flex', height: '100%', flexDirection: 'column', children: [jsx(MobileMenuItem, { className: "mobile-nav-app", title: t('products.crypto'), isExpanded: expandedIndex === 0, onClick: handleMenuItemClick(0), menuContent: jsx(ProductMenu, { menuData: products, onMenuItemClick: onSubMenuItemClick }) }), isExchange && (jsx(MobileMenuItem, { className: "mobile-nav-exchange", title: t('products.exchange'), isExpanded: expandedIndex === 1, onClick: handleMenuItemClick(1), menuContent: jsx(ExchangeMenu, { menuData: exchange, onMenuItemClick: onSubMenuItemClick }) })), isDefi && (jsx(MobileMenuItem, { className: "mobile-nav-defi", title: t('products.defi'), isExpanded: expandedIndex === 5, onClick: handleMenuItemClick(5), menuContent: jsx(DefiMenu, { menuData: defi, onMenuItemClick: onSubMenuItemClick }) })), isEco && (jsx(MobileMenuItem, { className: "mobile-nav-ecosystem", title: t('products.eco'), isExpanded: expandedIndex === 6, onClick: handleMenuItemClick(6), menuContent: jsx(EcoMenu, { menuData: eco, onMenuItemClick: onSubMenuItemClick }) })), jsx(MobileMenuItem, { className: "mobile-nav-company", title: t('navbar.company'), isExpanded: expandedIndex === 2, onClick: handleMenuItemClick(2), menuContent: jsx(CompanyMenu, { menuData: company, onMenuItemClick: onSubMenuItemClick }) }), learn && (jsx(MobileMenuItem, { className: "mobile-nav-learn", title: t('navbar.learn'), isExpanded: expandedIndex === 3, onClick: handleMenuItemClick(3), menuContent: jsx(LearnMenu, { menuData: learn, onMenuItemClick: onSubMenuItemClick }) })), isShowPrice && (jsx(Box, { children: jsx(Link, { href: "https://crypto.com/price", onClick: onSubMenuItemClick, children: jsx(MobileMenuItem, { className: "mobile-nav-prices", title: t('navbar.price') }) }) })), isShowNFT && (jsx(Box, { mb: [5, 4], children: jsx(Link, { href: "https://crypto.com/nft", onClick: onSubMenuItemClick, children: jsx(MobileMenuItem, { className: "mobile-nav-nft", title: t('navbar.nft') }) }) }))] }) }), jsx(MenuFooter, { borderTop: '1px solid #CED0D0', children: jsx(Flex, { height: 62, alignItems: 'center', justifyContent: 'space-between', children: jsx(Link, { href: isIos
                            ? `https://crypto.onelink.me/RSfq${queryString}`
                            : `https://crypto.onelink.me/veNW${queryString}`, children: jsxs(DownloadApp, { className: "mobile-nav-cta-download", children: [jsx(DownloadApp$1, { height: "20px" }), jsx(ForwardedTypography, { variant: "downloadBtn", color: '#0B1426', ml: 1, children: t('navbar.downloadButton') })] }) }) }) })] }));
};

const Navbar = ({ variant = 'dark', layerIndex, products, isExchange, exchange, isDefi, defi, isEco, eco, company, learn_desktop, company_desktop, products_desktop, isShowRewards, isShowNFT, isShowPrice, logoHref, languages, learn, isShowLogoFlag = '', isShowBanner, isShowRiskWarn, }) => {
    const { i18n } = useTranslation('navigation');
    const { language: currentLanguage } = i18n;
    const [isMobileOpen, toggleMobile] = useToggleMenu();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const navContext = useContext(NavFooterContext);
    const [suggestRegion, allRegion] = getRegions(navContext.geoLocation.geoRegion, navContext.country);
    const [suggestLangs, allLangs] = getLanguages(currentLanguage, languages);
    // const RegionIcon = userRegionIndicator(
    //   navContext.country.toUpperCase() as Regions
    // )
    const onPopupClose = () => {
        setPopupOpen(false);
    };
    return (jsx(LazyMotion, { features: domAnimation, strict: true, children: jsxs(Flex, { className: "navbar-container", position: "sticky", top: 0, left: 0, flexDirection: 'column', zIndex: layerIndex ?? 99, children: [isShowRiskWarn && jsx(RiskWarningBanner, {}), jsx(Flex, { width: "100%", zIndex: layerIndex ?? 99, alignItems: "center", backgroundColor: "backgroundDark", height: ['62px', '62px', '78px'], maxWidth: '100vw', children: jsx(Container, { flex: 1, children: jsxs(Flex, { alignItems: "center", justifyContent: "space-between", px: ['8px', '8px', '0px'], children: [jsx(Logo, { variant: variant, href: logoHref, isShowLogoFlag: isShowLogoFlag }), jsxs(Flex, { alignItems: "center", children: [jsx(DesktopMenu, { alignItems: "center", marginRight: '20px', style: { columnGap: '24px' }, display: ['none', 'none', 'flex'], variant: variant, company: company_desktop, products: products_desktop, isShowRewards: isShowRewards, isShowNFT: isShowNFT, isShowPrice: isShowPrice, learnSec: learn_desktop }), navContext.hasSearchBar && jsx(SearchBar, {}), jsx(DownloadButtons, {}), navContext.hasLangCountrySwitch && (jsxs(Box, { marginLeft: "20px", display: ['none', 'none', 'flex'], alignItems: "center", style: { cursor: 'pointer' }, onClick: () => {
                                                setPopupOpen(true);
                                            }, children: [jsx(GeolocationThin, { width: "22px", color: "#fff" }), jsx(ForwardedTypography, { variant: "subtitle5", color: "#fff", marginLeft: '6px', mt: '2px', children: currentLanguage.toUpperCase() })] })), jsx(ForwardedButton, { variant: "plain", marginLeft: [3, 5], mr: '3px', display: ['block', 'block', 'none'], onClick: toggleMobile, "aria-label": "menu", children: jsx(Menu, { width: "22px", color: "secondaryLightGrey" }) })] }), jsx(NavBarModal, { isOpen: isPopupOpen, setOpen: onPopupClose, suggestRegion: suggestRegion, allRegion: allRegion, suggestLangs: suggestLangs, allLangs: allLangs, onSetRegion: (region) => {
                                        if (navContext.countryChangeCallback) {
                                            navContext.countryChangeCallback(region.toLowerCase());
                                        }
                                        setPopupOpen(false);
                                    } })] }) }) }), jsx(AnimatePresence, { children: isMobileOpen && (jsx(m.div, { style: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 99,
                        }, initial: { x: '100%' }, animate: { x: 0 }, exit: { x: '100%' }, transition: { bounce: 0, duration: 0.2 }, children: jsx(MobileMenu, { onCloseButtonClick: toggleMobile, onSubMenuItemClick: toggleMobile, products: products, isExchange: isExchange, exchange: exchange, isDefi: isDefi, defi: defi, isEco: isEco, eco: eco, company: company, isShowRewards: isShowRewards, isShowPrice: isShowPrice, isShowNFT: isShowNFT, languages: languages, learn: learn, allRegion: allRegion }) })) }), isShowBanner && jsx(NavBarBanner, {})] }) }));
};

/**
 *
 * @param baseHref should start with `/`
 */
const getRegionalHref = (baseHref, region) => {
    if (region === RegionsEnum.GLOBAL)
        return baseHref;
    return `/${region.toLowerCase()}`;
};

const useBelgiumAccess = (geoCountry) => {
    const [isBelgiumAccess, setBelgiumAccess] = useState(false);
    useEffect(() => {
        let isMounted = true;
        const isBelgiumAccess = 'BE' === geoCountry;
        isMounted && setBelgiumAccess(isBelgiumAccess);
        return () => {
            isMounted = false;
        };
    }, [geoCountry]);
    return isBelgiumAccess;
};

const usePrimeAccess = (geoCountry) => {
    const [isPrimeAccess, setPrimeAccess] = useState(true);
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (geoCountry === 'HK') {
                setPrimeAccess(false);
            }
            else {
                setPrimeAccess(true);
            }
        }
        return () => {
            isMounted = false;
        };
    }, [geoCountry]);
    return isPrimeAccess;
};

// NOTE https://mcoproduct.atlassian.net/browse/WRP1-664, no margin and derivative trading links
const getProductsAU = (isStakingAvail) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        isStakingAvail ? links['products.staking'] : null,
    ].filter((product) => product !== null);
};
const defi_au = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_au = [links['products.payMerchant']];
const getProductsDesktopAU = (isStakingAvail) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [links['products.rewards'], links['products.staking']]
                        : [links['products.rewards']],
                },
            ].filter(Boolean),
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
            ],
        },
    ];
};
const learn_au = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_au = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_au = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_au = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsBR = (isStakingAvail, isPrimeAvail) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAvail ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_br = [links['products.exchangeIndex']];
const defi_br = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_br = [links['products.payMerchant']];
const getProductsDesktopBR = (isStakingAvail, isPrimeAvail) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAvail
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [
                            links['products.rewards'],
                            links['products.earn'],
                            links['products.staking'],
                        ]
                        : [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [links['products.exchangeIndex']],
                },
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
            ],
        },
    ];
};
const learn_br = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_br = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_br = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_br = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsCA = (isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_ca = [links['products.exchangeIndex']];
const eco_ca = [links['products.payMerchant']];
const getProductsDesktopCA = (isPrimeAccess) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [links['products.exchangeIndex']],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
                //TODO just found that this is a placeholder to align with design ... need to improve later
                {
                    tTitle: '',
                    items: [
                        {
                            tTitle: '',
                            tDesc: '',
                            href: '/', //NOTE add a relative path to avoid dev console warning of using GatsbyLink for external link
                        },
                    ],
                },
            ],
        },
    ];
};
const learn_ca = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.glossary'],
];
const company_ca = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_ca = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_ca = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsEEA = (isStakingAvail, isPrimeAccess, isRewardsAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        isRewardsAccess ? links['products.rewards'] : null,
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_eea = [
    links['products.exchangeIndex'],
    links['products.marginTrading'],
    links['products.derivatives'],
];
const defi_eea = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_eea = [links['products.payMerchant']];
const getProductsDesktopEEA = (isStakingAvail, isPrimeAccess, isRewardsAccess) => {
    let categoryGrowArray = [
        links['products.rewards'],
        links['products.earn'],
        links['products.staking'],
    ];
    if (!isStakingAvail) {
        categoryGrowArray = categoryGrowArray.filter((products) => products !== links['products.staking']);
    }
    if (!isRewardsAccess) {
        categoryGrowArray = categoryGrowArray.filter((products) => products !== links['products.rewards']);
    }
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: categoryGrowArray,
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [
                        links['products.exchangeIndex'],
                        links['products.marginTrading'],
                        links['products.derivatives'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
            ],
        },
    ];
};
const learn_eea = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_eea = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_eea = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_eea = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsFR = (isStakingAvail, isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const defi_fr = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_fr = [links['products.payMerchant']];
const getProductsDesktopFR = (isStakingAvail, isPrimeAccess) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [
                            links['products.rewards'],
                            links['products.earn'],
                            links['products.staking'],
                        ]
                        : [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
                //TODO just found that this is a placeholder to align with design ... need to improve later
                {
                    tTitle: '',
                    items: [
                        {
                            tTitle: '',
                            tDesc: '',
                            href: '/', //NOTE add a relative path to avoid dev console warning of using GatsbyLink for external link
                        },
                    ],
                },
            ],
        },
    ];
};
const learn_fr = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_fr = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_fr = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_fr = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsGlobal = (isStakingAvail, isPrimeAvail, isRewardsAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        isRewardsAccess ? links['products.rewards'] : null,
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAvail ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_global = [
    links['products.exchangeIndex'],
    links['products.marginTrading'],
    links['products.derivatives'],
];
const defi_global = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_global = [links['products.payMerchant']];
const getProductsDesktopGlobal = (isStakingAvail, isPrimeAvail, isRewardsAccess) => {
    let categoryGrowArray = [
        links['products.rewards'],
        links['products.earn'],
        links['products.staking'],
    ];
    if (!isStakingAvail) {
        categoryGrowArray = categoryGrowArray.filter((products) => products !== links['products.staking']);
    }
    if (!isRewardsAccess) {
        categoryGrowArray = categoryGrowArray.filter((products) => products !== links['products.rewards']);
    }
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAvail
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: categoryGrowArray,
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [
                        links['products.exchangeIndex'],
                        links['products.marginTrading'],
                        links['products.derivatives'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
            ],
        },
    ];
};
const learn_global = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_global = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_global = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_global = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsIT = (isStakingAvail, isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_it = [links['products.exchangeIndex']];
const defi_it = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const getProductsDesktopIT = (isStakingAvail, isPrimeAccess) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [
                            links['products.rewards'],
                            links['products.earn'],
                            links['products.staking'],
                        ]
                        : [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [links['products.exchangeIndex']],
                },
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: '',
                    items: [
                        {
                            tTitle: '',
                            tDesc: '',
                            href: '/', //NOTE add a relative path to avoid dev console warning of using GatsbyLink for external link
                        },
                    ],
                },
            ],
        },
    ];
};
const learn_it = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_it = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_it = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_it = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const products_kr = [links['products.buyAndSell']];
const products_desktop_kr = [
    {
        tTitle: 'products.sectionTitle_getStarted',
        items: [
            {
                tTitle: 'products.categoryTitle_buyAndSell',
                items: [links['products.app'], links['products.nft']],
            },
        ],
    },
];
const learn_kr = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_kr = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_kr = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_kr = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsSG = (isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const getProductsDesktopSG = (isPrimeAccess) => {
    return [
        {
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [links['products.app'], links['products.prime']]
                        : [links['products.app']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: [links['products.rewards'], links['products.earn']],
                },
            ],
        },
    ];
};
const company_sg = [
    links['company.about'],
    links['company.careers'],
    links['company.security'],
    links['company.partners'],
];
const company_desktop_sg = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.careers'],
            links['company.security'],
            links['company.partners'],
        ],
    },
];
const learn_sg = [links['learn.glossary']];
const learn_desktop_sg = [
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [links['learn.glossary']],
    },
];

const getProductsTR = (isStakingAvail) => {
    return [
        links['products.buyAndSell'],
        links['products.rewards'],
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
    ].filter((product) => product !== null);
};
const defi_tr = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const getProductsDesktopTR = (isStakingAvail) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [
                            links['products.rewards'],
                            links['products.earn'],
                            links['products.staking'],
                        ]
                        : [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
            ],
        },
    ];
};
const learn_tr = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_tr = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_tr = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_tr = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

const getProductsUK = (isStakingAvail, isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.earn'],
        isStakingAvail ? links['products.staking'] : null,
        isPrimeAccess ? links['products.prime'] : null,
    ].filter((product) => product !== null);
};
const exchange_uk = [links['products.exchangeIndex']];
const defi_uk = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const getProductsDesktopUK = (isStakingAvail, isPrimeAccess) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                        ]
                        : [links['products.app'], links['products.nft']],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: isStakingAvail
                        ? [links['products.earn'], links['products.staking']]
                        : [links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_exchange',
                    items: [links['products.exchangeIndex']],
                },
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
            ],
        },
    ];
};
const learn_uk = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_uk = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_uk = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_uk = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];
const eco_uk = [links['products.payMerchant']];

const getProductsUS = (isPrimeAccess) => {
    return [
        links['products.buyAndSell'],
        links['products.metalCards'],
        links['products.pay'],
        links['products.rewards'],
        links['products.earn'],
        isPrimeAccess ? links['products.prime'] : null,
        links['products.appDerivatives'],
    ].filter((product) => product !== null);
};
const defi_us = [
    links['products.defiWallet'],
    links['products.browserExt'],
    links['products.desktopWallet'],
];
const eco_us = [links['products.payMerchant']];
const getProductsDesktopUS = (isPrimeAccess) => {
    return [
        {
            tTitle: 'products.sectionTitle_getStarted',
            items: [
                {
                    tTitle: 'products.categoryTitle_buyAndSell',
                    items: isPrimeAccess
                        ? [
                            links['products.app'],
                            links['products.nft'],
                            links['products.prime'],
                            links['products.appDerivatives'],
                        ]
                        : [
                            links['products.app'],
                            links['products.nft'],
                            links['products.appDerivatives'],
                        ],
                },
                {
                    tTitle: 'products.categoryTitle_spend',
                    items: [links['products.metalCards'], links['products.pay']],
                },
                {
                    tTitle: 'products.categoryTitle_grow',
                    items: [links['products.rewards'], links['products.earn']],
                },
            ],
        },
        {
            tTitle: 'products.sectionTitle_advancedTrading',
            items: [
                {
                    tTitle: 'products.categoryTitle_defi',
                    items: [
                        links['products.defiWallet'],
                        links['products.browserExt'],
                        links['products.desktopWallet'],
                    ],
                },
                {
                    tTitle: 'products.categoryTitle_ecosystem',
                    items: [links['products.payMerchant']],
                },
                //TODO just found that this is a placeholder to align with design ... need to improve later
                {
                    tTitle: '',
                    items: [
                        {
                            tTitle: '',
                            tDesc: '',
                            href: '/', //NOTE add a relative path to avoid dev console warning of using GatsbyLink for external link
                        },
                    ],
                },
            ],
        },
    ];
};
const learn_us = [
    links['learn.trending'],
    links['learn.marketUpdates'],
    links['learn.productNews'],
    links['learn.events'],
    links['learn.university'],
    links['learn.reportsAndAnalysis'],
    links['learn.nftStories'],
    links['learn.glossary'],
];
const company_us = [
    links['company.about'],
    links['company.careers'],
    links['company.news'],
    links['company.support'],
    links['company.security'],
    links['company.partners'],
];
const learn_desktop_us = [
    {
        tTitle: 'learn.categoryTitle_updates',
        items: [
            links['learn.trending'],
            links['learn.events'],
            links['learn.productNews'],
            links['learn.marketUpdates'],
        ],
    },
    {
        tTitle: 'learn.categoryTitle_resources',
        items: [
            links['learn.university'],
            links['learn.reportsAndAnalysis'],
            links['learn.nftStories'],
            links['learn.glossary'],
        ],
    },
];
const company_desktop_us = [
    {
        tTitle: 'company.sectionTitle_aboutUs',
        items: [
            links['company.about'],
            links['company.support'],
            links['company.careers'],
            links['company.security'],
            links['company.news'],
            links['company.partners'],
        ],
    },
];

// NOTE this function is used to generate region sites config
const useStaticSiteConfig = (region) => {
    const basicConfig = {
        isExchange: true,
        isDefi: true,
        isEco: true,
        isShowNFT: true,
        isShowRewards: false,
        isShowPrice: true,
        isShowLanguages: true,
        logoHref: getRegionalHref('/', region),
        languages: regularSiteLanguages,
        isShowGeoIcon: true,
        isShowLogoFlag: '',
        isShowBanner: false,
        isShowRiskWarn: false,
    };
    const navContext = useContext(NavFooterContext);
    const isSpainUser = useSpanishAccess(navContext.geoLocation.geoCountry);
    const isBelgiumUser = useBelgiumAccess(navContext.geoLocation.geoCountry);
    const isStakingAvailable = useStakingAccess(navContext.geoLocation.geoCountry);
    const isPrimeAccess = usePrimeAccess(navContext.geoLocation.geoCountry);
    const isRewardsAccess = useRewardsAccess(navContext.geoLocation.geoCountry, region);
    if (region === RegionsEnum.US) {
        return {
            ...basicConfig,
            languages: usSiteLanguages,
            products: getProductsUS(isPrimeAccess),
            exchange: exchange_global,
            defi: defi_us,
            eco: eco_us,
            company: company_us,
            company_desktop: company_desktop_us,
            products_desktop: getProductsDesktopUS(isPrimeAccess),
            learn: learn_us,
            learn_desktop: learn_desktop_us,
            isShowRewards: true,
            isShowNFT: false,
            isExchange: false,
            isShowLogoFlag: 'US',
        };
    }
    if (region === RegionsEnum.EEA) {
        //for Spanish IP user , not showing geo selection
        if (isSpainUser) {
            return {
                ...basicConfig,
                products: getProductsEEA(true, true, true),
                exchange: exchange_eea,
                defi: defi_eea,
                eco: eco_eea,
                company: company_eea,
                company_desktop: company_desktop_eea,
                products_desktop: getProductsDesktopEEA(true, true, true),
                // NOTE no show language switch list on EEA site
                isShowLanguages: false,
                languages: eeaSiteLanguages,
                learn: learn_eea,
                learn_desktop: learn_desktop_eea,
                isShowGeoIcon: false,
                isShowLogoFlag: 'EEA',
                isShowRewards: true,
                isShowNFT: false,
            };
        }
        else {
            return {
                ...basicConfig,
                products: getProductsEEA(isStakingAvailable, isPrimeAccess, isRewardsAccess),
                exchange: exchange_eea,
                defi: defi_eea,
                eco: eco_eea,
                company: company_eea,
                company_desktop: company_desktop_eea,
                products_desktop: getProductsDesktopEEA(isStakingAvailable, isPrimeAccess, isRewardsAccess),
                // NOTE no show language switch list on EEA site
                isShowLanguages: false,
                languages: eeaSiteLanguages,
                learn: learn_eea,
                learn_desktop: learn_desktop_eea,
                isShowLogoFlag: 'EEA',
                isShowRewards: isRewardsAccess,
                isShowNFT: false,
                isShowRiskWarn: isBelgiumUser ? true : false,
            };
        }
    }
    if (region === RegionsEnum.SG) {
        return {
            ...basicConfig,
            products: getProductsSG(isPrimeAccess),
            exchange: exchange_global,
            defi: defi_global,
            eco: eco_global,
            company: company_sg,
            company_desktop: company_desktop_sg,
            learn: learn_sg,
            learn_desktop: learn_desktop_sg,
            products_desktop: getProductsDesktopSG(isPrimeAccess),
            // NOTE no these two menu on navbar on SG site
            isExchange: false,
            isDefi: false,
            isEco: false,
            isShowPrice: false,
            isShowNFT: false,
            isShowLogoFlag: 'SG',
            isShowRewards: true,
        };
    }
    if (region === RegionsEnum.AU) {
        return {
            ...basicConfig,
            products: getProductsAU(isStakingAvailable),
            exchange: exchange_global,
            defi: defi_au,
            eco: eco_au,
            company: company_au,
            company_desktop: company_desktop_au,
            products_desktop: getProductsDesktopAU(isStakingAvailable),
            learn: learn_au,
            learn_desktop: learn_desktop_au,
            isShowLogoFlag: 'AU',
            isExchange: false,
            isShowRewards: true,
        };
    }
    if (region === RegionsEnum.BR) {
        return {
            ...basicConfig,
            products: getProductsBR(isStakingAvailable, isPrimeAccess),
            exchange: exchange_br,
            defi: defi_br,
            eco: eco_br,
            company: company_br,
            company_desktop: company_desktop_br,
            products_desktop: getProductsDesktopBR(isStakingAvailable, isPrimeAccess),
            // NOTE language list is different on BR site
            languages: brSiteLanguages,
            learn: learn_br,
            learn_desktop: learn_desktop_br,
            isShowLogoFlag: 'BR',
            isShowRewards: true,
            isShowNFT: false,
        };
    }
    if (region === RegionsEnum.TR) {
        return {
            ...basicConfig,
            products: getProductsTR(isStakingAvailable),
            exchange: exchange_global,
            defi: defi_tr,
            eco: eco_global,
            company: company_tr,
            company_desktop: company_desktop_tr,
            products_desktop: getProductsDesktopTR(isStakingAvailable),
            // NOTE language list is different on TR site
            languages: trSiteLanguages,
            learn: learn_tr,
            learn_desktop: learn_desktop_tr,
            isExchange: false,
            isEco: false,
            isShowLogoFlag: 'TR',
            isShowRewards: true,
        };
    }
    if (region === RegionsEnum.FR) {
        return {
            ...basicConfig,
            products: getProductsFR(isStakingAvailable, isPrimeAccess),
            exchange: exchange_global,
            defi: defi_fr,
            eco: eco_fr,
            company: company_fr,
            company_desktop: company_desktop_fr,
            products_desktop: getProductsDesktopFR(isStakingAvailable, isPrimeAccess),
            // NOTE language list is different on FR site
            languages: frSiteLanguages,
            learn: learn_fr,
            learn_desktop: learn_desktop_fr,
            isExchange: false,
            isShowLogoFlag: 'FR',
            isShowRewards: true,
            isShowNFT: false,
        };
    }
    if (region === RegionsEnum.CA) {
        return {
            ...basicConfig,
            languages: caSiteLanguages,
            products: getProductsCA(isPrimeAccess),
            exchange: exchange_ca,
            defi: defi_global,
            eco: eco_ca,
            company: company_ca,
            company_desktop: company_desktop_ca,
            products_desktop: getProductsDesktopCA(isPrimeAccess),
            learn: learn_ca,
            learn_desktop: learn_desktop_ca,
            isDefi: false,
            isShowLogoFlag: 'CA',
            isShowRewards: true,
            isShowNFT: false,
        };
    }
    if (region === RegionsEnum.IT) {
        return {
            ...basicConfig,
            products: getProductsIT(isStakingAvailable, isPrimeAccess),
            exchange: exchange_it,
            defi: defi_it,
            eco: eco_global,
            company: company_it,
            company_desktop: company_desktop_it,
            products_desktop: getProductsDesktopIT(isStakingAvailable, isPrimeAccess),
            // NOTE language list is different on IT site
            languages: itSiteLanguages,
            learn: learn_it,
            learn_desktop: learn_desktop_it,
            isEco: false,
            isShowLogoFlag: 'IT',
            isShowRewards: true,
            isShowNFT: false,
        };
    }
    if (region === RegionsEnum.UK) {
        return {
            ...basicConfig,
            products: getProductsUK(isStakingAvailable, isPrimeAccess),
            exchange: exchange_uk,
            defi: defi_uk,
            eco: eco_uk,
            company: company_uk,
            company_desktop: company_desktop_uk,
            products_desktop: getProductsDesktopUK(isStakingAvailable, isPrimeAccess),
            languages: regularSiteLanguages,
            learn: learn_uk,
            learn_desktop: learn_desktop_uk,
            isShowLogoFlag: 'UK',
            isShowBanner: true,
        };
    }
    if (region === RegionsEnum.KR) {
        return {
            ...basicConfig,
            products: products_kr,
            exchange: exchange_global,
            defi: defi_global,
            eco: eco_global,
            company: company_kr,
            company_desktop: company_desktop_kr,
            products_desktop: products_desktop_kr,
            learn: learn_kr,
            learn_desktop: learn_desktop_kr,
            languages: krSiteLanguages,
            isExchange: false,
            isDefi: false,
            isEco: false,
            isShowPrice: false,
            isShowLogoFlag: 'KR',
        };
    }
    return {
        ...basicConfig,
        products: getProductsGlobal(isStakingAvailable, isPrimeAccess, isRewardsAccess),
        exchange: exchange_global,
        defi: defi_global,
        eco: eco_global,
        company: company_global,
        company_desktop: company_desktop_global,
        learn_desktop: learn_desktop_global,
        products_desktop: getProductsDesktopGlobal(isStakingAvailable, isPrimeAccess, isRewardsAccess),
        learn: learn_global,
        isShowRewards: isRewardsAccess,
    };
};

//req from exchange app, should hide some links on header and footer if
//derivatives access is false, this is specifically for UK users
const useDerivativeAccess = (geoCountry) => {
    const [isDerivativeAccess, setDerivativeAccess] = useState(true);
    useEffect(() => {
        let isMounted = true;
        const isEligibleForDerivativeFeature = api.get('crypto.isEligibleForDerivativeFeature');
        if (isEligibleForDerivativeFeature !== undefined) {
            isMounted && setDerivativeAccess(Boolean(isEligibleForDerivativeFeature));
        }
        const isDerivativeAccess = geoCountry !== 'GB' && geoCountry !== 'GBR';
        isMounted && setDerivativeAccess(isDerivativeAccess);
        return () => {
            isMounted = false;
        };
    }, [geoCountry]);
    return isDerivativeAccess;
};

const useUpdatedMenu = (region, products, exchange, defi, products_desktop) => {
    const navContext = useContext(NavFooterContext);
    const isDerivativeAccess = useDerivativeAccess(navContext.geoLocation.geoCountry);
    if (region === RegionsEnum.EEA && !isDerivativeAccess) {
        return {
            products: getProductsUK(true, true),
            products_desktop: getProductsDesktopUK(true, true),
        };
    }
    return {
        products,
        exchange,
        defi,
        products_desktop,
    };
};

const GeneralNavbar = ({ region }) => {
    const { products, isExchange, exchange, isDefi, defi, isEco, eco, company, company_desktop, products_desktop, isShowRewards, isShowNFT, isShowPrice, isShowLanguages, logoHref, languages, learn, learn_desktop, isShowLogoFlag, isShowBanner, isShowRiskWarn, } = useStaticSiteConfig(region);
    const { products: updatedProducts, products_desktop: updatedProductsDesktop, } = useUpdatedMenu(region, products, exchange, defi, products_desktop);
    return (jsx(Navbar, { products: updatedProducts, isExchange: isExchange, exchange: exchange, isDefi: isDefi, defi: defi, isEco: isEco, eco: eco, company: company, company_desktop: company_desktop || [], products_desktop: updatedProductsDesktop, isShowRewards: isShowRewards, isShowNFT: isShowNFT, isShowPrice: isShowPrice, isShowLanguages: isShowLanguages, logoHref: logoHref, languages: languages, learn: learn, learn_desktop: learn_desktop, isShowLogoFlag: isShowLogoFlag, isShowBanner: isShowBanner, isShowRiskWarn: isShowRiskWarn }));
};
const GlobalNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.GLOBAL });
const USNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.US });
const EEANavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.EEA });
const SGNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.SG });
const AUNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.AU });
const BRNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.BR });
const TRNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.TR });
const FRNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.FR });
const CANavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.CA });
const ITNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.IT });
const KRNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.KR });
const UKNavbar = () => jsx(GeneralNavbar, { region: RegionsEnum.UK });

const spaceKeys = [...Array(100).keys()];
const space = spaceKeys.map((i) => i * 8);
spaceKeys.forEach((i) => {
    space[`-${i}`] = -1 * i * 8;
});
space[0.5] = 4;
space[1.5] = 12;
space['-0.5'] = -4;
space['-1.5'] = -12;
const themeConfig = {
    breakpoints: ['768px', '1128px'],
    fonts: {
        general: [
            'Inter',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Helvetica',
            'Arial',
            'sans-serif',
            'Apple Color Emoji',
            'Segoe UI Emoji',
            'Segoe UI Symbol',
        ].join(', '),
    },
    colors: {
        primaryBrightBlue: '#1199FA',
        primaryBrightBlueLightBg: '#0058AA',
        primaryDeepBlack: '#000000',
        primaryPaleWhite: '#F4F4F4',
        primaryPaleWhiteRgb: 'rgb(244, 244, 244, 0.3)',
        secondaryDarkNavy: '#0E213B',
        secondaryDarkNavyAlpha: '#0E213BB3',
        secondaryDarkGrey: '#7D7D7D',
        secondaryLightGrey: '#D1D0D1',
        backgroundDark: '#061121',
        backgroundLight: '#F4F4F4',
        backgroundWhite: '#FFFFFF',
        backgroundDownloadAppDark: '#061B38',
        backgroundDownloadAppLight: '#FFFFFF',
        backgroundCard: '#0E223C',
        backgroundSecurityWhite: '#E7E6E6',
        backgroundSecurityGrey: '#16171C',
        primaryPartnerGrey: '#323C52',
        primaryPartnerBlue: '#00254F',
        secondaryPartnerBlue: '#002F61',
        statusGreen: '#20BCA4',
        statusRed: '#E64B60',
        secondaryDarkButtonHoverBg: 'rgba(255, 255, 255, 0.1)',
        secondaryLightButtonHoverBg: 'rgba(19, 53, 100, 0.1)',
        backgroundBlueGlow: 'radial-gradient(50% 50% at 50% 50%, rgba(65, 148, 236, 0.24) 0%, rgba(65, 148, 236, 0) 100%)',
        // TODO: Confirm with designers about the naming
        moreBlueColor: '#061525',
        cardTableBorder: '#37435380',
    },
    // Multiple of 8
    space,
    sizes: {
        containerWidth: 1128,
        navBarHeight: 92,
        navBarHeightCollapsed: 72,
    },
};

const WrapProvider = ({ lang = 'en', Link, onSearch, langChangeCallback, countryChangeCallback, hasLangCountrySwitch, hasSearchBar, country, geoLocation, site, children, }) => {
    const ChildrenWithLang = () => {
        const { i18n } = useTranslation();
        useEffect(() => {
            i18n.changeLanguage(lang);
        }, [i18n]);
        return jsx(Fragment, { children: children });
    };
    return (jsx(ThemeProvider, { theme: themeConfig, children: jsx(I18nextProvider, { i18n: i18n, children: jsx(OneLinkProvider, { children: jsx(NavFooterProvider, { Link: Link, langChangeCallback: langChangeCallback, countryChangeCallback: countryChangeCallback, hasLangCountrySwitch: hasLangCountrySwitch, hasSearchBar: hasSearchBar, onSearch: onSearch, country: country, geoLocation: geoLocation, site: site, children: jsx(ChildrenWithLang, {}) }) }) }) }));
};
const getCommonComps = ({ hasLangCountrySwitch = true, hasSearchBar = false, lang = 'en', country = RegionsEnum.GLOBAL, geoLocation, Link, site, onSearch, langChangeCallback, countryChangeCallback, }) => {
    let Footer, NavV2;
    switch (country) {
        case RegionsEnum.US:
            NavV2 = USNavbar;
            Footer = USFooter;
            break;
        case RegionsEnum.EEA:
            NavV2 = EEANavbar;
            Footer = EEAFooter;
            break;
        case RegionsEnum.SG:
            NavV2 = SGNavbar;
            Footer = SGFooter;
            break;
        case RegionsEnum.BR:
            NavV2 = BRNavbar;
            Footer = BRFooter;
            break;
        case RegionsEnum.AU:
            NavV2 = AUNavbar;
            Footer = AUFooter;
            break;
        case RegionsEnum.TR:
            NavV2 = TRNavbar;
            Footer = TRFooter;
            break;
        case RegionsEnum.FR:
            NavV2 = FRNavbar;
            Footer = FRFooter;
            break;
        case RegionsEnum.CA:
            NavV2 = CANavbar;
            Footer = CAFooter;
            break;
        case RegionsEnum.IT:
            NavV2 = ITNavbar;
            Footer = ITFooter;
            break;
        case RegionsEnum.KR:
            NavV2 = KRNavbar;
            Footer = KRFooter;
            break;
        case RegionsEnum.UK:
            NavV2 = UKNavbar;
            Footer = UKFooter;
            break;
        default:
            NavV2 = GlobalNavbar;
            Footer = GlobalFooter;
            break;
    }
    return {
        Nav: () => (jsx(WrapProvider, { lang: lang, Link: Link, onSearch: onSearch, langChangeCallback: langChangeCallback, countryChangeCallback: countryChangeCallback, hasLangCountrySwitch: hasLangCountrySwitch, hasSearchBar: hasSearchBar, country: country, geoLocation: geoLocation, site: site, children: jsx(NavV2, {}) })),
        Footer: () => (jsx(WrapProvider, { lang: lang, Link: Link, country: country, geoLocation: geoLocation, site: site, children: jsx(Footer, {}) })),
    };
};
const useNavFooter = (props) => {
    const geoLocation = useGeoLocation();
    return useMemo(() => {
        return getCommonComps({
            country: props.country,
            geoLocation: props.geoLocation ?? geoLocation,
            lang: props.lang,
            hasLangCountrySwitch: props.hasLangCountrySwitch,
            hasSearchBar: props.hasSearchBar,
            Link: props.Link,
            onSearch: props.onSearch,
            langChangeCallback: props.langChangeCallback,
            countryChangeCallback: props.countryChangeCallback,
            site: props.site,
        });
    }, [
        props.country,
        props.geoLocation,
        props.lang,
        props.hasLangCountrySwitch,
        props.hasSearchBar,
        props.Link,
        props.onSearch,
        props.langChangeCallback,
        props.countryChangeCallback,
        props.site,
        geoLocation,
    ]);
};

export { RegionsEnum, Site, getUsersRegion, i18n as navFooterI18n, languages as navFooterLangs, regionCookieName, useNavFooter, useUserRegion, useUserRegionCH };
